module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }, [_vm._v("Introduction")])]), _c('a', {
    attrs: {
      "id": "p1"
    }
  }, [_c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-1"
    }
  }, [_vm._v("I. T"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ITLE")])])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }, [_vm._v("The English name “Book of Proverbs” is a translation of "), _c('em', [_vm._v("Liber Proverbiorum")]), _vm._v(", its title in the Latin Vulgate, translated by Jerome (ca. A.D. 400). Its title in the Hebrew Bible is "), _c('em', [_vm._v("mišlê")]), _vm._v(" (“Proverbs”),"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-1",
      "id": "footnote-1934-1-backlink"
    }
  }, [_vm._v("1")]), _vm._v(" the first word of the book. Proverbs belongs to the third division of the Hebrew canon: the Writings. English Bibles, however, follow the order of the LXX and place it among the Poetical Books, in between Psalms and Ecclesiastes.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-2"
    }
  }, [_vm._v("II. T"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("EXTS")]), _vm._v(" "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("AND")]), _vm._v(" V"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ERSIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Most English translations of the Proverbs are based on the Masoretic Text (MT). According to the common-sense rules for establishing an original text, it is superior to the other versions even though the earliest extant manuscripts of the MT date to ca. A.D. 1000, more than 500 years after the earliest extant Greek texts. Both the MT and the LXX follow the same arrangement of content up to Prov. 24:22. After that, they significantly differ, as the following diagram shows:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-center"
  }, [_c('strong', [_vm._v("MT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-center"
  }, [_c('strong', [_vm._v("LXX")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1:1–24:22")])]), _vm._v(" "), _c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1:1–24:22")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("24:23–34 (Further sayings of the wise)")])]), _vm._v(" "), _c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("30:1–14 (Sayings of Agur)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("25:1–29:27 (Sayings gathered by Hezekiah’s men)")])]), _vm._v(" "), _c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("24:23–34 (Further sayings of the wise)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("30:1–33 (All the sayings of Agur)")])]), _vm._v(" "), _c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("30:15–33 (Agur’s numerical sayings)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "p2"
    }
  }, [_vm._v("31:1–31 (On being a noble king and finding a valiant wife)")])])]), _vm._v(" "), _c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("31:1–9 (On being a noble king)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col47"
  }), _vm._v(" "), _c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("25:1–29:27 (Sayings gathered by Hezekiah’s men)")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("31:10–31 (On finding a valiant wife)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("H. C. Washington argues convincingly that the structure of the LXX aims to give the whole book of Proverbs the illusion of being authored by Solomon."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-2",
      "id": "footnote-1934-2-backlink"
    }
  }, [_vm._v("2")])]), _vm._v(" It does so by suppressing the authorship of Agur (30:1) and Lemuel (31:1), rendering “the words of Agur” as “fear my words, son” and “the sayings of Lemuel, a king” as “my words have been spoken by God”; and by interlacing their sayings among “the sayings of the wise,” which it attributes to Solomon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There are also scores of additions, omissions, transpositions, and other differences between the LXX and the MT. Some are accidental, others deliberate. James Barr, a Scottish liberal Old Testament scholar, convincingly argues that the LXX translator sometimes so creatively renders proverbs that they become “an original composition rather than a rendering.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-3",
      "id": "footnote-1934-3-backlink"
    }
  }, [_vm._v("3")])]), _vm._v(" Nevertheless, the LXX occasionally preserves the original readings. Moreover, since centuries separate Solomon (ca. 950 B.C.) from the earliest extant Hebrew manuscripts and ancient versions, the extant text should be emended according to accredited principles of textual criticism to establish the original text."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-4",
      "id": "footnote-1934-4-backlink"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-3"
    }
  }, [_vm._v("III. S"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TRUCTURE")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Proverbs contains six headings naming the genre and authorship of distinct collections within the book (1:1; 10:1; 24:23; 25:1; 30:1, 31:1). No heading occurs in 22:17, but the distinctive form of these “thirty sayings of the wise” in 22:17–24:22, including its own preamble, fully justifies recognizing it as a distinct collection. Thus, the book of Proverbs consists of seven collections.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-1"
    }
  }, [_vm._v("Collection I (1:1–9:18)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This collection consists of three subsections: Title and Preamble (1:1–7), Prologue (1:8–8:36), and Epilogue (9:1–18). The Title (1:1) identifies the author "), _c('a', {
    attrs: {
      "id": "p3"
    }
  }, [_vm._v("(Solomon) and the genre (proverbs); the Preamble identifies its purpose (1:2–6), its addressees (youths, both uncommitted and wise), and the theological foundation of the book (“the fear of "), _c('em', [_vm._v("I AM")]), _vm._v(",”"), _c('em'), _vm._v(" 1:7). The Prologue consists of ten lectures by a fictional father and mother to their son and two sermons by Woman Wisdom to uncommitted youths. The Epilogue features metaphorical invitations by Woman Wisdom and Woman Folly to uncommitted youths to enter their houses of life and death respectively and feast on their life-giving or death-dealing food.")])]), _c('a', {
    attrs: {
      "id": "p3"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p3"
    }
  }, [_vm._v("Collection I differs markedly from the other collections. Whereas the other collections consist mainly of aphorisms (or epigrams: terse and witty statements of truth), its lectures and sermons are extended encomiums to wisdom to motivate the son to embrace the proverbs and sayings"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-5",
      "id": "footnote-1934-5-backlink"
    }
  }, [_vm._v("5")]), _vm._v(" in the following collections. Moreover, as Brevard Childs observes, chapters 1–9 function as “the ‘hermeneutical guide’ for understanding the rest of the book.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-6",
      "id": "footnote-1934-6-backlink"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-2"
    }
  }, [_vm._v("Collection II (10:1–22:16)")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The heading “The proverbs of Solomon” in 10:1a and the marked change from lengthy, unified lectures to aphorisms sharply separate Collection II from Collection I. Its one verse epigrams consist mainly of bicolons (the two halves, or versets, of a verse)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-7",
      "id": "footnote-1934-7-backlink"
    }
  }, [_vm._v("7")])]), _vm._v(" Scholars debate whether these aphorisms are a haphazard collection or are meaningfully grouped into larger clusters."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-8",
      "id": "footnote-1934-8-backlink"
    }
  }, [_vm._v("8")])]), _vm._v(" At the least, they are often associated with one another by sound and sense and occur in pairs. We seek to interpret the proverbs individually first and, where appropriate, within a larger meaningful cluster.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This collection is commonly divided into sections A (10:1–15:33) and B (16:1–22:17). However, 15:30–33 is better analyzed as a prologue to section B. The proverbs of section A are mostly antithetic while those of section "), _c('a', {
    attrs: {
      "id": "p4"
    }
  }, [_vm._v("B are mostly synthetic and show a much greater concern for the king and future functionaries at the royal court.")])]), _c('a', {
    attrs: {
      "id": "p4"
    }
  }, [_c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-3"
    }
  }, [_vm._v("Collection III (22:17–24:22)")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Collection III is commonly referred to as the “Thirty Sayings of the Wise.” Its own preamble (22:17–21) debatably refers to thirty sayings (22:20). Its preamble and especially its first ten sayings have striking similarities with the thirty sayings of the Egyptian "), _c('em', [_vm._v("Instruction of Amenemope")]), _vm._v(" (ca. 1186–1069 B.C.) as selected examples in the following table show:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-center"
  }, [_c('strong', [_vm._v("Instruction of Amenemope")])])]), _vm._v(" "), _c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-center"
  }, [_c('strong', [_vm._v("Proverbs")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("“Look to these thirty chapters; they inform, they educate.” (30.7)")])]), _vm._v(" "), _c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("“Have I not written for you thirty sayings of advice and knowledge … ?” (22:20)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("“Guard yourself from robbing the poor, from being violent to the weak.” (4.4–5)")])]), _vm._v(" "), _c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("“Do not rob poor people because they are poor and do not crush the afflicted in the gate.” (22:22)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("“As for the scribe who is experienced in his office, he will find himself worthy to be a courtier.” (22.16–17)")])]), _vm._v(" "), _c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("“Do you see people who are skillful in their commission? They will present themselves before kings.” (22:29)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("“They [riches] made themselves wings like geese and flew away to the sky.” (10.4–5)")])]), _vm._v(" "), _c('td', {
    staticClass: "col47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("“Will you let your eyes glance at riches? [If you do], they are not. Surely, without question, they will make a set of wings for themselves; like an eagle, they will fly toward the heavens.” (23:5)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Solomon "), _c('em', [_vm._v("adopted")]), _vm._v(" from pagan cultures the wise sayings informed by God’s common grace and "), _c('em', [_vm._v("adapted")]), _vm._v(" them to Israel’s faith in "), _c('em', [_vm._v("I AM")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The style of Collection III differs from that of Collection II. Gone are the short, pithy epigrams of Collection II. In their place are more flowing shorter sayings, often in pairs consisting of admonition and motivating reason.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-4"
    }
  }, [_vm._v("Collection IV (24:23–34)")])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "p4"
    }
  }, [_vm._v("The heading of this short collection identifies its genre and authors: “These also are sayings of the wise.” For the collection’s alternating structure, see ")]), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p1"
    }
  }, [_vm._v("p. 1")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p5"
    }
  }, [_vm._v("The similarity between its last two verses (24:33–34) and 6:10–11 shows how the same material can be used in different contexts.")])]), _c('a', {
    attrs: {
      "id": "p5"
    }
  }, [_c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-5"
    }
  }, [_vm._v("Collection V (25:1–29:27)")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "p5"
    }
  }, [_vm._v("The heading (“These also are proverbs of Solomon, which the men of Hezekiah the king of Judah copied and collected” [ca. 700 B.C.]) resembles the short aphorisms of Collection II. The heading shows that the proverbs of Solomon were still open to additions more than two centuries after Solomon. This collection consists of two clusters: Va (chs. 25–27) and Vb (chs. 28–29). Va virtually lacks proverbs mentioning "), _c('em', [_vm._v("I AM")]), _vm._v(" and commonly uses similes and metaphors, while Vb focuses on "), _c('em', [_vm._v("I AM")]), _vm._v(","), _c('em'), _vm._v(" rearing, and rulership. Raymond Van Leeuwen argues convincingly that Va consists of meaningful groupings: 25:2–27; 26:1–12; 26:13–16; and 26:17–28."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-9",
      "id": "footnote-1934-9-backlink"
    }
  }, [_vm._v("9")]), _vm._v(" Bruce Malchow argues that Vb has a unique structure to develop its main theme: to wit, the education of young rulers."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-10",
      "id": "footnote-1934-10-backlink"
    }
  }, [_vm._v("10")])]), _vm._v(" A long poem (27:23–27) functions as a janus (see "), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p14"
    }
  }, [_vm._v("p. 14")]), _vm._v(") linking the two clusters.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-6"
    }
  }, [_vm._v("Collection VI (30:1–33)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("An editorial prose heading (“The sayings of Agur son of Jakeh. An oracle.”) marks off Collection VI. Many scholars deny the unity of this collection, but we will argue its sayings are united structurally and thematically (see "), _c('span', {
    attrs: {
      "href": "#/014_Chapter06#p411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pp. 411–12")]), _vm._v(").")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-7"
    }
  }, [_vm._v("Collection VII (31:1–31)")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("“The sayings of Lemuel, a king—an oracle that his mother taught him” contains two distinct poems: the first a poem on the noble king (vv. 2–9) and the second an acrostic on the noble wife (vv. 10–31). Many scholars attribute only the first poem to King Lemuel, but we will argue with K. Kitchen that the heading pertains to both poems (see "), _c('span', {
    attrs: {
      "href": "#/015_Chapter07#p426",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 426")]), _vm._v(").")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-4"
    }
  }, [_vm._v("IV. A"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("UTHORSHIP")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The headings in Proverbs name four authors: Solomon (Collections I and II), “men of Hezekiah” who collected and edited some of Solomon’s proverbs "), _c('a', {
    attrs: {
      "id": "p6"
    }
  }, [_vm._v("(Collection V), Agur (Collection VI), and King Lemuel (Collection VII). Collection III and IV, identified as “sayings of the wise,” were probably adopted, adapted and appended by Solomon. If so, Solomon authored Collections I–IV (chs. 1–24), and other editors collected his proverbs in Collection V (chs. 25–29). In other words, Solomon’s fingerprint can be found in all but the last two collections.")])]), _c('a', {
    attrs: {
      "id": "p6"
    }
  }, [_c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-8"
    }
  }, [_vm._v("A. Solomon")])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "p6"
    }
  }, [_vm._v("Most scholars agree with the attribution of Collections V, VI, and VII to Hezekiah, Agur, and Lemuel respectively, but they inconsistently deny the Solomonic authorship of Collections I and II. Some grant that a small nucleus of Solomon’s proverbs are preserved in these collections. We contend, however, that the book’s claim of Solomon’s authorship should be taken at face value, although it’s possible some proverbs were reshaped by later editors, even as compositions by English poets have been."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-11",
      "id": "footnote-1934-11-backlink"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Old Testament claims Solomon was very wise and authored many proverbs (1 Kgs. 3:5–12 [= 2 Chr. 1:7–12]; 4:29–34; 5:7, 12; 10:1–12 [= 2 Chr. 9:1–9]; 11:41), and the New Testament accepts the historicity of these narratives (Matt. 6:29 [= Lk. 12:27]; 12:42 [= Lk. 11:31]; Acts 7:47). Similarities in the structure and content of Proverbs to comparable instructional literature from Egypt, Mesopotamia, and the Levant dating from the third millennium B.C. to Greco-Roman times substantiate the plain sense of the headings in Proverbs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("According to Egyptologist Kenneth Kitchen, the wisdom literature of Egypt exhibits two structures, which he labels type A and type B. Type A has a formal authorial title followed immediately by the main body. Type B has a formal authorial title followed by a prologue and then the main body, which may also contain short subtitles. The two types occur simultaneously and in roughly equal proportion from the third millennium B.C. to the Greco-Roman period, except that type A is unattested in the early second century B.C."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-12",
      "id": "footnote-1934-12-backlink"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The collections of Proverbs fall into either of these types. Collections IV–VII are like type A, while Collections I–II, consisting of author (1:1) + prologue (1:8–9:18) + main body (10:1–22:16) with terse subtitle (10:1), and III, "), _c('a', {
    attrs: {
      "id": "p7"
    }
  }, [_vm._v("consisting of prologue (22:17–21) and main body (22:22–24:22) are essentially like type B. This comparative empirical evidence supports, but doesn’t prove, the biblical claim.")])]), _c('a', {
    attrs: {
      "id": "p7"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p7"
    }
  }, [_vm._v("Other correlations between Solomon and Egypt support the claims of Solomonic authorship. In 1922, E. A. Wallis Budge published what came to be known as "), _c('em', [_vm._v("The Instruction of Amenemope")]), _vm._v(","), _c('em'), _vm._v(" which is from about the time of Solomon."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-13",
      "id": "footnote-1934-13-backlink"
    }
  }, [_vm._v("13")]), _vm._v(" Its teachings, as noted above, resemble those of Collection III, further substantiating Solomon’s connection to Prov. 22:17–24:22 as author or compiler. In 1966, Christa Kayatz noted many similarities in form and motifs between Proverbs 1–9 and Egyptian instructional wisdom, leading her toward a preexilic dating of Collection I."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-14",
      "id": "footnote-1934-14-backlink"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The similarities between the Solomonic proverbs and Egyptian wisdom are unsurprising given that Solomon married an Egyptian princess (1 Kgs. 3:1) and modeled his administration on that of Egypt. Scribes in Israel’s courts must have been fluent in several languages, including Egyptian. Moreover, one can easily imagine the brilliant Solomon learning Egyptian from schoolboy texts, which consisted of instruction literature, in his preparation to head Israel’s administration.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Solomonic authorship is also supported by linguistic evidence. Proverbs teems with Canaanitisms"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-15",
      "id": "footnote-1934-15-backlink"
    }
  }, [_vm._v("15")])]), _vm._v(" and makes use of Ugaritic (ca. 1400 B.C.). This is consistent with the Solomonic era."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-16",
      "id": "footnote-1934-16-backlink"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The attributions in Proverbs to “Solomon son of David, king of Israel” (1:1; cf. 10:1), to “King Hezekiah” (25:1), and to “King Lemuel” (31:1), all royal figures, match the attributions of much ANE wisdom literature to royalty: in Egypt, for example, Khety I (ca. 2100 B.C.), Merikare (ca. 2000 B.C.), and Amenemhat I (ca. 1900 B.C.). The limited evidence from Mesopotamia also associates its wisdom with the legendary Sumerian king Shuruppak. The Aramaic collection of proverbial sayings is attributed to Ahiqar, a senior advisor to the Assyrian kings Sennacherib and Esarhaddon. In sum, the evidence from the ancient Near East indicates that wisdom literature is typically associated with a court setting, and a court setting is opaquely present throughout Proverbs. Of all Israelite royal figures, Solomon best fits this setting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("David M. Carr cautiously suggests that parts of Proverbs “have the best claim to being datable … to the time of David and Solomon.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-17",
      "id": "footnote-1934-17-backlink"
    }
  }, [_vm._v("17")])]), _vm._v(" In a subsequent monograph, he argues that explicit and implicit historical references in Proverbs, such as attribution of major collections to Solomon, should be taken prima facie: “Perhaps we should start with the assumption that substantial portions of Proverbs date to the early preexilic period.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-18",
      "id": "footnote-1934-18-backlink"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In short, there is indisputable evidence that supports the Bible’s claim that Solomon authored the bulk of Proverbs and no evidence that refutes it."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-19",
      "id": "footnote-1934-19-backlink"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To a scroll containing Collections I and II, Solomon probably appended the Thirty Sayings of the Wise (Collection III). Its author speaks of himself in the first person: “I cause you to know,” (22:19) and “have I not written for you thirty sayings” (22:20). Solomon is the only named antecedent of “I.” To this collection, he appended Collection IV, introducing it with: “these also are sayings of the wise” (24:23), which assumes the existence of Collection III. If Collections III and IV are anonymous, they are unique.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-9"
    }
  }, [_vm._v("B. Men of Hezekiah")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("To the scroll of proverbs by Solomon (Collections I and II) and of sayings of the wise that Solomon appended to it (Collections III and IV), the men of Hezekiah king of Judah compiled “more proverbs of Solomon” (Collection V). When Collection V was added to the Proverbs is unknown. Although Solomon composed the proverbs of Collection V, their compilation is an act of authorship.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-10"
    }
  }, [_c('a', {
    attrs: {
      "id": "p9"
    }
  }, [_vm._v("C. Agur and Lemuel")])]), _c('a', {
    attrs: {
      "id": "p9"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("Agur son of Jakeh, unknown and undated, is not a king. He was likely a court official, since he supports dynastic succession and strong kingship (30:22, 31) and his son Ithiel seems to be a budding court official (30:32–33). Lemuel, also unknown, is referred to as a king (31:1), which is in keeping with the royal context of wisdom literature.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-11"
    }
  }, [_vm._v("D. The Final Editor")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("An anonymous final editor must have appended at the end of an expanding scroll the Sayings of Agur and Sayings of King Lemuel. The final editor also probably added the preamble (1:1–7) since it refers to the substance of the book as proverbs (of Solomon) and sayings of the wise (1:6). He may have allowed the original heading, “proverbs of Solomon” (1:1), to stand as the title to the whole book. This follows the practice of other biblical books. The editor who compiled the book of Job names Job as the author (cf. 31:40b) even though the book contains speeches from Job’s friends. Similarly, the editor of Psalms names David as the author (72:20) of a collection that includes psalms by the sons of Korah and by Asaph.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This final editor—the real author of Proverbs but not of its collections—probably lived during the Persian period (ca. 540 B.C. – 322 B.C.) or in the Hellenistic era and expanded and updated the book to its present form. This inspired editor mediated the proverbs and sayings, originally addressed to historical persons such as Ithiel, to the universal covenant community of all ages. More specifically, according to the book’s preamble, it is addressed to Israel’s youths (1:4) and the wise (1:5, 8) to enable them to attain wisdom and to safeguard them against pagan worldviews in any age. The Holy Spirit, through the church, then sanctioned the work as canonical.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-5"
    }
  }, [_vm._v("V. A"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("NCIENT")]), _vm._v(" N"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("EAR")]), _vm._v(" E"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ASTERN")]), _vm._v(" W"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ISDOM")]), _vm._v(" L"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ITERATURE")])])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "p9"
    }
  }, [_vm._v("Sound interpretation requires that words be interpreted in light of their historical context. The comparative ANE wisdom literature sheds light on Proverbs’s authorship, literary forms, arrangement, textual transmission, philology, and figures of speech and also profiles its theology. For example, in Egypt, the number 30 was considered holy and symbolizes a complete and perfect teaching. Probably, Solomon meant the same in Prov. 22:20. In Prov. 24:12, "), _c('em', [_vm._v("I AM")]), _vm._v(" is represented as the one “who weighs the heart” (NIV). This imagery can be traced ")]), _c('a', {
    attrs: {
      "id": "p10"
    }
  }, [_vm._v("to the Egyptian god Thoth, who is represented as standing at the judgment of the dead beside the scales with the human heart."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-20",
      "id": "footnote-1934-20-backlink"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-6"
    }
  }, [_vm._v("VI. P"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("OETRY")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-12"
    }
  }, [_vm._v("A. Characteristics of Biblical Poetry")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Apart from the prose headings (1:1; 10:1a; 24:23a; 25:1; 30:1; 31:1), Proverbs is written in poetry. Three elements characterize biblical poetry: terseness, imagery, and parallelism.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-1"
    }
  }, [_vm._v("1. Terseness")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("A poet states things in as few words as possible."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-21",
      "id": "footnote-1934-21-backlink"
    }
  }, [_vm._v("21")])]), _vm._v(" Terseness is achieved within the poetic line by commonly omitting the definite article, conjunctions, and relative pronouns and occasionally gapping whole words or phrases. Terseness between the lines is achieved by the omission of conjunctions and logical particles such as “and” or “therefore.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("For Proverbs, terseness is the hallmark of its lines. The sage teaches truth through aphorisms that are also epigrams. Consequently, a single proverb may not express the whole truth about a subject; other proverbs are needed to complete the picture."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-22",
      "id": "footnote-1934-22-backlink"
    }
  }, [_vm._v("22")])]), _vm._v(" For example, “Dedicate youth according to what their way dictates; even when they become old, they will not depart from it” (22:6) expresses the truth (or promise) that parenting has lifelong effects on a youth, but it does not exhaust the biblical truth about child-raising. Rather, it is one of many components that must be fitted together with other components in order to comprehend the comprehensive, confused pattern of real life. A failure to recognize "), _c('em', [_vm._v("terseness")]), _vm._v(" and how it asserts truth baldly has led to many errors in interpreting Proverbs.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-2"
    }
  }, [_vm._v("2. Imagery or Figures")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Proverbs is filled with figures of speech (e.g., simile, metaphor, metonymy, etc.), and even sustained figures—especially in the Prologue. In addition to being evocative, imagery contributes to terseness by enabling the author to communicate much with little. Familiarity with figures of speech is an essential part of the propaedeutic for interpreting any poem.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-3"
    }
  }, [_vm._v("3. Parallelism")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Whereas English poetry is marked by a sustained meter and rhyme, Hebrew poetry is marked by parallelism. Parallelism occurs when a line of poetry is divided into half lines—what we call versets—with each corresponding to the other in some way."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-23",
      "id": "footnote-1934-23-backlink"
    }
  }, [_vm._v("23")])]), _vm._v(" The two versets together constitute a bicolon. Prov. 15:4 is a typical bicolon:")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "struct"
  }, [_vm._v("Verset A: The soothing tongue is a tree of life,")]), _vm._v(" "), _c('p', {
    staticClass: "struct"
  }, [_vm._v("Verset B: but perversity in it fractures the spirit.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("In this example, the bicolon consists of two versets, which we designate verset A (or 15:4a) and verset B (or 15:4b).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Semantically, verset B both corresponds in thought with verset A and in some way advances or escalates it, often specifying or intensifying it. The versets commonly move from general to specific, from abstract to concrete, or from less intense to more intense."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-24",
      "id": "footnote-1934-24-backlink"
    }
  }, [_vm._v("24")])]), _vm._v(" Traditionally, the parallelism in the versets has been classified into three main types:")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "id": "p12"
    }
  }, [_vm._v("Synonymous—Verset B repeats the same thought as verset A in different words:")])])]), _c('a', {
    attrs: {
      "id": "p12"
    }
  }, [_c('p', {
    staticClass: "struct2"
  }, [_vm._v("Verset A: Let a stranger and not your own mouth praise you,")]), _vm._v(" "), _c('p', {
    staticClass: "struct2"
  }, [_vm._v("Verset B: an outsider, and let not your own lips praise you. (27:2)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Antithetical—The thought of verset B is opposed to that of verset A. Usually the contrast is marked by “but”:")])]), _vm._v(" "), _c('p', {
    staticClass: "struct2"
  }, [_vm._v("Verset A: A poor person is made with a slack hand,")]), _vm._v(" "), _c('p', {
    staticClass: "struct2"
  }, [_vm._v("Verset B: but the hand of diligent people brings wealth. (10:4)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Synthetic—Verset B expands the thought of verset A:")])]), _vm._v(" "), _c('p', {
    staticClass: "struct2"
  }, [_vm._v("Verset A: Commit to "), _c('em', [_vm._v("I AM")]), _vm._v(" your works")]), _vm._v(" "), _c('p', {
    staticClass: "struct2"
  }, [_vm._v("Verset B: and your thoughts will be established. (16:3)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("Two subtypes are also worth noting:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Better-Than Proverbs—A subtype of antithetical parallelism, this type provides two negative situations in its versets and calls the reader to choose the better of the two, which is usually stated in verset A:")])]), _vm._v(" "), _c('p', {
    staticClass: "struct2"
  }, [_vm._v("Verset A: Better a little with the fear of "), _c('em', [_vm._v("I AM")])]), _vm._v(" "), _c('p', {
    staticClass: "struct2"
  }, [_vm._v("Verset B: than great treasure and turmoil with it. (15:16)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Comparative Proverbs—In this subtype of synthetic parallelism, the reader is called to compare two situations to note what is similar in them:")])]), _vm._v(" "), _c('p', {
    staticClass: "struct2"
  }, [_vm._v("Verset A: [Like] a gold ring in a snout of a pig")]), _vm._v(" "), _c('p', {
    staticClass: "struct2"
  }, [_vm._v("Verset B: [is] a beautiful woman who turns aside from discretion. (11:22)")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The above classifications of parallelism are not hard and fast, and no complete taxonomy of parallelism is possible since the variations are too many.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sometimes two bicola stand in parallel, forming a quatrain. Consider Prov. 23:4–5 (NIV):")])]), _c('p', {
    staticClass: "pl1"
  }, [_c('a', {
    attrs: {
      "id": "p12"
    }
  }), _c('a', {
    attrs: {
      "id": "p13"
    }
  }, [_vm._v("Do not wear yourself out to get rich;")])]), _c('a', {
    attrs: {
      "id": "p13"
    }
  }, [_c('p', {
    staticClass: "pl2"
  }, [_vm._v("do not trust your own cleverness.")]), _vm._v(" "), _c('p', {
    staticClass: "pl"
  }, [_vm._v("Cast but a glance at riches, and they are gone,")]), _vm._v(" "), _c('p', {
    staticClass: "pl2b"
  }, [_vm._v("for they will surely sprout wings and fly off to the sky like an eagle.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Semantically, not formally, v. 5 gives the reason for heeding the admonition in v. 4, albeit each verse is a saying in its own right.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-13"
    }
  }, [_vm._v("B. Poetics")])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "p13"
    }
  }, [_vm._v("Through the study of poetics, connections between the verses are discerned. Biblical sages used a variety of literary techniques to give their compositions coherence and unity and to protect the vulnerable epigrams against misinterpretation. According to Adele Berlin, poetics is “an inductive science that seeks to abstract the general principles of literature from many different manifestations of those principles as they occur in actual literary texts.” Its essential aim is not “to elicit meaning of any given text” but “to find the building blocks of literature and the rules by which they are assembled.” Thus, “poetics is to literature as linguistics is to language.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-25",
      "id": "footnote-1934-25-backlink"
    }
  }, [_vm._v("25")]), _vm._v(" If linguistics is the science of language (a study of the meaning of words and the rules that govern their interrelationship), then poetics is the science of literature (a study of how basic components of writing interrelate to create meaning). In other words, poetics is a grammar of literature. Just as we need grammar to make sense of a language, we need poetics to make sense of a literary text. To know what a text means, we must first know how it means.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In a poem, the verses are usually connected. For example, in Prov. 2, the conditional clauses introduced by “if” in vv. 1–4 are followed by the consequential clauses introduced by “then” in vv. 5 and 9. Two closely connected verses (or bicola) are called a "), _c('em', [_vm._v("quatrain")]), _vm._v(", a smaller collection of verses a "), _c('em', [_vm._v("strophe")]), _vm._v(", and a larger division a "), _c('em', [_vm._v("stanza")]), _vm._v(". The twelve lectures and sermons of the Prologue are all poems.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In contrast to the poems, the proverbs of Solomon and the sayings of the wise are mostly collections of individual proverbs and sayings, expressing a complete thought by themselves and only secondarily to be interpreted in connection with other proverbs or sayings. The connections between the units are less obvious, "), _c('a', {
    attrs: {
      "id": "p14"
    }
  }, [_vm._v("creating the impression that they are atomistic and without coherence. However, the study of poetics provides a lens to see unstated connections between them. This means the interpreter must interpret each proverb and saying not only on its own but also in light of the group to which it is connected.")])]), _c('a', {
    attrs: {
      "id": "p14"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Verses are linked by words, syntax, sense, and repetitive phonology. Other literary devices are also used to create connections. A sampling of such devises includes:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Inclusio—Marking off a literary unit by matching the end with the beginning. The preamble to the book (1:2–7) begins and ends with the words “wisdom and instruction” (2a; 7b).")]), _vm._v(" "), _c('li', [_vm._v("Key word (German "), _c('em', [_vm._v("Leitwort")]), _vm._v(")—A word that highlights the unit’s topic. In Prov. 30:18–20, the key word “way” is used to contrast the four ways admired by Agur (30:18–19) with the despicable way of the adulteress.")]), _vm._v(" "), _c('li', [_vm._v("Catchword—A word that stitches the sayings together. Prov. 16:1–9 is connected by the catchword “"), _c('em', [_vm._v("I AM")]), _vm._v("” which occurs in every verse except 8, the second from the end. Prov. 16:10–15 is held together by the catchword “king,” which occurs in every verse except 11, the second from the beginning. Thus, the two units (16:1–9, 10–15) complement each other by respectively trumpeting the themes of God’s sovereign rule and the king’s mediatorial rule.")]), _vm._v(" "), _c('li', [_vm._v("Janus—A transition that looks back to the preceding text and ahead to the proceeding text. Thus, 31:19 is a janus because it functions as a seam transitioning from the valiant wife’s sources of income (vv. 13–18) to her contributions to her household and to the wider community (vv. 20–27).")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("In addition to the techniques listed above, structures of patterning are used to bind proverbs or sayings together around a specific topic or theme that is only discernible when the pattern is recognized. Patterns help to establish the boundaries of a unit. Scholars have recognized a variety of such patterns in Proverbs:")])]), _c('ul', [_c('a', {
    attrs: {
      "id": "p14"
    }
  }), _c('li', [_c('a', {
    attrs: {
      "id": "p14"
    }
  }, [_vm._v("An alternating pattern (A-B::A′-B′) can be described as one wave following another."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-26",
      "id": "footnote-1934-26-backlink"
    }
  }, [_vm._v("26")]), _vm._v(" This pattern requires the reader to compare the parallel elements to discern progression. For example, in 4:5–9, the admonition to get wisdom (A, A′) progresses in the motivation from protection (B) to honor (B′):")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s1"
  }, [_c('a', {
    attrs: {
      "id": "p15"
    }
  }, [_vm._v("A "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Admonition: Get wisdom")])])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("v. 5")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s2"
  }, [_vm._v("B "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Motivation: She will protect her lover")])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("v. 6")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s1"
  }, [_vm._v("A′ "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Admonition: Get wisdom")])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("v. 7")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s2"
  }, [_vm._v("B′ "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Motivation: She will honor her lover")])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("vv. 8–9")])])])])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("A concentric pattern (A-B-C::C′-B′-A′) can be described as the tide coming in and then going back out. This pattern provides a sense of completeness and enables the reader to focus on comparison and contrast. The Prologue (1:8–9:18) may be arranged in a concentric pattern:")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s1"
  }, [_vm._v("A "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Rival invitations of parents and gang to son")])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("1:8–19")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s2"
  }, [_vm._v("B "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Wisdom’s rebuke of uncommitted")])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("1:20–33")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s3"
  }, [_vm._v("C "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Janus: Father’s command to heed teaching as safeguard against evil men and unchaste wife")])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("2:1–22")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s4"
  }, [_vm._v("D "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Father’s command to heed teaching")])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("3:1–4:27")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s4"
  }, [_vm._v("D′ "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Father’s warnings against unchaste wife")])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("5:1–6:35")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s3"
  }, [_vm._v("C′ "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Janus: Father’s warnings against Wisdom’s rival")])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("7:1–27")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s2"
  }, [_vm._v("B′ "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Wisdom’s invitation to uncommitted")])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("8:1–36")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s1"
  }, [_vm._v("A′ "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Rival invitations of Wisdom and Folly to uncommitted")])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("9:1–18")])])])])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("A chiastic pattern (A-B-C-X-C′-B′-A′) has a pivot (X) as the focus of the message. It can be described as the ripples from a rock thrown in a pond."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-27",
      "id": "footnote-1934-27-backlink"
    }
  }, [_vm._v("27")])]), _vm._v(" The five sayings of Prov. 26:6–10 are arranged in a chiastic pattern, as shown by Duane Garrett,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-28",
      "id": "footnote-1934-28-backlink"
    }
  }, [_vm._v("28")])]), _vm._v(" to emphasize the point that honoring a fool is unfitting.")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s1"
  }, [_vm._v("A "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Committing important business to a fool")])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("v. 6")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s2"
  }, [_vm._v("B "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("A proverb in a fool’s mouth")])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("v. 7")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s3"
  }, [_vm._v("X "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Honoring a fool")])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("v. 8")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s2"
  }, [_vm._v("B′ "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("A proverb in a fool’s mouth")])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("v. 9")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "t-s1"
  }, [_vm._v("A′ "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Committing important business to a fool")])])]), _vm._v(" "), _c('td', {
    staticClass: "col25r"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("v. 10")])])])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-7"
    }
  }, [_vm._v("VII. T"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("HE")]), _vm._v(" W"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ISDOM")]), _vm._v(" G"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ENRE")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-14"
    }
  }, [_vm._v("A. What Is Wisdom Literature?")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Understanding the literary genre of a text is essential to properly interpret it. Each genre contains distinctive characteristics that require unique interpretative approaches."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-29",
      "id": "footnote-1934-29-backlink"
    }
  }, [_vm._v("29")])]), _vm._v(" The exact nature and setting of the wisdom literature of the Old Testament is debated. It is often said to be characterized by features such as being humanistic in orientation, international in scope, non-historical in emphasis, eudaemonistic in practice, concerned with a search for order, and instructional in tone. However, what radically distinguishes biblical wisdom literature from other biblical genres is its unique inspiration."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-30",
      "id": "footnote-1934-30-backlink"
    }
  }, [_vm._v("30")])]), _vm._v(" Unlike the visions and dreams given to the prophet, the face-to-face encounter given to Moses, and the poetic imagination given to David, sages gained revelation through keen observations of nature and humanity and their cogitations upon them, which are informed by the fear of "), _c('em', [_vm._v("I AM")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-31",
      "id": "footnote-1934-31-backlink"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This psychology of inspiration is showcased in 24:30–34. After passing the field of a sluggard, which once was a productive and profitable vineyard but under the sluggard’s management has devolved into a weed patch, the sage says: “I saw; I paid attention; I observed; I accepted a lesson” (v. 32), whereupon the sage either coins or cites a proverb (vv. 33–34):")]), _vm._v(" "), _c('p', {
    staticClass: "pl1"
  }, [_vm._v("A little sleep, a little slumber,")]), _vm._v(" "), _c('p', {
    staticClass: "pl2"
  }, [_vm._v("a little folding of the arms to lie down,")]), _vm._v(" "), _c('p', {
    staticClass: "pl"
  }, [_vm._v("and poverty will come on you like a vagrant,")]), _vm._v(" "), _c('p', {
    staticClass: "pl2b"
  }, [_vm._v("and scarcity like an armed man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The sages’ wisdom, however, is not based on natural theology. They view creation and all human activity through the lens of faith in Israel’s "), _c('a', {
    attrs: {
      "id": "p17"
    }
  }, [_vm._v("covenant-keeping God. Without this point of view, observing nature could teach the “law of the survival of the fittest” and not the way of righteousness, leading them to commend the use of power and dominance. When Solomon uses the ant as a paragon of industry and prudence (6:6–11), he ignores the ant’s destructive capabilities. In fact, both Agur (30:1–6) and Job (Job 8:31–41) claim that creation teaches the impossibility of attaining true wisdom apart from special revelation.")])]), _c('a', {
    attrs: {
      "id": "p17"
    }
  }, [_c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-15"
    }
  }, [_vm._v("B. Genres in Proverbs")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-4"
    }
  }, [_vm._v("1. Proverbs")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Proverbs classifies its genre as "), _c('em', [_vm._v("mišlê")]), _vm._v(" (a plural form of "), _c('em', [_vm._v("māšāl")]), _vm._v(", meaning “proverb”). Both in English language and culture and in the book of Proverbs, a proverb is a short, pithy saying. In English, it has popular currency, whereas in Proverbs, it has currency only with those who fear"), _c('em'), _vm._v(" "), _c('em', [_vm._v("I AM")]), _vm._v(". For example, the first proverb (“Treasures gained by wickedness are of no eternal value,” 10:2) is not popular among the masses, since many seek precisely such treasure. Similarly, Wisdom restricts the acceptance of her wisdom “to those who understand” (8:9). Were it popular among the masses, she would not need to stand at the gate of the city pleading her cause (1:20–21; 8:1–3).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p17"
    }
  }, [_vm._v("The verbal root of the noun "), _c('em', [_vm._v("māšāl")]), _vm._v(" may mean “to be like,” in which case the noun would mean “a comparison or analogy [constructed] for the purpose of conveying a model, exemplar, or paradigm.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-32",
      "id": "footnote-1934-32-backlink"
    }
  }, [_vm._v("32")]), _vm._v(" Thus, the purpose of a proverb is to compel the readers or hearers to compare their lives to the truth of the proverb."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-33",
      "id": "footnote-1934-33-backlink"
    }
  }, [_vm._v("33")])]), _vm._v(" Because the proverbs and sayings ask the reader to “see” the connection between the proverb and themselves, they are also called “parables” or “riddles” (1:6).The result depends sometimes on the reader’s particular life situation. For example, in Psalm 49, the proverb ("), _c('em', [_vm._v("māšāl")]), _vm._v(" in v. 4) that a person without understanding “is like” the beasts that perish (vv. 12, 20) will comfort the low and sober the high, warn the rich and console the poor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Although proverbs assert truths, using them without discerning one’s situation can have dire consequences. The proverb “A thornbush in the hand of a drunkard, and a proverb in the mouth of fools” (26:9) is illustrated by Job’s "), _c('a', {
    attrs: {
      "id": "p18"
    }
  }, [_vm._v("friends’ misuse of proverbs (see Job 18:5). R. Van Leeuwen notes, “Users of proverbs must choose from the diverse sayings and admonitions the one that best ‘hits the nail on the head.’ … Proverb use is always situational.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-34",
      "id": "footnote-1934-34-backlink"
    }
  }, [_vm._v("34")]), _vm._v(" A proverb is always true, but it may not be true for a given situation.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-5"
    }
  }, [_vm._v("2. Short Sayings and Long Admonitions")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Proverbs contains two primary literary forms: longer units in admonitory style (Collections I, III–IV) and short aphorisms or epigrams in the third person (Collections II and V), albeit exceptions occur (6:12–19; 31:10–31). The longer, admonitory type is similar to the Egyptian instructions, while the shorter sentence proverbs are similar to those from Mesopotamia. As noted, the epigrammatic proverbs must be qualified by other proverbs (cf. Prov. 14:20–21). Also, the epigrammatic proverbs require more wit to interpret them. Consequently, the Prologue’s longer, clearer, admonitory poems prepare the reader to interpret the more elusive shorter sayings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This distinction, however, can be misleading. Admonitions may seem more instructive and authoritative than the shorter sayings, but the preamble to Proverbs makes clear that all proverbs and sayings are to make youth prudent and the wise wiser (1:4–5). The Prologue refers to both forms as commands and teaching (1:8). Moreover, both forms are authoritative because they are both inspired by God (2:6) and handed down by faithful parents through the generations (4:3–4). They are not based on human traditions nor on common sense.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-16"
    }
  }, [_vm._v("C. Setting")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Two issues concern us here: In what context were proverbs composed, and in what context were they circulated?")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-6"
    }
  }, [_vm._v("1. Setting of Composition")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The attributions of proverbs and sayings to Solomon (1:1; 10:1), the men of Hezekiah (25:1), and King Lemuel (31:1) suggest they were composed in a court setting. Agur (30:1) was probably a court official (see exposition). As argued above (see "), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p4"
    }
  }, [_vm._v("p. 4")]), _vm._v("), the Thirty Sayings of the Wise (22:17) were probably adopted and adapted by Solomon, and he himself probably appended the “further sayings of the wise” (24:23–34). And as noted above (see "), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p7"
    }
  }, [_vm._v("p. 7")]), _vm._v(") the collections of Egyptian instructional literature were composed in court settings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Scholars who reject the book’s attribution to Solomon disagree as to where the book’s sayings were composed. Among the proposed settings, two are worth noting: the folk setting and the school setting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Those who propound a folk setting argue that many of the book’s sayings originate from observations on life by ordinary people functioning in the agricultural sector of society. One reason they prefer this setting is that many of the sayings do not speak directly of the king and are more appropriate to a rural, agricultural context. As for those sayings that do speak directly of the king (and they are a significant number), Whybray explains them as the observations on monarchy by ordinary people."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-35",
      "id": "footnote-1934-35-backlink"
    }
  }, [_vm._v("35")])]), _vm._v(" Fox notes, however, that this conclusion overlooks clues for an urban setting, such as “references to goldsmiths and messengers which have no place in the small village.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-36",
      "id": "footnote-1934-36-backlink"
    }
  }, [_vm._v("36")])]), _vm._v(" Moreover, the content of a proverb does not establish its setting. “Strike while the iron is hot” may not have originated in a blacksmith’s shop any more than “look before you leap” originated at a swimming hole.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Those who propound a school setting argue on the basis that such schools existed in Egypt. However, as Lucas notes, following others, “The fact is there is no unambiguous reference to a wisdom school in Israel until Jesus Ben Sirach’s ‘house of instruction’ in the early second century B.C. (Sir. 51:23).”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-37",
      "id": "footnote-1934-37-backlink"
    }
  }, [_vm._v("37")])]), _vm._v(" Of course, much depends on one’s definition of “school.” If by school one understands a standalone building staffed by professional “teachers,” then the evidence of such schools in ancient Israel is still forthcoming."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-38",
      "id": "footnote-1934-38-backlink"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Although it is hazardous to establish setting by content, many sayings and proverbs unmistakably point to a royal setting. For example, “When you sit "), _c('a', {
    attrs: {
      "id": "p20"
    }
  }, [_vm._v("down to eat with a ruler, mark well what is before you” (23:1) does not pertain to Mr. Everyman. So, given the lack of consensus for another setting and on the basis of the named authors, the analogy of other collections of instructional literature for budding officials, and the content of many sayings, we contend that the sayings of Proverbs originated in a court setting.")])]), _c('a', {
    attrs: {
      "id": "p20"
    }
  }, [_c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-7"
    }
  }, [_vm._v("2. Setting of Dissemination")])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "p20"
    }
  }, [_vm._v("Where were the proverbs disseminated? The references to the father and the mother and their son(s) (e.g., 1:8; 6:20; 10:1) point to the home as the setting for the dissemination of the book’s wisdom. As noted above, ancient Israel had no schools."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-39",
      "id": "footnote-1934-39-backlink"
    }
  }, [_vm._v("39")]), _vm._v(" Moreover, in Egyptian and Mesopotamian wisdom literature, the speaker is almost always a father speaking to his son. Furthermore, the fact that the mother is also mentioned as teaching the son wisdom puts the home setting beyond reasonable doubt (4:3; 6:20; 23:25; 31:1, 26–28; cf. 10:1; 15:20). Carr comments, “It is highly unlikely that female teachers would have taken on the epithet ‘mother’ who were not the actual ‘mother’ of a student, and Proverbs 31:1 even mentions a mother responsible for a given written teaching attributed to King Lemuel.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-40",
      "id": "footnote-1934-40-backlink"
    }
  }, [_vm._v("40")])]), _vm._v(" The home setting is further corroborated in 4:1–9, where the godly family—including grandfather, father, mother, and son—is fictitiously represented as transmitting the family’s spiritual inheritance. Fox finds a strong analogy to the ancient wisdom instructions in the medieval Jewish ethical testament."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-41",
      "id": "footnote-1934-41-backlink"
    }
  }, [_vm._v("41")])]), _vm._v(" Thus, it appears Solomon intended to pass his wisdom to Israel’s youths by putting his proverbs in the mouths of godly parents (1:8–9), even as Moses disseminated the law in the home (cf. Deut. 6:7–9). Wisdom’s call in the public places to the masses (1:20–33; 8:1–31) are fictional and in fact intended for the son, as the conclusion of her address in 8:32–36 shows. Finally, the fact that the book does not name a specific recipient—unlike other ANE wisdom texts—indicates the final editor wished to democratize the book so it would be continually taught in all godly homes.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-8"
    }
  }, [_vm._v("VIII. T"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("HEOLOGY")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-17"
    }
  }, [_vm._v("A. Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("To better understand Proverbs, we step back briefly and consider some of the book’s theological presuppositions and teachings utilizing three of the categories of systematic theology: theology proper (God), anthropology, and soteriology. Under the category of theology proper, we also consider the subcategories of revelation, inspiration, and tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But first, two other theological matters should be dealt with: What is the relationship of Proverbs to the rest of the Old Testament? And how do we explain Proverbs’s relationship to the wisdom literature of the surrounding cultures?")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-8"
    }
  }, [_vm._v("1. The Relationship of Proverbs to the Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Two facts have led to the problem of how to relate Proverbs to the rest of the Old Testament: the book’s lack of reference to the history of Israel and its many similarities with the wisdom literature of the surrounding cultures, especially Egypt. These two facts lead scholars to connect Proverbs more to the international wisdom scene than to the rest of the Old Testament. So how holy is Proverbs? Is it Scripture, or merely an expression of human wisdom like other ancient instructional literature?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In fact, Proverbs has many significant connections with other Old Testament literature."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-42",
      "id": "footnote-1934-42-backlink"
    }
  }, [_vm._v("42")])]), _vm._v(" First, its identification of Solomon as “son of David, king of Israel” (1:1) both locates Proverbs within the flow of Israel’s narrative history and implies its audience is God’s mediatorial “kingdom of priests” (see Exod. 19:6).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Second, Proverbs joins the rest of the Old Testament in calling its audience to “fear "), _c('em', [_vm._v("I AM")]), _vm._v("” ("), _c('em', [_vm._v("yir’at yhwh")]), _vm._v("; Prov. 1:7; cf. Deut. 6:5; Josh. 24:14; Isa. 29:13). The use of God’s personal name, YHWH (“He is,” translated “"), _c('em', [_vm._v("I AM")]), _vm._v("”), in Prov. 1:7 signals his unique covenant relationship with his son, Israel. And the call to fear him pertains to submitting to his revealed will—whether it is revealed in the laws of Moses or in the proverbs of Solomon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Third, the theology of Proverbs refines the theology of Moses and of the prophets. The bottom line for all three—Moses, the prophets, and the sages—is to create a nation that in its theology fears God, in its praxis reflects God’s character by doing righteousness and justice, and in its purpose extends true Israel to the ends of the earth. The law does it through its commandments and stipulations, the prophets, through their oracles, and Solomon through his proverbs."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-43",
      "id": "footnote-1934-43-backlink"
    }
  }, [_vm._v("43")])]), _vm._v(" Derek Kidner notes about Proverbs, “There are details of character small enough to escape the mesh of the law and the broadsides of the prophets, and yet decisive in personal dealings. Proverbs moves in this realm, asking what a person is like to live with, or to employ; how he manages his affairs, his time and himself.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-44",
      "id": "footnote-1934-44-backlink"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The refinement of the Law of Moses by the proverbs of Solomon may be compared to learning to drive a car."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-45",
      "id": "footnote-1934-45-backlink"
    }
  }, [_vm._v("45")])]), _vm._v(" The comprehensive rule “drive carefully” is refined by road signs: “STOP,” “YIELD,” “Speed Limit 35 mph,” and so on. This is further refined by passing a written test and a road test, requiring such knowledge as how far to park from a corner, how to change lanes, and how to merge onto a four-lane highway. Similarly, the comprehensive commandments “love God” and “love your neighbor” (see Deut. 6:5; Lev. 19:18) are refined in the Law of Moses by the Ten Commandments: “You shall have no other gods before me” (Exod. 20:3); “you shall not murder” (Exod. 20:13). And these commandments are further refined in Proverbs: “If those who hate you are hungry, give them food to eat ” (25:21); and “Her husband [rises] and praises her: ‘Many daughters do valiantly, but you surpass them all’” (31:28–29). Thus, if the son obeys Proverbs, he will, "), _c('em', [_vm._v("ipso facto")]), _vm._v(", fulfill the Law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Fourth, Solomon ascribes the same attributes and actions to God as do Moses and the prophets. To all three, God is the Creator (Deut. 10:14; Prov. 1:7; 3:19–20; Isa. 40:28), the just Avenger (Deut. 32:35, 40–41; Prov. 5:21–22; Nah. 1:2), the Sovereign of history (Deut. 4:19; 29:1; Prov. 16:1–9; 19:21; Isa. 45:1), the disciplinary Father (Deut. 8:5; Prov. 3:11–12; Isa. 1:4–6), and the merciful Responder who answers prayer (Deut. 4:29–31; Prov. 15:8, 29; Isa. 56:7)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-46",
      "id": "footnote-1934-46-backlink"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Fifth, Agur’s relationship to the rest of the Old Testament is indicated in Prov. 30:5–6, where Agur cites two Scriptures from the Old Testament. After confessing his despair of finding wisdom and a knowledge he can trust, he "), _c('a', {
    attrs: {
      "id": "p23"
    }
  }, [_vm._v("arrives at an answer in discovering that God has spoken in the Bible, citing Ps. 18:30 in v. 5 and the canonical formula of Deut. 4:2 in v. 6a. Thus, we can extrapolate that his search for knowledge is satisfied in Scripture found in the canon as it was then known to him."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-47",
      "id": "footnote-1934-47-backlink"
    }
  }, [_vm._v("47")]), _vm._v(" In sum, Solomon, Moses, and the prophets speak out of the same worldview, but they express it in different forms: proverbs, laws, and oracles.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-9"
    }
  }, [_vm._v("2. The Relationship of Proverbs to the Wisdom Literature of the Surrounding Cultures")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("But how do we explain and understand the undoubtable similarities in expression and in theology between the inspired book of Proverbs and the non-inspired wisdom of Israel’s neighbors? None doubts that the instruction literature from Egypt’s Old Kingdom (ca. 2686–2181 B.C.) and Middle Kingdom (ca. 1975–1640 B.C.), and from the Ebla and Sumerian collections, predates and so is not dependent on Solomon’s proverbs. The Thirty Sayings of the Wise and The "), _c('em', [_vm._v("Instructions of Amenemope")]), _vm._v(" originate at about the same time and may both depend on a common earlier source.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The first explanation is cultural. The Old Testament is embedded in the culture of the ancient Near East. Hebrew is a Canaanite language, and its forms of literature (e.g., law codes, hymns, and prophecies) are also found in pagan cultures. Thus, its uniqueness is found not in transcending its culture but in its subjection of that culture to the transcendent, living God. It borrows "), _c('em', [_vm._v("and")]), _vm._v(" "), _c('em', [_vm._v("adapts")]), _vm._v(" ideas, language, sayings, laws, and mythological allusions from its neighbors, but purges them of their pagan theology to serve the purposes of "), _c('em', [_vm._v("I AM")]), _vm._v(". This is the case also with Proverbs. Some of its wisdom is borrowed, but all of the borrowed material is brought under the affirmation that it is "), _c('em', [_vm._v("I AM")]), _vm._v(" who is the Creator and Revealer of wisdom. In Prov. 22:17, Solomon states that he has borrowed and adapted the sayings of other wise men but immediately adds, “In order that your trust may be in "), _c('em', [_vm._v("I AM")]), _vm._v(".”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-48",
      "id": "footnote-1934-48-backlink"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The second explanation is theological and rests in the distinction between the concepts of the “fear of "), _c('em', [_vm._v("I AM")]), _vm._v(" ["), _c('em', [_vm._v("yhwh")]), _vm._v("]” and the “fear of God [’"), _c('em', [_vm._v("ĕlōhîm")]), _vm._v("].” The Bible distinguishes between them. The former is seen as unique to Israel and pertains to special revelation, whereas the latter is seen as the general revelation of God to all humans, which is accessible through conscience and the created order."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-49",
      "id": "footnote-1934-49-backlink"
    }
  }, [_vm._v("49")])]), _vm._v(" According to R. N. Whybray, “fear of God” refers “to a standard of moral conduct known and accepted by men in general” and “motivates people to right behavior even when there are no legal codes.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-50",
      "id": "footnote-1934-50-backlink"
    }
  }, [_vm._v("50")])]), _vm._v(" And Yale psychology professor Paul Bloom finds that “at birth, babies are endowed with compassion, with empathy, with the beginnings of a sense of fairness.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-51",
      "id": "footnote-1934-51-backlink"
    }
  }, [_vm._v("51")])]), _vm._v(" Thus, foreign sages such as Amenemope, who possess the “fear of God,” can produce wisdom that agrees in some moral matters with the wisdom of Proverbs. The difference is that in "), _c('em', [_vm._v("Amenemope")]), _vm._v(", God is opaque, a generic being, while in Proverbs he is specifically named as YHWH, the God of Israel.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-18"
    }
  }, [_vm._v("B. God")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-10"
    }
  }, [_vm._v("1. Names of God")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Proverbs refers to God in 100 of its 915 verses—over 10 percent—and, more specifically, eighty-seven times by his covenant-with-Israel name YHWH ("), _c('em', [_vm._v("I AM")]), _vm._v("). In contrast, the name “God” ("), _c('em', [_vm._v("’ĕlōhîm")]), _vm._v(") occurs only five times and signifies God’s eternal might and power over all mortals (cf. Num. 23:19).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-11"
    }
  }, [_vm._v("2. God as Creator")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The concept of creation is mentioned ten times in Proverbs. The citations in Collection I, the Prologue, refer to God’s creation of the world (Prov. 3:19–20; 8:22–31), while those in Solomon’s proverbs (Collections II and V) refer to his creation of human beings (Prov. 14:31; 16:11; 17:5; 20:12; 22:2; 29:13). These references are consistent with the creation theology of the rest of the Bible (e.g., that Israel’s God is the solitary and sovereign Creator), albeit some poems of the Bible may use the terminology, but not the theology, of pagan myths (cf. 3:20; 8:29; 30:4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In 3:19–20, the Hebrew verb used for splitting the primeval waters retains the imagery of battle myths. Unlike the psalmists, who point to "), _c('em', [_vm._v("I AM")]), _vm._v("’s creation and his sustenance of the earth to glorify him (see Ps. 104) or to argue for the steadfastness of the Creator’s laws (see Ps. 93),"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-52",
      "id": "footnote-1934-52-backlink"
    }
  }, [_vm._v("52")])]), _vm._v(" Solomon points to "), _c('a', {
    attrs: {
      "id": "p25"
    }
  }, [_vm._v("God’s wisdom, which enables the world to endure in such a finely balanced manner. The application, then, is that the same wisdom which established a creation that endures is also what is needed, and what is available, to establish a life that will endure. The Creator made humans with eyes and ears in order to grasp wisdom (20:12).")])]), _c('a', {
    attrs: {
      "id": "p25"
    }
  }, [_c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-12"
    }
  }, [_vm._v("3. God as Sovereign, Transcendent, and Immanent")])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "p25"
    }
  }, [_c('em', [_vm._v("I AM")]), _vm._v(" is sovereign. Nothing is hidden from his eyes (5:21; 15:3; 22:12), and nothing operates outside of his will. Even the king’s heart, inscrutable to other humans (25:3), is but a stream of water in "), _c('em', [_vm._v("I AM")]), _vm._v("’s hands that he directs as he sees fit (21:1), meriting him the title King of kings."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-53",
      "id": "footnote-1934-53-backlink"
    }
  }, [_vm._v("53")]), _vm._v(" "), _c('em', [_vm._v("I AM")]), _vm._v(" even rules over chance. Humans may throw a die and call it chance, but it is "), _c('em', [_vm._v("I AM")]), _vm._v(" who determines which way it ends up (16:33). His sovereignty over history means that everything, even the wicked, will be directed to an end appropriate to itself (16:4). He made the scales that the king uses to administer fair weights and measures, and under his king’s administration, no cheat escapes judgment (16:4, 14). The Sovereign created all humans, rich and poor, investing both with dignity and requiring the wealthy to take care of the poor (22:2; 29:13). Whoever mocks the poor reviles "), _c('em', [_vm._v("I AM")]), _vm._v(" since he created the poor in his image (17:5). The human thinks and plans, but the answer of his tongue is from "), _c('em', [_vm._v("I AM")]), _vm._v(", who also establishes his steps (16:1, 9). Thus, the only sensible response for humankind is to commit their ways to "), _c('em', [_vm._v("I AM")]), _vm._v(" (16:3), who searches them out (15:11; 20:27) and blesses or punishes humans for their works and words (3:13, 18; 8:34; 12:14; 19:3; 20:25; 21:16; 24:12; 28:14, 17; 29:23).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("I AM")]), _vm._v("’s sovereignty entails his transcendence. This is seen in his role as Creator; he is not bound by the spatial or temporal limits of his creation. His existence before time contributes to his comprehensive and therefore infallible knowledge—a fact that filled Agur with humility and hope and lays the foundation for an orthodox epistemology (see 30:1–4). It hardly needs saying that in the theology of Proverbs, there are no other gods to compete with "), _c('em', [_vm._v("I AM")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Paradoxically, I AM, transcendent in heaven, is immanent on earth. His immanence means he knows the sufferings of the oppressed. He is near to them, feels their misery, and will punish their oppressors just as certainly as he will reward those who have compassion on them (19:17). The saying “ignorance of the law is no excuse” comes home to roost in Proverbs, where the immanent "), _c('em', [_vm._v("I AM")]), _vm._v(" holds the ignorant accountable for not delivering the helpless "), _c('a', {
    attrs: {
      "id": "p26"
    }
  }, [_vm._v("and oppressed (24:11–12). Only an immanent God, fully involved in the life of the world, would care enough to hold people accountable for their deeds. All who choose wisdom will find "), _c('em', [_vm._v("I AM")]), _vm._v(" at their side (3:26) and be, as his friends, taken into his confidence (3:32).")])]), _c('a', {
    attrs: {
      "id": "p26"
    }
  }, [_c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-13"
    }
  }, [_vm._v("4. God as Judge")])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "p26"
    }
  }, [_vm._v("In Proverbs, God’s transcendence provides the theological rationale for his role as judge. “Only a transcendent God,” states Bostrom, “can be trusted with the ‘impossible’ task of dispensing justice to each individual and situation!”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-54",
      "id": "footnote-1934-54-backlink"
    }
  }, [_vm._v("54")]), _vm._v(" But precisely how does God dispense justice? To some scholars, Proverbs presents a world order that is so impersonal and deistic that the dispensing of justice becomes merely a matter of an inexorable “deed and destiny”: you reap what you sow. In such a scheme, "), _c('em', [_vm._v("I AM")]), _vm._v("’s connection to justice is at best no more than that of a first cause. Does Proverbs teach that the fate of the wicked is simply a matter of some inescapable destiny or karma that automatically follows their deeds? A superficial reading could lead to such a view—“He who sows iniquity will reap calamity” (cf. 1:19; 10:2, 4; 11:5–6; etc.)—but a deeper reading shows that "), _c('em', [_vm._v("I AM")]), _vm._v(" is no Olympian removed from the active dispensation of justice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("First, recall the epigrammatic nature of the proverbs, which bars an individual saying from expressing the complete truth of a matter. Proverbs need to be read together."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-55",
      "id": "footnote-1934-55-backlink"
    }
  }, [_vm._v("55")])]), _vm._v(" Proverbs that seem to present an impersonal world order (10:2) are followed by proverbs that speak of "), _c('em', [_vm._v("I AM")]), _vm._v("’s involvement in peoples’ lives, as in 10:3."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-56",
      "id": "footnote-1934-56-backlink"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Second, as noted above, one cannot enter Proverbs without its key: “the fear of "), _c('em', [_vm._v("I AM")]), _vm._v("” (1:7). This programmatic phrase, discussed below, emphasizes that a reverent, awestruck trust in "), _c('em', [_vm._v("I AM")]), _vm._v(", who upholds his proverbs promising life or threatening death, is the lens through which to read Proverbs, and it rules out the notion that justice is meted out by the impersonal forces of fate or karma.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p27"
    }
  }, [_vm._v("Third, some proverbs of Solomon explicitly assert "), _c('em', [_vm._v("I AM")]), _vm._v("’s involvement in judgment (10:3; 12:2; 15:3; 16:7; 19:17; 25:21–22; 28:25; 29:25, 26), and the twenty-fifth saying of the wise (24:12) asks rhetorically, “Will he not repay people according to their conduct?”")])]), _c('a', {
    attrs: {
      "id": "p27"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p27"
    }
  }, [_vm._v("Proverbs makes clear, however, that retribution does not operate like clockwork. Sayings that seem to indicate that righteousness is immediately rewarded and wickedness immediately punished (e.g., 11:5–6) need to be read along with other proverbs that assert that retribution, like many of God’s actions, is inscrutable and only grasped by faith. Proverbs knows all too well we live in a topsy-turvy world where the wicked seem to operate with impunity while the righteous suffer for doing good. But Proverbs assures the reader that this present state of affairs will not be the final state. We will return to this issue below under the heading “Does Proverbs Promise Too Much” (")]), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p42"
    }
  }, [_vm._v("pp. 42–45")]), _vm._v(").")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-19"
    }
  }, [_vm._v("C. Revelation, Inspiration, Woman Wisdom, and Tradition")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("God revealed his word through a variety of means. Sometimes he appeared in a theophany, as with Moses at the burning bush; other times in dreams and visions, as with the prophets. With the sages, he used their keen observations and their faith-informed reflections. Let us flesh out this notion, which entails the sages’ epistemology. We begin by defining wisdom and then examine the nature of its revelation and inspiration. We will also try to identify who Woman Wisdom is and the role of tradition in the formation and transmission of wisdom.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-14"
    }
  }, [_vm._v("1. What Is “Wisdom”?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Wisdom” ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("okmâ")]), _vm._v(") is a difficult concept to define since, as Van Leeuwen and others note, it is a totalizing concept that seeks to bring all of life’s activities into harmony with God’s created order."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-57",
      "id": "footnote-1934-57-backlink"
    }
  }, [_vm._v("57")])]), _vm._v(" At its core is the belief that God has made the world in, with, and by wisdom (3:19–20; Ps. 104:24). The wise, therefore, seek to orientate all their being and actions to conform to this wisdom. The word’s use in the Bible suggests the meaning “masterful understanding,” “expertise,” “skill.” People are called wise who possessed technical and artistic skills "), _c('a', {
    attrs: {
      "id": "p28"
    }
  }, [_vm._v("(Exod. 28:3; 31:6), who displayed diplomacy in government (1 Kgs. 5:7), who gave wise judgments (1 Kgs. 3:28), and who possessed encyclopedic knowledge (2 Sam. 14:20; 1 Kgs. 4:29–34). The possession of wisdom enables humans to cope with life"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-58",
      "id": "footnote-1934-58-backlink"
    }
  }, [_vm._v("58")]), _vm._v(" and to achieve what would otherwise be impossible—to wit, eternal life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In Proverbs, “wisdom” mainly denotes the skill to navigate through the maze of life so that one conducts one’s life to the greatest benefit of oneself and the community; it is the way of eternal life. Through wisdom, one is able to read circumstances and interpret situations so as to act correctly, speak properly, and respond appropriately to each situation so that beneficial consequences ensue to self and community. This reveals a further understanding of “wisdom”: namely, insight into the deed-destiny nexus (2:20–21; 22:8). In 30:24–28, it is depicted as the skill to survive even when the odds are stacked against you—as in the examples of the ant, rock badger, locust, and lizard. These creatures are vulnerable; they have almost no personal defense systems. Yet by their "), _c('em', [_vm._v("wisdom")]), _vm._v(", they survive, and the lizard even lives in a palace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Biblical wisdom also has companions. The book’s preamble (1:1–7) includes among them “knowledge” ("), _c('em', [_vm._v("da‘at")]), _vm._v("), “instruction” ("), _c('em', [_vm._v("mûsār")]), _vm._v("), “understanding” ("), _c('em', [_vm._v("bînâ")]), _vm._v("), “prudence” ("), _c('em', [_vm._v("haśkēl")]), _vm._v("), “subtlety” (‘"), _c('em', [_vm._v("ormâ")]), _vm._v("), “discretion” ("), _c('em', [_vm._v("m")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("zimmâ")]), _vm._v("). We unpack each of these words and its context in the commentary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Some of these words by themselves are morally neutral; they can describe even Satan (see Gen. 3:1) and the wicked. Therefore, these wisdom terms are safeguarded by their correlative (that is, words that have the same referent but are not synonyms) ethical and moral companions: righteousness ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("edeq")]), _vm._v("), justice ("), _c('em', [_vm._v("mišpā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṭ")]), _vm._v("), and fairness ("), _c('em', [_vm._v("mêšārîm")]), _vm._v(") (1:3). In other words, in Proverbs, if a person is righteous, that person is also wise. Notice the matching of “righteous” with “wise” in 10:1–2. These "), _c('em', [_vm._v("ethical")]), _vm._v(" correlative terms lift the wisdom terms from the morally neutral realm of skill into the realm of God’s character and actions.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-15"
    }
  }, [_vm._v("2. Revelation")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Proverbs claims that its wisdom comes from God: “For "), _c('em', [_vm._v("I AM")]), _vm._v(" gives wisdom; from his mouth come knowledge and understanding” (2:6). But this wisdom, says the sage, comes through a human’s mouth (1:1), indicating that the revelation from God is communicated through the inspired sage. In short, the sage’s mouth is God’s mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("While it can be inferred that God in common grace has revealed wisdom to humans in and through the created order (Prov. 6:6; 30:24–28), special "), _c('a', {
    attrs: {
      "id": "p29"
    }
  }, [_vm._v("revelation of wisdom is needed to be truly wise. On one hand, the created order is marred by evil, alienated from God, and not in humankind’s interest; on the other, human beings are totally infected by this evil and thus deluded in their understanding of creation. Additionally, the finite mind cannot achieve comprehensive knowledge, and without comprehensive knowledge, humans cannot attain certainty or see clearly. For example, people used to think using asbestos was good and that forest fires were bad. With more knowledge, they learned that the former is bad and the latter may be good. For the epistemology of Proverbs, see the exposition at 8:22–31; 30:1–6.")])]), _c('a', {
    attrs: {
      "id": "p29"
    }
  }, [_c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-16"
    }
  }, [_vm._v("3. Inspiration")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("But how did the sages of Proverbs receive this revelation? Many scholars claim that it was through their research into the created order and rational reflection upon it. The problem with this notion is twofold: it is not taught in Proverbs, and it reduces the authority of Proverbs to merely human advice.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p29"
    }
  }, [_vm._v("However, Solomon, in the guise of the wise father, urges his son to accept his proverbs because “"), _c('em', [_vm._v("I AM")]), _vm._v(" gives wisdom; from his mouth comes understanding” (2:6; cf. vv. 1–6). Here, “wisdom” and its companion, “understanding,” refer to Proverbs. In short, what the sages in Proverbs say, "), _c('em', [_vm._v("I AM")]), _vm._v(" says (see ")]), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p6"
    }
  }, [_vm._v("“Author,” p. 6")]), _vm._v("). From the time of its composition, God’s people have recognized in Proverbs the voice of God and have accepted it as part of their canon of Scripture.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-17"
    }
  }, [_vm._v("4. Illumination and Woman Wisdom")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("“Woman Wisdom” plays a prominent role in the Prologue. Who is she? She makes her debut immediately after the parents’ first lecture to their son (1:8–19) in a passionate call, complete with withering warnings, to the uncommitted to commit to her (1:20–33). She appears again in ch. 8, where she extols her virtues and promises profound premiums for those who embosom her. Elsewhere in the Prologue, she appears in other guises: a divine guide (ch. 6), a beloved sister (= bride, ch. 7). Finally and climactically, we meet her in the epilogue to Collection I (9:1–18), where she offers a compelling invitation to the youth to come and dine with her (9:1–6). However, here she is not alone, as Woman Folly also makes an appearance in 9:13–18 with a rival invitation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Scholars have posited various identities for Woman Wisdom:"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-59",
      "id": "footnote-1934-59-backlink"
    }
  }, [_vm._v("59")])]), _vm._v(" a prophetess because she sounds like the prophet (e.g., compare “how long” in 1:22 with 1 Kgs. 18:21; Jer. 4:14; Hos. 8:5); a sage because her jargon is the same as in the book’s preamble (1:1–7); and a hypostasis of God (of the same substance but independent from God) because of her promise to provide life. Moreover, her claim to laugh at the calamity of the wicked (1:26) reflects on action elsewhere attributed only to God (Pss. 2:4; 59:8)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-60",
      "id": "footnote-1934-60-backlink"
    }
  }, [_vm._v("60")])]), _vm._v(" Still others see her as the ideal woman and wise wife."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-61",
      "id": "footnote-1934-61-backlink"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In truth, she is a unique woman who speaks with the passion of a prophet, reasons like a sage, exercises the authority of God, and honors those who cherish her. In this, she is a heavenly go-between who mediates God’s wisdom to humans. This is the role of Proverbs according to its preamble: to wit, that its reader/hearers may know wisdom and instruction with understanding (1:1–2). Thus, the preamble identifies “wisdom” with Proverbs, and we have no reason to think its personification as Woman Wisdom differs from this equation. Moreover, there are similarities between Proverbs and Woman Wisdom: both address the uncommitted (1:4, 22, 32; 8:5) and teach the fear of "), _c('em', [_vm._v("I AM")]), _vm._v(" (1:7, 29). Woman Wisdom’s admonitions, motivations, promises, and speech style are virtually indistinguishable from those of the parents’ lectures. Heeding her sermon and the parents’ lectures is a matter of life and death (e.g. 2:20–22; 8:32–36). Compare the grandfather’s words in 4:5–6, where he equates his teaching (“Do not forget and do not turn aside from the words of my mouth!” v. 5b) with personified Wisdom (“Do not leave [Wisdom], and she will keep you; love her, and she will guard you,” v. 6).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These striking parallels between the lectures of the father (Solomon’s alter ego) and the sermons of Woman Wisdom are best explained by recognizing Woman Wisdom as a "), _c('em', [_vm._v("personification of Proverbs")]), _vm._v(". Thus, when the son is enjoined to marry Wisdom (7:4), it is a metaphorical way of saying he should become intimately acquainted with Proverbs, which would then provide him with both guidance (6:22) and nutrition (9:1–6) on the way of eternal life.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-18"
    }
  }, [_vm._v("5. Tradition")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Some scholars, who deny an inspired Solomon composed the bulk of Proverbs (see "), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p6"
    }
  }, [_vm._v("“Author,” p. 6")]), _vm._v("), maintain that the composers of Proverbs derived their "), _c('a', {
    attrs: {
      "id": "p31"
    }
  }, [_vm._v("sayings from human tradition. Apart from the fifth lecture (4:1–9), however, there is no evidence within the book of an appeal to a “wisdom tradition” as the original source of the book’s proverbs and sayings. In this fifth lecture, a fictive father expects the son to receive and pass on his teaching even as he received it from his father, the son’s grandfather. The point of this lecture is that Solomon expected his teaching to be passed on by tradition, not that his wisdom derives from tradition.")])]), _c('a', {
    attrs: {
      "id": "p31"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nevertheless, Collections III (22:17–24:22) and IV (24:23–34) consist of sayings that the inspired Solomon adopted and adapted from other sages, and Collection V (25:1–29:27) contains Solomon’s sayings that Hezekiah’s officials copied. In Collection VII (ch. 31), King Lemuel passes on the sayings that his mother taught him. But tradition is not the original source of these collections; rather "), _c('em', [_vm._v("I AM")]), _vm._v(" inspired them, and he stands behind their threats and promises, according to the Prologue (3:1–5).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-20"
    }
  }, [_vm._v("D. Anthropology")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Here, we will analyze humankind in general and then differentiate between the wise and fools and male and female.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-19"
    }
  }, [_vm._v("1. Human Beings in General")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-1"
    }
  }, [_vm._v("a. Words for “Humankind” in Proverbs")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The word ’"), _c('em', [_vm._v("ādām")]), _vm._v(" (“humankind”), occurring forty-four times in Proverbs, differentiates the mortal on earth from God in heaven, who is sovereign over all human potentialities and limitations. The word "), _c('em', [_vm._v("’îš")]), _vm._v(", occurring ninety times in Proverbs, designates an individual vis-à-vis society. It is used variously to designate a male (“man”/“husband”) in contrast to an "), _c('em', [_vm._v("’iššâ")]), _vm._v(" (“woman”/“wife”; see 7:19), though in 2 Sam. 6:19, "), _c('em', [_vm._v("’îš")]), _vm._v(" refers to “each one” of men and women. It too may distinguish the human from the divine, making the human conscious of the vast distinction (see 5:21; 14:12; 21:2; 30:2–4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Geber")]), _vm._v(" refers to the male in his strength, and "), _c('em', [_vm._v("’")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("nôš")]), _vm._v(" refers to the male in his weakness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Throughout the Old Testament, human beings are conceptualized as a psychosomatic unity, but the fundamental components of their beings in Proverbs, besides their bodies, are "), _c('em', [_vm._v("nepeš")]), _vm._v(" (traditionally “soul”), "), _c('em', [_vm._v("lēb")]), _vm._v(" (“heart”), and "), _c('em', [_vm._v("rûa")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _vm._v(" (“spirit”).")])]), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "p31"
    }
  }), _c('a', {
    attrs: {
      "id": "p32"
    }
  }, [_vm._v("b. "), _c('em', [_vm._v("Nepeš")]), _vm._v(" (Traditionally, “Soul”)")])]), _c('a', {
    attrs: {
      "id": "p32"
    }
  }), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "p32"
    }
  }, [_c('em', [_vm._v("Nepeš")]), _vm._v(", occurring fifty-six times in Proverbs, has the same meaning as in the rest of the Old Testament. In English versions, it is traditionally glossed “soul,” which can mislead the reader to conceptualize the “soul” in the New Testament sense of "), _c('em', [_vm._v("psychē")]), _vm._v(", the “seat and center of life that transcends the earthly.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-62",
      "id": "footnote-1934-62-backlink"
    }
  }, [_vm._v("62")]), _vm._v(" But in the Old Testament, "), _c('em', [_vm._v("nepeš")]), _vm._v(" refers to the passionate drives and appetites of all breathing creatures, including their drive for food and sex (6:30; 10:3; 12:10; 16:26; 19:15; 25:25; 27:7; cf. Deut. 23:24; Ps. 78:18; Isa. 5:14; Jer. 2:24). A glutton is a "), _c('em', [_vm._v("ba‘al nepeš")]), _vm._v(" (“owner of appetite/hunger,” 23:2). A greedy person with an unrestrained appetite is a "), _c('em', [_vm._v("r")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em'), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ab-nepeš")]), _vm._v(" (“wide of throat/appetite,” 28:25). "), _c('em', [_vm._v("Nepeš")]), _vm._v(" often predicates words denoting yearning (13:19; 21:10). The craving for God distinguishes a human "), _c('em', [_vm._v("nepeš")]), _vm._v(" from an animal "), _c('em', [_vm._v("nepeš")]), _vm._v(". Since it refers to the basic nature of humans as having and being “passionate yearning,” it is best rendered according to context by “hunger,” “self” (see 1:18, 19), “life” (22:5), and “soul” when it clearly refers to the appetite (see 13:19; 16:24).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-3"
    }
  }, [_vm._v("c. Heart")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("“Heart” ("), _c('em', [_vm._v("lēb/lēbāb")]), _vm._v("), occurring forty-six times in Proverbs and 858 times in the Old Testament, is the most important anthropological term in the Old Testament (see 4:20–27, esp. v. 23) but has no equivalent in English. The ancients attributed "), _c('em', [_vm._v("bodily functions")]), _vm._v(" to the heart, not the brain. Nabal’s body became like stone (paralyzed) because his "), _c('em', [_vm._v("heart")]), _vm._v(" died (1 Sam. 25:37–38). The heart controls facial expressions (Prov. 15:13), the tongue (15:28; 12:23), and all other members (4:23–27; 6:18).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Psychological functions")]), _vm._v(" are also ascribed to the heart. It is the seat of a person’s disposition (23:7; cf. Rom 1:21). The complex interplay of intellect, sensibility, will and disposition occurs in the heart; it prompts all we do (4:23). Thus, planning and decision-making are actions of the heart (6:14, 18; 16:9). "), _c('em', [_vm._v("I AM")]), _vm._v(" knows (17:3; 24:12) and experiences all of its emotions (cf. 12:25; 14:10, 30; 15:15). Lack of insight or judgment is called “lacking heart” (10:13).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The heart also has "), _c('em', [_vm._v("spiritual functions")]), _vm._v("; it accepts and trusts in the religious sphere (3:5). It feels all modes of desire and is responsible for ethical activity. The teacher warns the son not to let "), _c('em', [_vm._v("his heart")]), _vm._v(" covet the adulteress’s beauty (6:25) and not to let it envy sinners (23:17). The heart’s psychological and spiritual functions are closely connected to its "), _c('em', [_vm._v("spiritual state")]), _vm._v(". It can be wise (14:33) "), _c('a', {
    attrs: {
      "id": "p33"
    }
  }, [_vm._v("and pure (20:9) or perverse (17:20; 26:23–25). The bent of one’s heart can determine one’s actions (Exod. 14:5; 35:21; Num. 32:9; 1 Kgs. 12:27; 18:37). Therefore, Solomon seeks to bend the spiritual condition of the heart by repeated appeals to accept his wisdom (2:10; 3:1; 22:17; 23:12; 24:32). But the heart can spurn correction (5:12) and become so hardened that it cannot move in a new spiritual direction (28:14; cf. Isa. 6:10; Matt. 13:15). The centrality of the heart to a person’s emotional-intellectual-religious-moral activity demands its utmost safeguarding (4:23).")])]), _c('a', {
    attrs: {
      "id": "p33"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p33"
    }
  }, [_vm._v("Paradoxically, while the eye and the ear are gates to the heart and shape it (see 2:2; 4:21–23), the heart decides what they will see and hear (4:25–26). Egyptian wisdom resolved the paradox by perceiving God as the ultimate cause of the good: “The one whom God loves can hear; but the one whom God hates cannot hear.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-63",
      "id": "footnote-1934-63-backlink"
    }
  }, [_vm._v("63")]), _vm._v(" Prov. 20:12 traces the teachable ear and the morally insightful eye to God. The king’s heart is in "), _c('em', [_vm._v("I AM")]), _vm._v("’s hand (21:1). But Proverbs negates fatalism by placing the emphasis on the audience’s responsibility to choose the teaching.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-4"
    }
  }, [_vm._v("d. Spirit")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("In Proverbs, "), _c('em', [_vm._v("rûa")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _vm._v(" (“wind” or “spirit,” occurring twenty-one times) is used literally of the wind, which sets other things in motion (25:23; 27:16). But, apart from Agur’s reference to God’s control of the wind (30:4a), Proverbs, unlike other biblical books, does not associate "), _c('em', [_vm._v("rûa")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _vm._v(" with "), _c('em', [_vm._v("I AM")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Rûa")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _vm._v(" also denotes “breathing,” and the manner of breathing indicates one’s mindset: if “short,” nervousness (14:29); if “long,” patience (17:27). This dynamic vitality becomes attenuated into the psychic designation of “mood” or “spirit.” In contexts where the person’s physical vitality is paramount, "), _c('em', [_vm._v("rûa")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _vm._v(" is best rendered by “breath” (e.g., Judg. 15:19 [= “strength,” NIV]; 1 Sam. 30:12 [= “revived,” NIV]); where psychical vitality is paramount, it is best rendered by “spirit” (e.g., Gen. 45:27).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Rûa")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _vm._v(" can also function as a synecdoche for a person’s entire disposition (Eccl. 7:8, 9; Ezek. 11:19; 18:31; 36:26) or the whole inner life (Job 7:11; Ps. 78:8), including opinions or desires (Ezek. 13:3), mind (Ps. 77:6), will (Prov. 16:32), and motives (Prov. 16:2; cf. 2 Chr. 36:22)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-64",
      "id": "footnote-1934-64-backlink"
    }
  }, [_vm._v("64")])]), _vm._v(" The plural of "), _c('em', [_vm._v("rûa")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _vm._v(" in 16:2, paralleling “ways,” denotes that complex patterns of behavior depend on complex motives.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-20"
    }
  }, [_c('a', {
    attrs: {
      "id": "p34"
    }
  }, [_vm._v("2. The Wise and Fools")])]), _c('a', {
    attrs: {
      "id": "p34"
    }
  }, [_c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-5"
    }
  }, [_vm._v("a. Introduction: Correlative Terms")])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "p34"
    }
  }, [_vm._v("Proverbs divides humans into the “wise and righteous” and the “fools and wicked.” We are indebted to Knut Heim for his cogent recognition that these word pairs are correlative terms—that is to say, they differ in their semantic domains (“skill” versus “ethics”) but refer to the same person and so are inseparable."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-65",
      "id": "footnote-1934-65-backlink"
    }
  }, [_vm._v("65")]), _vm._v(" For example, “Vice President of the US” and “President of the US Senate” are correlative terms since they do not belong to the same semantic domain but refer to the same person."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-66",
      "id": "footnote-1934-66-backlink"
    }
  }, [_vm._v("66")])]), _vm._v(" So a wise person is righteous, and a fool is wicked. Synonyms belong to the same semantic domain and often, but not always, refer to the same person or thing (cf. 1:3–6; 8:12). So, a righteous person is also “good” and “upright” while the wicked are also “bad” and “crooked.” These synonyms often occur as parallels. Apart from these two classes, there is no other category in Proverbs. A person uncommitted to wisdom is not in a category in between the wise and the fool but is categorized as a fool and suffers the fate of fools (1:22–33), even though they do not despise wisdom, unlike the fool. The following are the more frequent synonyms of these correlative terms.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-6"
    }
  }, [_vm._v("b. The Wise and Righteous")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5",
    attrs: {
      "id": "sec5-1"
    }
  }, [_vm._v("i. Intellectual Terms for the Wise and Righteous")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The "), _c('em', [_vm._v("wise")]), _vm._v(" person ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ākam")]), _vm._v(") possesses and exhibits the traits of wisdom in its religious-social-ethical sense. Instead of being wise in their own opinion (26:5, 11, 12, 16), they are teachable, seek knowledge (18:15), and store it up (10:4). They listen to instruction (13:1; 22:17) and counsel (12:5), accept commands (10:8), love reproof (9:8), walk with the wise (13:20), and ever increase their wisdom (1:5; 4:18; 15:31–32)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-67",
      "id": "footnote-1934-67-backlink"
    }
  }, [_vm._v("67")])]), _vm._v(" The wise grow to become exceedingly wise (cf. 30:24) and become teachers (4:1–4). Having gained knowledge, they spread it "), _c('a', {
    attrs: {
      "id": "p35"
    }
  }, [_vm._v("(15:7) and become a fountain of life to the community (13:14). Their mastery of the moral order enables them to control their emotions (29:11) and to rule fools (11:29). They bring joy to their parents (15:20; 23:24) and healing to others (12:18) and are themselves protected (13:14).")])]), _c('a', {
    attrs: {
      "id": "p35"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p35"
    }
  }, [_vm._v("The wise are also "), _c('em', [_vm._v("prudent")]), _vm._v(" ("), _c('em', [_vm._v("maśkîl")]), _vm._v("), having “wise behavior” and “good sense” (1:3; cf. 10:5, 19; 14:35; 15:24; 17:2; 19:14; 21:16). The prudent person pays attention to a threatening situation, gets insight into its solution, acts on it decisively, and thereby gains success and life while preventing failure and death. David’s success against the Philistines is a textbook example of prudence (see 1 Sam. 18:5, 14, 15)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-68",
      "id": "footnote-1934-68-backlink"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("According to Fox, "), _c('em', [_vm._v("‘ormâ")]), _vm._v(" ("), _c('em', [_vm._v("shrewdness")]), _vm._v(" or “cunning”) “is the talent for devising and using adroit and wily tactics in the attaining of one’s goals, whatever these may be…. Lady Wisdom herself legitimizes ‘"), _c('em', [_vm._v("ormâ")]), _vm._v(" when she boasts of proximity to it (8:12).”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-69",
      "id": "footnote-1934-69-backlink"
    }
  }, [_vm._v("69")])]), _vm._v(" The shrewd scheme to achieve their desires (14:8, 15), ignore insults (12:16), look where they are going (14:15), and spot danger and avoid it (22:3; 27:12). Being cunning entails acting with “knowledge” (13:16) while refraining from vaunting it (12:23).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Discretion")]), _vm._v(" (or “caginess,” "), _c('em', [_vm._v("m")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("zimmâ")]), _vm._v(") is defined by Fox as “private, unrevealed thinking and the faculty for it”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-70",
      "id": "footnote-1934-70-backlink"
    }
  }, [_vm._v("70")])]), _vm._v("—usually in the sense of making plans."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-71",
      "id": "footnote-1934-71-backlink"
    }
  }, [_vm._v("71")])]), _vm._v(" If the plans are hostile and full of intrigue (24:8), they are condemned by God (12:2) and the community (14:17). But if discretion is in accord with the sages’ wisdom (1:4; 2:11; 3:21; 5:2), it is inseparable from it (8:12).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The "), _c('em', [_vm._v("insightful")]), _vm._v(" person ("), _c('em', [_vm._v("nābôn")]), _vm._v(", 1:5) “has a penetrating and foreseeing mind (15:21; 20:5; 28:11) … [and] speaks and acts sensibly (11:12; 17:28).”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-72",
      "id": "footnote-1934-72-backlink"
    }
  }, [_vm._v("72")])]), _vm._v(" They are so because they have the perspective of wisdom and therefore the mental and intellectual ability to distinguish between right and wrong, good and bad. The insightful can perceive things from the divine viewpoint and do not rely on "), _c('a', {
    attrs: {
      "id": "p36"
    }
  }, [_vm._v("their own relative perspective. They seek and obtain knowledge (14:6; 15:14; 18:15), readily accept rebuke (19:25), enshrine the book’s wisdom in the heart (14:33), wear it as the badge of their character (16:21), and keep silent (17:28) unless they can speak wisely (10:13).")])]), _c('a', {
    attrs: {
      "id": "p36"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The insightful acquire "), _c('em', [_vm._v("guidance")]), _vm._v(" ("), _c('em', [_vm._v("ta")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("bulôt")]), _vm._v(", 1:5). The word may be a nautical term, referring to the steering ropes of a ship. The LXX renders the word by the Greek "), _c('em', [_vm._v("kybernēsis")]), _vm._v(" (“steering” or “navigation”).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p36"
    }
  }, [_c('em', [_vm._v("Understanding")]), _vm._v(" ("), _c('em', [_vm._v("t")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("bûnâ")]), _vm._v(") occurs nineteen times, thirteen of which are in parallel with “wisdom” (2:2, 6; 3:13, 19; 5:1; 8:1; 24:3; cf. 21:30) or one of its synonyms. According to Fox, who renders it with “competence” or “know-how,” the distinction between "), _c('em', [_vm._v("t")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("bûnâ")]), _vm._v(" and "), _c('em', [_vm._v("bînâ")]), _vm._v(" is that the former “designates the pragmatic, applied aspect of thought, operating in the field of action; it aims at efficacy and accomplishment. [The latter] is the conceptual, interpretive activity of thought, operating in the field of meaning; it aims at perception and comprehension.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-73",
      "id": "footnote-1934-73-backlink"
    }
  }, [_vm._v("73")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("People with "), _c('em', [_vm._v("t")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("bûnâ")]), _vm._v(" have insight into the moral order and a social conscience that guides their actions. They have self-control (17:27), are patient (14:29), hold their tongues (11:29), can discern the hearts of others (20:5), and keep a straight path (15:21). Fools couldn’t care less for "), _c('em', [_vm._v("t")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("bûnâ")]), _vm._v(" (18:2), and without it, rulers become tyrants (28:16).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_vm._v("ii. Ethical Terms for the Wise and Righteous")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("According to Lucas, explicit references to “the righteous” and “the wise” are approximately equal in Proverbs."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-74",
      "id": "footnote-1934-74-backlink"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('em', [_vm._v("Righteousness")]), _vm._v(" is “doing what is right in a social relationship, as defined by God’s standard of what is right behavior … , [namely] depriving self to benefit others. Put simply, the righteous disadvantage themselves to advantage the community; the wicked disadvantage the community to advantage themselves.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-75",
      "id": "footnote-1934-75-backlink"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p37"
    }
  }, [_vm._v("Furthermore, righteousness must be “put on” (Job 29:14), a metaphor signifying it is the very essence of a person, not merely an outward performance. It is a matter of the heart (10:20) gained through the sages’ words (2:1–11) and so promotes a relationship with God (15:9). The wicked forsake God, while the righteous cling to him. Righteousness also profits self because "), _c('em', [_vm._v("I AM")]), _vm._v(" guarantees that it will result in true profit and security (2:11; 10:2, 3). Finally, being righteous is a matter of life and death (11:19; 15:9; 21:12).")])]), _c('a', {
    attrs: {
      "id": "p37"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If righteousness establishes right order, "), _c('em', [_vm._v("justice")]), _vm._v(" ("), _c('em', [_vm._v("mišpā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṭ")]), _vm._v(") restores the violated order by delivering the victim and punishing the offender to produce shalom. But justice is more than legal action; it is a moral quality, coming from the heart. To live rightly is to do justice and righteousness (cf. Gen. 18:19; Ps. 106:3; Prov. 1:3; 2:3; 8:20; 16:8; 21:3; Isa. 5:7; 58:2). To judge rightly is to judge in accordance with justice and righteousness (cf. Lev. 19:15; Deut. 1:16, 17; Ps. 9:4, 7–8), as is to govern rightly (cf. 2 Sam. 8:15; 1 Kgs. 10:9; Ps. 72:1–12; Eccl. 3:16; Isa. 9:7)—just as God governs all his realm in accordance with justice and righteousness (cf. Job 8:3; Pss. 33:5; 36:6; 89:14).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p37"
    }
  }, [_c('em', [_vm._v("Uprightness")]), _vm._v(" ("), _c('em', [_vm._v("mêšārîm")]), _vm._v(", often translated “equity” in the sense of being fair or impartial) derives from the root "), _c('em', [_vm._v("yāšār,")]), _vm._v(" which has the geometrical notion of being straight, whether vertically or horizontally. The geometric use assumes a fixed order to which something can be compared. Proverbs uses the term primarily in an ethical figurative sense that assumes a fixed moral order by which actions can be judged as straight, upright, and level (Prov. 8:6)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-76",
      "id": "footnote-1934-76-backlink"
    }
  }, [_vm._v("76")]), _vm._v(" Conduct that does not stray from or go outside of this fixed moral order can be called “upright.” Paraphrasing a public lecture by Raymond C. Van Leeuwen, true freedom is found within form, liberty within law, lovemaking within marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Blameless(ness)")]), _vm._v(" ("), _c('em', [_vm._v("tām")]), _vm._v(" [adj.]; "), _c('em', [_vm._v("tōm")]), _vm._v(" [n.]) denotes completeness and integrity in the sense of a process that has already been accomplished in a person (see 1:12, where it is translated “whole” in the NIV). The basic meaning of the root ("), _c('em', [_vm._v("tmm")]), _vm._v(") is “to be complete, finished, perfect.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-77",
      "id": "footnote-1934-77-backlink"
    }
  }, [_vm._v("77")])]), _vm._v(" When used with “walk,” it denotes consistent behavior—doing things with the whole of one’s heart as opposed to acting with a double heart. In Proverbs, "), _c('em', [_vm._v("tōm")]), _vm._v(" is a comprehensive term for total commitment to "), _c('em', [_vm._v("I AM")]), _vm._v(". The word occurs always with “walk” or “way” (2:7; 10:9, 29; 13:6; 19:1; 28:6).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Good")]), _vm._v(" ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṭ")]), _c('em', [_vm._v("ôb")]), _vm._v(") denotes anything or anyone as desirable on account of being "), _c('a', {
    attrs: {
      "id": "p38"
    }
  }, [_vm._v("aesthetically pleasing and ethically beneficial. The “good” unselfishly act in the best interest of God and neighbor.")])]), _c('a', {
    attrs: {
      "id": "p38"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p38"
    }
  }, [_c('em', [_vm._v("Trustworthy")]), _vm._v(" ("), _c('em', [_vm._v("’")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("mûnâ")]), _vm._v("; also “honest” or “conscientious”) designates a person’s character and conduct, not just their words. Trustworthiness is not an abstract quality but springs from inner stability—the inner attitude that produces honest and conscientious conduct."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-78",
      "id": "footnote-1934-78-backlink"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Finally, "), _c('em', [_vm._v("kindness")]), _vm._v(" ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("esed")]), _vm._v(") essentially means “help to the needy” and has no precise English equivalent. It refers to a situation where someone needs help and another provides it without compulsion, out of their better spiritual and inward instincts. Since the helper is under no obligation to help, "), _c('em', [_vm._v("faithfulness")]), _vm._v(" or “reliability” ("), _c('em', [_vm._v("’")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("met")]), _vm._v(") is added to "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("esed")]), _vm._v(" twenty-one times in the Old Testament. The resulting combination ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("esed we’")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("met")]), _vm._v(") means to exercise “unfailing kindness.”")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_vm._v("iii. Fear of "), _c('span', {
    staticClass: "no-em"
  }, [_vm._v("I AM")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("Fear of")]), _vm._v(" "), _c('span', {
    staticClass: "no-em"
  }, [_vm._v("I AM")]), _vm._v(" ("), _c('em', [_vm._v("yir’at yhwh")]), _vm._v(") is the key that opens the door to understanding Proverbs."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-79",
      "id": "footnote-1934-79-backlink"
    }
  }, [_vm._v("79")])]), _vm._v(" The expression is a collocation, a combination of words that has a unique meaning. For example, one will not understand “butterfly” by analyzing “butter” and “fly” independently. So also “fear of "), _c('em', [_vm._v("I AM")]), _vm._v("” cannot be understood by analyzing “fear” and “"), _c('em', [_vm._v("I AM")]), _vm._v("” separately. The expression is a compound. “Fear of "), _c('em', [_vm._v("I AM")]), _vm._v("” involves both rational and non-rational aspects simultaneously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Rationally, the collocation entails an objective revelation that can be taught (Ps. 34:11ff.) and memorized (Prov. 2:1–5). In Ps. 19:7–9, it is used as an equivalent of “law,” “statutes,” “commands,” and “ordinances” of "), _c('em', [_vm._v("I AM")]), _vm._v(". As noted above under “Names of God” (see "), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p26"
    }
  }, [_vm._v("p. 26")]), _vm._v("), “fear of "), _c('em', [_vm._v("I AM")]), _vm._v("” differs somewhat from “fear of God.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Psychologically, the “fear of "), _c('em', [_vm._v("I AM")]), _vm._v("” entails responding to the revelation in fear, love, and humility. According to Prov. 2:1–5, “the fear of "), _c('em', [_vm._v("I AM")]), _vm._v("” is found through heartfelt prayer and diligent seeking for the sages’ words. In 15:33, “humility” and “the fear of "), _c('em', [_vm._v("I AM")]), _vm._v("” are parallel terms, and “humility” in 22:4 is further defined as “the fear of "), _c('em', [_vm._v("I AM")]), _vm._v(" sort” (our translation).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Whoever fears "), _c('em', [_vm._v("I AM")]), _vm._v(" trusts him, for they are confident that he upholds the "), _c('a', {
    attrs: {
      "id": "p39"
    }
  }, [_vm._v("teachings that promise life to the obedient and threaten death to the disobedient. So paradoxically, because of their faith in "), _c('em', [_vm._v("I AM")]), _vm._v(", whoever fears "), _c('em', [_vm._v("I AM")]), _vm._v(" also loves him (cf. Deut. 5:29 with 6:2; Deut. 6:5 with Josh. 24:14; cf. Prov. 10:12, 20; 13:5)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-80",
      "id": "footnote-1934-80-backlink"
    }
  }, [_vm._v("80")]), _vm._v(" C. Bridges writes, “[The fear of YHWH is] that affectionate reverence, by which the child of God bends himself humbly and carefully to his Father’s law.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-81",
      "id": "footnote-1934-81-backlink"
    }
  }, [_vm._v("81")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_vm._v("iv. The Wise and Words")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The behavior of the wise/righteous is often assumed and not defined in Proverbs. But two areas stand out in contrasting the wise/righteous and the fools/wicked: namely, how they handle words and wealth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Bible’s ideal of wise speech is similar to the humanistic ideal of "), _c('em', [_vm._v("eloquentia")]), _vm._v(", or talking well, which Gadamer identifies as having two meanings: “not merely rhetorical ideal [but] also … saying the right things—that is the truth.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-82",
      "id": "footnote-1934-82-backlink"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The importance of "), _c('em', [_vm._v("eloquentia")]), _vm._v(" cannot be overemphasized. All social relationships depend on communication. “Speech and communication go hand in hand. Community depends on communication”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-83",
      "id": "footnote-1934-83-backlink"
    }
  }, [_vm._v("83")])]), _vm._v(" (see Prov. 11:30; 15:4). Here we consider the value of wise speech, its characteristics, and its sources.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Concerning value, first, the tongue has the power of life and death (18:21; cf. 10:19; 17:27–28) because it has the power to shape beliefs and convictions that affect eternal destinies. Parents utilize the good power of the tongue (that is, speech) to influence their children to accept wisdom and life. However, fools starve to death because they refuse to eat the good fruit of sound teaching (10:21). Good speech is both a “tree of life” (11:30) and a “fountain of life” "), _c('a', {
    attrs: {
      "id": "p40"
    }
  }, [_vm._v("(13:14) available now. Second, the tongue has the power to heal and to destroy (6:12–15, 16–19; 10:14; 11:9; 12:18; 16:24). The child’s proverb “Sticks and stones may break my bones, but words will never hurt me” is not true, for, as Kidner says, “What is done "), _c('em', [_vm._v("to")]), _vm._v(" you is of little account beside what is done "), _c('em', [_vm._v("in")]), _vm._v(" you.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-84",
      "id": "footnote-1934-84-backlink"
    }
  }, [_vm._v("84")]), _vm._v(" Third, the tongue has the power to reward or damage its owner (10:10; 12:14; 18:6–7). A fool’s tongue is long enough to cut his throat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Concerning its characteristics, one of Bruce’s students formulated the acronym Gentle B-R-E-A-T-H to make some of the features of wise speech memorable. Such speech is "), _c('em', [_vm._v("gentle")]), _vm._v(", not harsh or quarrelsome (15:1); "), _c('em', [_vm._v("boasts")]), _vm._v(" not (27:1–2); is "), _c('em', [_vm._v("restrained")]), _vm._v(", not blabby (10:19; 17:14, 27, 28); "), _c('em', [_vm._v("eavesdrops")]), _vm._v(" not (that is, is not given to gossip or rumor; 11:12–13); is "), _c('em', [_vm._v("apt")]), _vm._v(" (uses the right word at the right time in the right way; 15:2); is "), _c('em', [_vm._v("thoughtful")]), _vm._v(", not rash (15:28; 18:13); and is "), _c('em', [_vm._v("honest")]), _vm._v(", not false (8:7; 12:17, 19, 22).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Concerning sources, wise speech comes from the heart (16:23) and is realized by walking with the wise (13:20), by maintaining sound doctrine (22:17–19), and by prayer (15:29; cf. Jas. 1:5).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_vm._v("v. The Wise and Wealth")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("In their lectures, the parents aim to protect their son from the dangers of easy sex (2:16–19) and easy money (1:10–19). Here, the topic of wealth is analyzed in terms of its danger, limitation, value and management.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As to money’s dangers, it tends to supplant trust in God. That happens to the "), _c('em', [_vm._v("rich person")]), _vm._v(" ("), _c('em', [_vm._v("‘āšîr")]), _vm._v(") in Proverbs. The meanings of “rich person” in English and in Proverbs differ significantly. In the former, “rich person” has only a material sense; the rich have superfluous money. In Proverbs, however, “the rich” also has the spiritual connotation of trusting money, not "), _c('em', [_vm._v("I AM")]), _vm._v(", for one’s security and significance (10:15; 18:10–11; cf. Ps. 49:6). Instructively, the NIV changed Prov. 28:11 from “the rich "), _c('em', [_vm._v("may be")]), _vm._v(" wise in their own eyes” (1984) to “the rich "), _c('em', [_vm._v("are")]), _vm._v(" wise in their own eyes” (2011). Instead of depending on "), _c('em', [_vm._v("I AM")]), _vm._v(","), _c('em'), _vm._v(" the rich think of themselves as self-made. So they are fools, living in the realm of death. Agur recognized this danger of wealth and prayed to be kept from too much of it (30:7–9). As one seminary ad says, under an image of a stack of bills, “It’s put more Christians at stake than Nero.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Proverbs also recognizes the limitations of money (3:13–18). It can build a house but not a home; put food on the table but not fellowship around the table; give a woman diamonds and furs but not the love she really wants. Wisdom, however, gives both material well-being and spiritual life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p41"
    }
  }, [_vm._v("Yet Proverbs is realistic about the value of money. It saves one from the "), _c('em', [_vm._v("spiritual")]), _vm._v(" losses associated with poverty. Too little money leads people to steal and so defile their consciences and alienate themselves from God (30:9). The poor lack social power (18:23; 22:7). Moreover, Proverbs candidly recognizes that poverty hampers friendship: people dodge the destitute (14:20), albeit Proverbs promotes kindness to them (14:21). Some wealth, therefore, is necessary to enjoy life more fully (12:9) and to be righteous in the sense of serving and supporting the community (11:23–28; cf. Eph. 4:28).")])]), _c('a', {
    attrs: {
      "id": "p41"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Enduring wealth is obtained through honoring God with one’s firstfruits (3:9–10), generosity rather than stinginess (11:23–28; 28:22), hard and timely work (10:4–5), contentment rather than indulgence (21:17), patience rather than haste (13:11; 21:5), and securing one’s income before building a home (24:27). In other words, the key is character, not method. Proverbs is a “how to be” book, not a “how to get” book.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_vm._v("vi. The Wise and Their Rewards: Life")])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "p41"
    }
  }, [_vm._v("The sage’s nexus between deed-destiny (see ")]), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p27"
    }
  }, [_vm._v("“What Is ‘Wisdom’?” pp. 27–28")]), _vm._v(") entails the doctrines of retribution for the wicked (see "), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p26"
    }
  }, [_vm._v("“God as Judge,” p. 26")]), _vm._v(") and of reward for the righteous (10:2; 11:5–6, 23, 27)—to wit, “life” ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ayyîm")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The noun "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ayyîm")]), _vm._v(" occurs thirty-three times in Proverbs and the verb "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("āyâ")]), _vm._v(" four times."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-85",
      "id": "footnote-1934-85-backlink"
    }
  }, [_vm._v("85")])]), _vm._v(" Sometimes it refers to physical life (31:12), but most often "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ayyîm")]), _vm._v(" is unqualified and refers to “life” that is added to physical (that is, clinical) life—apparently an abundant life of health, prosperity, and social esteem (3:21–22; 4:13; 8:35; 16:15; 21:21; 22:4). Other than 16:15, these passages point to “life” as wisdom’s reward—a reward never said to be tarnished by death (4:22; 6:23; 10:17; 11:19; 12:28; 13:14; 15:31; 19:23; 22:4). This is true also for all four uses of the verb (4:4; 7:2; 9:6; 15:27). Moreover, the “tree of life” (3:18; 11:30; 13:12; 15:4; cf. Gen. 2:9; 3:24) figuratively represents perpetual healing, ensuring eternal life, as is probably also true of the “wellspring of life” (16:22).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the proverb “The wages of the righteous is life, but the earnings of the wicked are sin and death” (10:16), “life” is in antithetic parallelism to “death,” implying that the former is life apart from death. In biblical theology, life is essentially a relationship with the living and eternal God, and the disruption of that relationship means death (Gen. 2:17). Wisdom’s concern is in maintaining this relationship (Prov. 2:5–8) and thus with experiencing life in God’s favor. In sum, “life” mostly refers to abundant life in fellowship with God—a living, "), _c('a', {
    attrs: {
      "id": "p42"
    }
  }, [_vm._v("eternal relationship in contrast to the eternal “death” of the wicked. As Jesus said, “He is not the God of the dead but of the living” (Matt. 22:32).")])]), _c('a', {
    attrs: {
      "id": "p42"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Prov. 12:28 affirms that the righteous are rewarded with immortality (’al-māwet). Prov. 14:32 says, “Even in death the righteous seek refuge in God,” and 23:17 asserts that their future hope will not be disappointed. In contrast, the wicked have no future hope (11:7a; 12:28; 24:19–20). What Proverbs teaches, then, is immortality, not resurrection, unlike Job 19:25–27; Pss. 49:15 (cf. v. 8); 73:23–24; Isa. 14:13–15; and Dan. 12:2 (cf. Gen. 5:24; 2 Kgs. 2:1). However, Prov. 15:24, if taken at face value, implies an ascent from the grave. The movement from below (that is, the grave— "), _c('em', [_vm._v("š")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em'), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ôl")]), _vm._v(") “upward” fits the biblical teaching that the godly terminate their journey in the presence of God himself (Pss. 16:9–11; 73:23–26; John 14:1–4; 2 Tim. 4:18; Heb. 12:2). Thus, “life” in Proverbs has to be more than being spared an untimely death, for otherwise “the path of life” terminates in death. But death is not God and does not have the last word in this book any more than in any other biblical book.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p42"
    }
  }, [_vm._v("Furthermore, the hope of life after death in Proverbs comports with the well-known Egyptian belief in an afterlife. The hymns and prayers of the Egyptians witness to their hope for a blessed future beyond death. Since Proverbs shows a heavy dependence on Egyptian instructions, it would be surprising if “life” meant less with the living God than the Egyptian hope of life with a “no-god” (Deut. 32:21). Finally, humanity’s intuitive notion of justice and the assurance of it in Proverbs (16:15) demand the doctrine (see ")]), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p36"
    }
  }, [_vm._v("“Ethical Terms for the Wise and Righteous,” pp. 36–38")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nevertheless, it is true that Proverbs and the Egyptian instructions focus on health, prosperity, and social honor "), _c('em', [_vm._v("in this life")]), _vm._v(" in contrast to the Christian focus on the resurrection. Perhaps this is due to the opaqueness of the hope before the resurrection of Jesus Christ (Titus 1:2–3).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_vm._v("vii. Does Proverbs Promise Too Much?")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The heavenly promises of life, health, prosperity, and honor given in Proverbs to the wise/righteous, appear unrealistic in light of earth’s harsh realities. Human experience sometimes contradicts them—as Job (9:22–23) and Qoheleth (the “Preacher”/“Gatherer,” Eccl. 9:2–3) complained. Often, the righteous suffer and the wicked prosper (cf. Heb. 11:35–38). The following reflections on whether Proverbs promises too much explore, first, three unsatisfactory and untenable solutions to this apparent contradiction and, second, four better solutions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("First, the three untenable solutions:")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("The problem is human depravity. This was the solution of Eliphaz: “Consider now: Who, being innocent, has ever perished? Where were the upright ever destroyed? As I have observed, those who plow evil and those who sow trouble reap it” (Job 4:7–8). There is a large element of truth to Eliphaz’s proposition that sin has its consequences in this life (see "), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p26"
    }
  }, [_vm._v("“God as Judge,” p. 26")]), _vm._v("). However, it is not the whole answer, and it is debunked, first by the narrator of Job (1:8) and later by "), _c('em', [_vm._v("I AM")]), _vm._v(" himself (42:7): Job was a righteous man and suffered uncommonly.")]), _vm._v(" "), _c('li', [_vm._v("The sages are dullards who cannot see or think straight"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-86",
      "id": "footnote-1934-86-backlink"
    }
  }, [_vm._v("86")])]), _vm._v(" and are looking at the world through rose-tinted glasses. This solution contradicts the principle of the inspiration of the sage, which entails cogent reflection upon keen observation (see "), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p29"
    }
  }, [_vm._v("“Inspiration,” p. 29")]), _vm._v("). Moreover, this solution undermines the authority of Proverbs and the canon, as well as Christ and his apostles’ claim that all Scripture is inspired of God, who neither lies (1 Sam. 15:29) nor authors confusion (1 Cor. 14:33; 2 Tim. 3:16).")]), _vm._v(" "), _c('li', [_vm._v("A popular evangelical solution is that these are not promises but probabilities. Though this solution contains an element of truth, it also raises theological, practical, and psychological problems. Stated this way, humans are expected to keep their obligations perfectly (3:1, 3, 5, 7, 9), but God may keep his obligations imperfectly (3:2, 4, 6, 8, 10). The truth is, “though we are faithless, he will remain faithful” (2 Tim. 2:13). Moreover, a risk-taker would like to know the odds, and a person of sound mind could scarcely trust a God who will “probably” keep his promises.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("From among the better solutions that have been suggested, we present four:")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("The promises are mostly validated by experience. The sober person, not the drunkard (cf. 23:29–35); the cool-tempered person, not the hothead (15:18; 19:19; 22:24; 29:22); and the diligent person, not the sluggard, usually experience health and prosperity. Moreover, even apart from a future that outlasts death (see the fourth solution, below), history shows that people may not pay the price for vice immediately, but over time the harm is realized.")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "id": "p44"
    }
  }, [_vm._v("The epigrammatic nature of the proverbs means that a proverb represents the truth but not the whole truth. Proverbs that promise health and wealth must be balanced by other proverbs that qualify these promises. For example, note that the first proverb pair (10:2–3) is a unity. Proverbs 10:2a asserts that the wicked do have treasures gained by wickedness (plundering the innocent) for a season, but 10:2b says that it will not deliver them from death. To this, 10:3 adds that (afterward) the cravings of the wicked will be frustrated, while the righteous, who may now be afflicted, will later be fed. Moreover, several better-than proverbs assume that at present the wicked have material possessions while the righteous do not: “Better a little with righteousness than a large income with injustice” (16:8; see 16:19; 17:1; 19:1, 19; 22:1; 25:24; 28:6; cf. Ps. 37:16; Eccl. 4:6).")])]), _c('a', {
    attrs: {
      "id": "p44"
    }
  }), _c('li', [_c('a', {
    attrs: {
      "id": "p44"
    }
  }, [_vm._v("As a primer on morality for youth, Proverbs focuses on a future when the righteous rise (see ")]), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p41"
    }
  }, [_vm._v("“The Wise and Their Rewards: Life,” pp. 41–42")]), _vm._v("), not the present when they fall: “For if the righteous fall seven times, then they rise; but the wicked stumble in calamity” (24:16). “Seven” signifies completeness, like the count of ten for the downed boxer. Here, the complete fall of the righteous is assumed, but so is their future rise, phoenix-like, from the ashes. Job and Qoheleth, instead of noting the fall of the righteous in a concessive clause, feature their fall in the main clause, as it were. This by-faith religious instruction of Proverbs (to wit, the fear of "), _c('em', [_vm._v("I AM")]), _vm._v(") reinforces youth’s intuitive grasp of right and wrong.")]), _vm._v(" "), _c('li', [_vm._v("Finally, as argued under the heading “The Wise and Their Rewards: Life” ("), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p41"
    }
  }, [_vm._v("pp. 41–42")]), _vm._v("), the righteous person rises in a blessed future that surpasses death. The book’s concept of justice demands such a hope. Instructively, in his first lecture warning the son against criminal gangs, the father imagines a situation very much like that of the first situation of humanity outside the garden. Just as the righteous Abel was dispatched to an early grave by the wicked Cain, who then lived a normal span of life, in the father’s first lecture, an innocent victim is depicted as prematurely dispatched by wicked gangsters. This initial situation debunks the popular view that, in Proverbs, “life” refers to long life while “death” refers to dying prematurely. For justice to be done, as Proverbs assures it will be (e.g., 3:31–35; 16:4–5), Abel and the innocent victim must be vindicated and delivered from death in a future that lies beyond their graves. If physical death is the last word for innocent victims, then the first story outside the Garden and the first lecture, along with other biblical stories about the martyrs, undermine the Bible’s claim that God upholds "), _c('a', {
    attrs: {
      "id": "p45"
    }
  }, [_vm._v("justice. Farmer rightly comments, “One either has to give up the idea of justice or one has to push its execution into some realm beyond the evidence of human experience.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-87",
      "id": "footnote-1934-87-backlink"
    }
  }, [_vm._v("87")]), _vm._v(" Prov. 23:18 puts it more explicitly: “Surely there is a latter end [for the wise]; your hope will not be cut off.” So “do not fret because of those who forge evil; do not envy the wicked; for the evil person has no blessed future; the lamp of the wicked will be snuffed out” (24:19–20). Obviously, that future is not accessible to verification, as Gladson complained,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-88",
      "id": "footnote-1934-88-backlink"
    }
  }, [_vm._v("88")])]), _vm._v(" but without such faith, one cannot be justified (Rom. 4:5–25), cannot be saved (Rom. 10:6–13), cannot please God (Heb. 11:6). If these promises were infallibly validated by experience, then the father’s command for the son to trust in "), _c('em', [_vm._v("I AM")]), _vm._v(" (3:5) is pointless.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If God were to reward virtue instantly, humankind would confound pleasure with piety and would use piety to satisfy its prurient interests. Instead, God develops the character of his saints by calling them to suffer for the sake of righteousness while living in the hope of eternal life (see Rom. 8:18; 2 Cor. 4:17). In sum, Proverbs characterizes the wise as living by faith entirely (“with all your heart,” 3:5a), exclusively (“lean not on your own understanding,” 3:5b), and exhaustively (“in all your ways” 3:6a).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-7"
    }
  }, [_vm._v("c. The Wicked and Fools")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5",
    attrs: {
      "id": "sec5-2"
    }
  }, [_vm._v("i. Ethical Terms for Wicked and Fools")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Those called "), _c('em', [_vm._v("wicked")]), _vm._v(" ("), _c('em', [_vm._v("r")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("šā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("îm")]), _vm._v("), according to K. H. Richards, are the guilty and are always seen as such vis-à-vis the community."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-89",
      "id": "footnote-1934-89-backlink"
    }
  }, [_vm._v("89")])]), _vm._v(" "), _c('em', [_vm._v("Rešā‘")]), _vm._v(" (“wickedness”) is the most important antonym of "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("edeq")]), _vm._v(" (“righteousness”). Van Leeuwen writes, “Rš‘ expresses negative behavior—evil thoughts, words, and deeds—antisocial behavior that simultaneously betrays a person’s inner disharmony and unrest (Isa. 57:20).”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-90",
      "id": "footnote-1934-90-backlink"
    }
  }, [_vm._v("90")])]), _vm._v(" If the righteous advantage the community, even at the expense of disadvantaging themselves, then the wicked advantage themselves by disadvantaging the community. In Proverbs, “the wicked” is used of impious "), _c('a', {
    attrs: {
      "id": "p46"
    }
  }, [_vm._v("people who are greedy (10:3; 21:10), violent (10:6), threaten innocent life (12:6; 24:15), practice deceit (12:5) and cruelty (12:10), and speak perversely (10:32; 11:11; 15:28; 19:28). "), _c('em', [_vm._v("I AM")]), _vm._v(" detests them and their ways (15:9, 29).")])]), _c('a', {
    attrs: {
      "id": "p46"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p46"
    }
  }, [_c('em', [_vm._v("Perversity")]), _vm._v(" ("), _c('em', [_vm._v("tahpūkôt")]), _vm._v(") is an abstract noun designating the action of its verbal root "), _c('em', [_vm._v("hāpak")]), _vm._v(": “to overturn, overthrow,” as when bread is turned over when baked (Hos. 7:8) and bowls are turned upside down (2 Kgs. 21:13). In Proverbs, it is used as a general term of reproach for speech (8:13; 10:31; cf. 17:20) coming from a perverse heart (cf. 6:14; 16:30) that seeks to overthrow the established order. Such a tongue will be “cut out” (10:31)—a radical punishment but proportional to the threat to public safety. The perverse act against the community and for their own selves."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-91",
      "id": "footnote-1934-91-backlink"
    }
  }, [_vm._v("91")]), _vm._v(" The word combines the moral perverseness of what people say and do (Prov. 8:8; 19:1; 28:6) with the calamitous result of their lifestyle, which trips them up and makes them stumble headlong (4:12; 22:5).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The verbal root of "), _c('em', [_vm._v("treacherous")]), _vm._v(" ("), _c('em', [_vm._v("bôg")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("dîm")]), _vm._v(", 11:3, 6; 13:2, 15; 21:18; 22:12; 23:28; 25:19) expresses unfaithfulness to an established relationship. Specifically, it refers to those “who abandon” their heritage of having a relationship with God and with their teachers (2:13, 17; cf. Ps. 25:3). Prov. 2:21–22 divides the covenant community into two groups: those wholly committed to "), _c('em', [_vm._v("I AM")]), _vm._v(" and the treacherous who refuse to honor the covenant given them by faithful parents.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Those called "), _c('em', [_vm._v("evildoers")]), _vm._v(" are literally “those who do iniquity ("), _c('em', [_vm._v("’āwen")]), _vm._v(").” They use the negative power of violence and deception against all humanity; they even hound the blameless (3:34; 6:12 [“villain,” NIV]; 10:29; 21:15b).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("For "), _c('em', [_vm._v("sinners")]), _vm._v(", see on 1:10.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_vm._v("ii. Intellectual Terms for the Wicked and Fools")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The above ethical terms for the unwise refer to fools’ moral culpability, not their lack of intelligence."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-92",
      "id": "footnote-1934-92-backlink"
    }
  }, [_vm._v("92")])]), _vm._v(" The intellectual terms, however, are not correlatives, but distinguish several classes of fools according to their teachableness: the uncommitted, the fool, and the mocker. As for the “sluggard” and the "), _c('a', {
    attrs: {
      "id": "p47"
    }
  }, [_vm._v("“senseless” (see the next section, ")]), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p49"
    }
  }, [_vm._v("pp. 49–50")]), _vm._v("), the former is worse than the fool (cf. 28:12, 16) but not as incorrigible or vile as the latter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The personal term "), _c('em', [_vm._v("uncommitted")]), _vm._v(" ("), _c('em', [_vm._v("p")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("tî/p")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("tā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("yīm")]), _vm._v(" [pl.] ) occurs fourteen times in Proverbs, and the related abstract nouns "), _c('em', [_vm._v("petî")]), _vm._v(" and "), _c('em', [_vm._v("p")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("tayyût")]), _vm._v(" (“simplicity”) once each. Basically, the word means “to be open” and so in Proverbs describes a person who is not committed to the sages’ teachings. Such a character is in danger of being easily misled. I (Bruce) earlier suggested the translation “gullible,” but upon further reflection, the notion of being uncommitted is more fundamental to the meaning of "), _c('em', [_vm._v("p")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("tî/p")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("tā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("yim")]), _vm._v(". The uncommitted are the mildest sort of fools, and their state is not hopeless; they can still repent and be taught (1:4, 22–23; 8:5; 21:11) and so join the wise (cf. 1:22; 9:4). Both Wisdom and Folly vie for their allegiance (ch. 9), but until they make the decision to accept wisdom, they are wayward (see 1:32). Descriptive terms used with "), _c('em', [_vm._v("p")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("tî")]), _vm._v(" describe their character as youthful (1:4; 7:7) and senseless (7:7; 9:4, 16); neither shrewd (14:15, 18) nor “insightful” (19:25); not “wise” (21:11); weak-willed (22:3; 27:12); and easily seduced (7:7, 21–22)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-93",
      "id": "footnote-1934-93-backlink"
    }
  }, [_vm._v("93")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The uncommitted are a danger to themselves and their associates. Until they repent, they are on a slippery slope and are grouped with fools and mockers (1:22, 32; 8:5). What they need most is “shrewdness” (1:4). They naively trust every word (14:15), bumble into misfortune (22:3; 27:13), and inherit folly (14:18). Their “open-to-everything” attitude kills them (1:32). “Simplicity” ("), _c('em', [_vm._v("p")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("tayyût")]), _vm._v(") characterizes Woman Folly, whose way leads to death (9:13). Only by abandoning their peers, embarking on the way of insight, and learning cunning can they live (8:5; 9:4, 6, 16). Put colloquially, Woman Wisdom’s message to them is, “Turn or burn” (1:25–32).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Two Hebrew terms are commonly translated "), _c('em', [_vm._v("fool")]), _vm._v(" ("), _c('em', [_vm._v("’ĕwîl")]), _vm._v(" and "), _c('em', [_vm._v("k")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("sîl")]), _vm._v("). Unlike the uncommitted, the fool is fixed in the infallibility of their own opinion, even when it contravenes the established moral order revealed through the sage. Ptahhotep noted, “A fool sees knowledge in ignorance, usefulness in harmfulness…. He lives on that by which one dies, his food is distortion of speech.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-94",
      "id": "footnote-1934-94-backlink"
    }
  }, [_vm._v("94")])]), _vm._v(" Both Hebrew words are derogatory, describing people who act irrationally due to their morally deficient characters. They are deaf to wisdom but cocksure of their distorted moral vision from which they love to twist the beneficial values of the community.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A clear distinction between "), _c('em', [_vm._v("’ĕwîl")]), _vm._v(" and "), _c('em', [_vm._v("k")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("sîl")]), _vm._v(" cannot be drawn, because both "), _c('a', {
    attrs: {
      "id": "p48"
    }
  }, [_vm._v("share the same moral deficiencies and fate. Respectively in the citations, note that "), _c('em', [_vm._v("’ĕwîl")]), _vm._v(" and "), _c('em', [_vm._v("k")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("sîl")]), _vm._v(" are characterized by “folly” ("), _c('em', [_vm._v("’iwwelet")]), _vm._v(", 16:22 and 14:24; 17:12; 26:4, 5, 11), despise discipline and correction (15:5 and 15:20), lack wisdom (10:14, 21 and 14:33), speak poorly (10:8, 10; 17:28; 27:3 and 10:18; 12:23; 15:2; 19:1), lack self-control and are hot-tempered (12:16; 20:3 and 19:11), and are morally insolent, intractable, and incorrigible (12:15; 24:7 and 15:14; 17:10; 18:2; 26:5, 11; 28:26). Hopelessly bound to their folly (27:22 and 14:24; 17:10, 16; 23:9; 26:11), they cannot manage their homes and finances (11:29 and 21:20), have no honor (20:23; 29:9 and 3:35), and are punished for their folly (10:14; 14:3 and 19:29; 26:3).")])]), _c('a', {
    attrs: {
      "id": "p48"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The "), _c('em', [_vm._v("’ĕwîl")]), _vm._v(" uniquely has no interest in rectifying wrongs (14:9). Such a person’s provocations are worse than carrying sand and stones (27:3), and their vexations upset others (12:16; 17:25; 26:4). (The same is probably true of the "), _c('em', [_vm._v("k")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("sîl")]), _vm._v(".) The "), _c('em', [_vm._v("’ĕwîl")]), _vm._v(" is self-sufficient, rejects counsel (12:15), and disdains wisdom (1:7).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p48"
    }
  }, [_vm._v("The nominal equivalent of the “fool” is "), _c('em', [_vm._v("folly")]), _vm._v(", "), _c('em', [_vm._v("foolishness")]), _vm._v(" ("), _c('em', [_vm._v("’iwwelet")]), _vm._v("), which, according to Fox, signifies “moral corruption from the standpoint of its impact on judgment and reason.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-95",
      "id": "footnote-1934-95-backlink"
    }
  }, [_vm._v("95")]), _vm._v(" While the disciplining rod may remove folly from a youth (22:15), not even pounding fools in a pestle removes their folly (27:22). The deed-destiny nexus ensures that the fool’s folly"), _c('em'), _vm._v(" is transformed into a chastening discipline (16:22). The fool’s mouth is a cherry bomb (10:14); their ignorance kills them (10:21).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Fools")]), _vm._v(" (pl. "), _c('em', [_vm._v("k")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("sîlîm")]), _vm._v(") are cocksure of their own point of view (18:2; 26:12; 28:26; 30:32), have no heart for education, disregard moral truth, and recklessly vent their folly (12:23; 15:2; 26:9). As they spout their own opinions, they get others (14:7) and themselves into trouble (18:6, 7). They are hotheaded (29:11) and reckless (14:16), and delight in evil conduct (10:23). They waste money (17:16) and are prone to stupid amusements (19:10). Their ways are clear to all (13:16). It is “better to meet a bear robbed of her cubs than a fool bent on folly” (17:12, NIV). Instead of valuing knowledge and pursuing it, fools are repulsed by it and seek to rid themselves of it, doubling down on folly “as a dog returns to its vomit” (26:11).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Mockers")]), _vm._v(" ("), _c('em', [_vm._v("lē")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("îm")]), _vm._v(") occurs fourteen times in Proverbs and refers to the most hardened apostates. The noun “mocking” ("), _c('em', [_vm._v("lā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("ôn")]), _vm._v(") occurs in 1:22; 29:8. The mocker, the direct opposite of the wise (Prov. 9:12; 13:1; 20:1; 21:4) and of the discerning (14:6; 19:25), hates the wise should they try to correct them (9:7–8; 15:12). Their spiritual problem is rooted in their overweening pride (21:24), "), _c('a', {
    attrs: {
      "id": "p49"
    }
  }, [_vm._v("and their arrogance keeps them from wisdom (14:6). It is futile to punish or discipline a mocker, but watching a mocker being disciplined may enlighten the uncommitted (19:25; 21:11). A mocker has a big mouth and unleashes strife upon the community (22:10; 29:8), destroying it in the process (21:24; 22:10; 29:8). Their negative influence is clear to most (24:9). According to McKane, “No man earns more universal detestation or deserves it more than he who wears a perpetual sneer, who is himself incapable of deep loyalty and reverence and who supposes that it is his mission in life to promote the corrosion of the values by which individuals and society lives.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-96",
      "id": "footnote-1934-96-backlink"
    }
  }, [_vm._v("96")]), _vm._v(" To save the community, a mocker must be forcefully driven out (22:10). In the end, God himself scoffs at the mocker (3:34), thus ensuring they will disappear (Isa. 29:20).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_vm._v("iii. The Sluggard and the Senseless")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The term "), _c('em', [_vm._v("sluggard")]), _vm._v(" ("), _c('em', [_vm._v("‘ā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("ēl")]), _vm._v(")"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-97",
      "id": "footnote-1934-97-backlink"
    }
  }, [_vm._v("97")])]), _vm._v(" occurs thirteen times in the Old Testament, all in the book of Proverbs (6:6, 9; 10:26; 13:4; 15:19; 19:24; 20:4; 21:25; 22:13; 24:30; 26:13, 14, 16). Another term for the sluggard is "), _c('em', [_vm._v("r")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("miyyâ")]), _vm._v(" (10:4; 12:24, 27; 19:15). Other circumlocutions for the sluggard are “slack in his work” (18:9) and “a man of want” (21:17). The antonym of the sluggard is the “diligent” ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ārû")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _vm._v("), which also only occurs in Proverbs and always as the antithetic parallel to sluggard. Only in 21:5 is a clear contrast to the sluggard missing, but the sluggard’s shadow is still discernible. The sluggard is the subject of two main units: 6:6–11 and 24:30–34.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sluggards irritate all who do business with them because they are unreliable and procrastinate (10:26; cf. 26:15). They bring shame to their parents (10:5) because they destroy the family inheritance (19:13–15; 24:31). Sluggards view hard workers as fools; otherwise they would stand self-condemned. The sluggard irrationally excuses not going to work: “I can’t go to work today; I might get hit by a truck!” (see 22:13).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Laziness in Proverbs is more than a character flaw. It is a moral issue, for it takes away freedom (12:24), causes frustration because of the sense of getting nowhere (24:34), and eventually results in death (see 6:6–11; 10:4; 18:9; 20:13; 21:25–26; 24:30–34; cf. 28:24). Sluggards stand in contrast to the “upright” in 15:19 and the “righteous” in 21:25–26 because they give nothing to society. Sluggards are never equated with the “poor,” who are so because of "), _c('a', {
    attrs: {
      "id": "p50"
    }
  }, [_vm._v("circumstances beyond their control, such as tyranny (13:23; cf. 28:3); sluggards are poor because they are morally degenerate. They are not worthy to be called “poor,” which is why the book does not instruct the disciple to feed them (13:4; 16:26; 19:17). The sluggard is left begging in harvest and has “plenty of poverty,” a telling oxymoron (20:4; 28:19).")])]), _c('a', {
    attrs: {
      "id": "p50"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "p50"
    }
  }, [_vm._v("The "), _c('em', [_vm._v("senseless")]), _vm._v(" ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ăsar-lēb")]), _vm._v(", “lacking heart/sense”) occurs only in wisdom literature (thirteen times in Proverbs; cf. Eccl. 10:3 and Sirach). Here the word “heart” ("), _c('em', [_vm._v("lēb")]), _vm._v(") carries its psychological meaning (see ")]), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p32"
    }
  }, [_vm._v("“Heart,” p. 32")]), _vm._v("). In Collection I, this moral flaw is ascribed to the uncommitted (7:7; 9:4, 16) and the unchaste wife (6:32). The former is weak in temptation, lacking the foresight to see the fatal consequences of adultery (6:32; 7:7). In Collection II, the senseless despise their neighbors (11:12), chase fantasies (12:11), find joy in folly (15:21), put themselves up as security (17:18), and are the antithesis of the righteous (10:20, 21) and wise (10:13). In Collection IV, senselessness is ascribed to the sluggard (24:30). In short, fools have this moral flaw.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_vm._v("iv. Retribution for the Wicked")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The wicked are already dead, for they have no relationship with the living God. The texts predicting the death of the wicked do not refer to a premature death but represent this present state of death, terminating with a tragic, final end. While the pursuit of wisdom and practice of righteousness save the wise from the realm and destiny of death, nothing can deliver the wicked (1:4, 19; 10:2; 13:14; 14:27; 15:24). Their physical death is a land of no return, without a second chance (1:20–33; 2:19, 22; cf. Ps. 49:8, 15; Isa. 26:19). If death is the final destiny of the wicked, we should assume that life is the final destiny of the righteous (cf. Matt. 25:46).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_vm._v("v. The Grave (Traditionally, “Sheol”)")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("Sheol")]), _vm._v(" ("), _c('em', [_vm._v("š")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em'), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ôl")]), _vm._v("), which occurs nine times in Proverbs, describes the destiny of all humanity (23:14; 27:20; 30:16), both the fools/wicked (5:5; 7:27; 9:18) and, temporarily, the wise/righteous (1:12; cf. Ps. 49:9, 15, a wisdom psalm). In most English translations, "), _c('em', [_vm._v("š")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em'), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ôl")]), _vm._v(" is transliterated as “Sheol,” but the NIV (1984) justly renders it by “Grave.” The prepositions attached to Sheol indicate that it is the physical grave below the earth. The varied and rich figures that the biblical poets use to depict it transform it from the physical realm of the dead to the metaphorical, transcendent realm—a place distinct from both the earth where the living are and the heavenly realm where God is."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-98",
      "id": "footnote-1934-98-backlink"
    }
  }, [_vm._v("98")])]), _vm._v(" The Grave, like the Jordan River and Mount Zion, symbolizes eternal realities that transcend its physical space, and so it is rendered with the upper case, “Grave.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-99",
      "id": "footnote-1934-99-backlink"
    }
  }, [_vm._v("99")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-21"
    }
  }, [_vm._v("3. Male and Female")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Finally, humankind is divided into male and female, distinguishing them sexually as man and woman, socially as husband and wife, and parentally as father and mother."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-100",
      "id": "footnote-1934-100-backlink"
    }
  }, [_vm._v("100")])]), _vm._v(" The complex character of the unfaithful wife will be discussed separately, since the father lectures against her more than any other person.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-8"
    }
  }, [_vm._v("a. Man and Woman")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Proverbs is a book oriented to the male. In the lectures of the Prologue, the father is always mentioned, the mother rarely so (however, see below). The addressee is always his son, never his daughter; and in the father’s warning, he warns his son against an unfaithful wife (chs. 5, 7), never his daughter against an adulterous husband. Woman Wisdom addresses the males in the gate, not the women in the market (8:4). The unfaithful wife and Woman Folly go after the uncommitted male, but no equivalent male seduces the uncommitted girl. In Collection II, Solomon continues to address the son (10:1; 19:27), not the daughter. He warns against the unfaithful (22:14) and quarrelsome woman (19:13; 21:9, 19; 25:24; 27:15) while commending marriage to a good woman (12:4; 18:22; 19:14). He never mentions a good or bad husband. Collections III, VI, and "), _c('a', {
    attrs: {
      "id": "p52"
    }
  }, [_vm._v("VII are addressed to the son (23:15; 30:1; 31:1), and the book closes with a portrait of an ideal wife, with no mention of an ideal husband for a woman."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-101",
      "id": "footnote-1934-101-backlink"
    }
  }, [_vm._v("101")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yet the woman was not excluded from being taught the book’s wisdom. The reference to “your mother” (1:8; 4:3; 6:20; 10:1) points to the home, with mother and father, as the place in which wisdom was taught. The fact that some lectures of the Prologue mention the mother (1:8; 4:3; 6:20) implies that in the other lectures, too, she is engaged with the father in teaching their son. The poet gaps her presence in the other lectures due to the epigrammatic nature of proverbs."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-102",
      "id": "footnote-1934-102-backlink"
    }
  }, [_vm._v("102")])]), _vm._v(" In the book’s concluding poem, the noble wife is praised for having faithful instruction on her tongue (31:26). These references to the mother/noble wife as a teacher in the home imply that when she was a daughter, she too was taught the proverbs by both her parents, since to be a teacher of wisdom, she herself had to be taught.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One reason only the son is addressed is the expectation that it is the male offspring who will assume leadership in defining the family’s identity and values (4:3–4; cf. Num. 30). E. Follis argues another reason: speaking in general terms, males are the more adventuresome of the sexes by nature, tending to press beyond existing boundaries and stray from the inherited tradition. By contrast, daughters tend to nurture the home and community."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-103",
      "id": "footnote-1934-103-backlink"
    }
  }, [_vm._v("103")])]), _vm._v(" In sum, the proverbs are also addressed to the daughter and need to be applied appropriately in a way that looks at men through a woman’s eyes.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-9"
    }
  }, [_vm._v("b. Husband and Wife")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("A wise man is prayerful (15:8, 29; 16:3) and depends on God for a prudent wife (18:22). He searches for one who is noble and competent (31:10–31) and rejects "), _c('a', {
    attrs: {
      "id": "p53"
    }
  }, [_vm._v("one who is unloved by the godly community (30:23). Because he is wise and teachable, he listens to his wife’s good and earnest correction and counsel (9:8, 9; 13:14, 20) as he would to a friend (27:6, 9)—as David listened to Abigail (1 Sam. 25:32–35). If his wife is foolish, we assume he would reject her counsel as Job refuted his wife’s (Job 2:9–10), as David rebuffed Michal’s (2 Sam. 6:21–22), and as Adam and Abraham should have done to their wives (Gen. 3:6, 12; 16:2). The wise husband becomes intoxicated with his wife’s love, and the father prays that the son will find a wife who fully satisfies his God-given sexual appetite (5:18–19). A good wife does not shame him (12:4) or tear down her house (14:1), and he praises her by publicly standing up in her presence and proclaiming her virtue (31:28–31).")])]), _c('a', {
    attrs: {
      "id": "p53"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A wise wife fears "), _c('em', [_vm._v("I AM")]), _vm._v(", is wise and righteous in general (see 31:31b) and so accepts her husband’s godly teaching and correction. He can trust her as he does "), _c('em', [_vm._v("I AM")]), _vm._v(" (31:11). Unlike the unfaithful wife, she keeps her marriage covenant (2:17; 15:4) and desires to be a crown on her husband’s head (12:4). She works to supplement the family income so that her husband is free to serve the public good (31:13–25, esp. v. 23). She teaches and manages her whole household (31:28) and finds her fulfillment in enriching others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In sum, husband and wife dwell together in a spirit of humility (15:33) and faith in God (16:3). They express their love in each other’s embrace and in open correction of each other (27:5; cf. Lev. 19:17–18). And they confess and renounce their inevitable sins while extending mercy to each other (28:13).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-10"
    }
  }, [_vm._v("c. Father and Mother")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Wise parents build their house (14:1; 24:27), value their children (4:3), and raise them in "), _c('em', [_vm._v("I AM")]), _vm._v(". They recognize the depravity of human nature (14:12; 19:27; 20:9; 22:15; 29:18) but believe wise parenting is effective (22:6) and so give their children moral instruction (1:2–6; 30:1; 31:1). They use verbal instruction to form the child’s character (chs. 1–10) and the rod to prevent repeated folly (13:24). They regard their values as God-given (2:6) and therefore as absolute and not relative to the whims of secular society. They are united in their instruction (1:8; 31:26), were exemplary in their own submission when they were children (4:3–4), and are diligent in their pedagogy—as seen in the repetitive pattern of the ten lectures. Far from overly safeguarding the child from real-world evil, they take the risk and allow the child to feel its tempting power by re-creating the words of wicked men and the unfaithful wife while simultaneously developing repulsion to them (1:10–19; 7:1–27).")])]), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-11"
    }
  }, [_c('a', {
    attrs: {
      "id": "p53"
    }
  }), _c('a', {
    attrs: {
      "id": "p54"
    }
  }, [_vm._v("d. The Unchaste (“Strange”) Wife")])]), _c('a', {
    attrs: {
      "id": "p54"
    }
  }), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "p54"
    }
  }, [_vm._v("Who is the woman from whose wiles the father seeks to protect his son through repeated warnings in chapters 5–7?"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-104",
      "id": "footnote-1934-104-backlink"
    }
  }, [_vm._v("104")]), _vm._v(" He introduces her in 2:16–19 and then expands her profile in three lectures (5:1–23; 6:20–35; 7:1–27; cf. 22:14; 23:33)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-105",
      "id": "footnote-1934-105-backlink"
    }
  }, [_vm._v("105")])]), _vm._v(" He introduces her as an “unchaste wife” ("), _c('em', [_vm._v("’iššâ zāra‘")]), _vm._v(" ), a “foreigner” ("), _c('em', [_vm._v("nokrîâ")]), _vm._v("), “who abandons the companion of her youth,” and “forgets her covenant with God” (2:16–17). The last two reveal her as an unfaithful, apostate wife. When all the lectures about her are analyzed, they present a portrait of an unchaste wife, an outsider to the covenant community, who betrayed her faithful covenant husband (2:16; 5:20; 6:24; 7:5) and remarried outside the covenant community."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-106",
      "id": "footnote-1934-106-backlink"
    }
  }, [_vm._v("106")])]), _vm._v(" Her remarriage can be inferred from the fact that she now has a foreign husband (6:29; 7:19). She is a prostitute "), _c('em', [_vm._v("at heart")]), _vm._v(" (6:26)"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-107",
      "id": "footnote-1934-107-backlink"
    }
  }, [_vm._v("107")])]), _vm._v(" who lustfully stalks the streets and attempts to seduce young men (7:10–21). Let us analyze the four descriptors used to introduce her.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_c('a', {
    attrs: {
      "id": "p55"
    }
  }, [_vm._v("i. The “Unchaste Woman” (’iššâ zārâ, 2:16a)")])]), _c('a', {
    attrs: {
      "id": "p55"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "p55"
    }
  }, [_vm._v("According to Snijders, “the participle zār (‘strange’ [fem. zārâ]) must be translated ‘one who distances or removes himself.’”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-108",
      "id": "footnote-1934-108-backlink"
    }
  }, [_vm._v("108")]), _vm._v(" This definition fits well the sketch in 2:17 (“[She] abandons the companion of her youth”), matching the depiction in the parallel sketch of the perverse men as apostates from the right way (2:15–18). Furthermore, the "), _c('em', [_vm._v("zārâ")]), _vm._v(" is hostile to the covenant community and endangers it because her behavior is outside the laws of the community."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-109",
      "id": "footnote-1934-109-backlink"
    }
  }, [_vm._v("109")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_vm._v("ii. The “Outsider” (nokriyyâ, 2:16b)")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Is this unchaste woman also a foreigner in the literal sense?"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-110",
      "id": "footnote-1934-110-backlink"
    }
  }, [_vm._v("110")])]), _vm._v(" In covenantal contexts, "), _c('em', [_vm._v("nokrî")]), _vm._v(" signifies a “foreigner” not incorporated within Israel (Exod. 2:22; Deut. 14:21; Judg. 19:12; 1 Kgs. 8:41; Isa. 2:6). Based on this, some contend she is a cult prostitute."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-111",
      "id": "footnote-1934-111-backlink"
    }
  }, [_vm._v("111")])]), _vm._v(" However, the father does not label her as such, and she never tempts the son religiously but only with sensual pleasure. The father warns of the danger posed by her husband, not by apostasy from "), _c('em', [_vm._v("I AM")]), _c('em', [_vm._v(".")]), _vm._v(" The father’s warning does not pertain to her ethnicity but to the negative social and economic consequences of adultery. In sum, in Proverbs, she is probably not a pagan foreigner but an unfaithful wife who stands outside the community of the wise.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_vm._v("iii. The Unfaithful Wife (2:17a)")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The woman is also described as willfully violating her commitment to her godly husband. “Companion of her youth” ("), _c('em', [_vm._v("’allûp n")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em'), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("ûrêhā")]), _vm._v(") is a metonymy for her husband as a teacher. "), _c('em', [_vm._v("’Allûp")]), _vm._v(" denotes “a [personal] friend, confidante, "), _c('a', {
    attrs: {
      "id": "p56"
    }
  }, [_vm._v("[bosom] companion, comrade” and is used six other times (cf. 16:28; 17:9; Ps. 55:14; Jer. 3:4; 13:21; Mic. 7:5)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-112",
      "id": "footnote-1934-112-backlink"
    }
  }, [_vm._v("112")]), _vm._v(" Its verbal root means “to instruct” and may refer to the intimate fellowship that develops from people sharing and getting to know each other. In such a relationship, friends become vulnerable to each other because their trust can be misused. Indeed, in all seven occurrences of ’"), _c('em', [_vm._v("allûp")]), _vm._v(", it refers to the betrayed confidence of a close friend. As Hosea guided Gomer (Hos. 3:2–3), so this woman’s husband faithfully instructed her in the right way, but she spurned his loyalty with betrayal.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_vm._v("iv. The Apostate Wife (2:17b)")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("In the phrase “forgets her covenant with God,” the word “forgets” ("), _c('em', [_vm._v("šākē")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("â")]), _vm._v(") means that she dismembers herself from her allegiance to her marriage covenant; it is synonymous with “abandon.” “Covenant” ("), _c('em', [_vm._v("b")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("rît")]), _vm._v(") means “imposition” or “obligation” and here refers to her marriage obligations. The addition of “with her God” suggest that the Creator is the witness to, guarantor, and possibly author of her marriage vows."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-113",
      "id": "footnote-1934-113-backlink"
    }
  }, [_vm._v("113")])]), _vm._v(" Thus, this depiction presents her as a woman who in her youth had accepted "), _c('em', [_vm._v("I AM")]), _vm._v(" and his wisdom as taught her by her husband but refuses to honor her commitment. Turning her back on her husband, she has also turned her back on "), _c('em', [_vm._v("I AM")]), _vm._v(" and his covenant community. The unfaithful wife of the Prologue is an adulteress among people and an apostate against God.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_vm._v("v. Conclusion")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The unchaste wife is not simply an “adulteress” (that is, “someone else’s wife”)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-114",
      "id": "footnote-1934-114-backlink"
    }
  }, [_vm._v("114")])]), _vm._v(" The various descriptions of her in the Prologue present her as a lustful apostate from the godly community and an unrestrained wife who has betrayed the faithful husband of her youth (2:16–17; 5:20; 6:24; 7:5), as Gomer did Hosea (Hos. 1:2–11). Throughout the Prologue, she is "), _c('em', [_vm._v("at heart")]), _vm._v(" a prostitute (6:26), lustfully stalking the streets to seduce young men (7:10–21). This description fits the biblical world. She is a "), _c('em', [_vm._v("femme fatale")]), _vm._v(" who will bring disaster to the son if he becomes involved with her—namely, ruin from the community (5:17), insatiable vengeance from her current husband (6:32–35), and ultimately death from God (5:21–23; 7:23–27).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The unchaste wife is also a paradigm for spiritual infidelity to "), _c('em', [_vm._v("I AM")]), _vm._v(". This interpretation is fortified in the unchaste wife’s personification as Woman Folly at the end of the Prologue. Sexual and spiritual faithfulness interpenetrate each other. A sexual adulterer shows himself incapable of having a single eye toward God. Solomon’s sexual unfaithfulness stole away his heart from loving God because his sex life was married to his spiritual life. The prophets frequently used marriage as a metaphor for Israel’s relationship to "), _c('em', [_vm._v("I AM")]), _c('em', [_vm._v(".")]), _vm._v(" However, these warnings against the literal adulteress must not be minimized, as seen by the father’s detailed description of her allurements and the economic, not religious, nature of his warnings.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-21"
    }
  }, [_vm._v("E. Christology")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Proverbs is directly relevant to the Christian, albeit it is surpassed in the life and teachings of Jesus Christ. Moreover, Woman Wisdom is a type of Lord Jesus Christ and, along with the rest of Scripture, speaks of his death and resurrection, as Jesus said (Luke 24:44).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-22"
    }
  }, [_vm._v("1. The Enduring Relevance of Proverbs to Christians")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Four arguments establish the enduring importance of Proverbs.")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("By nature, proverbs express eternal, unchanging truth applicable to many situations, but the way they express that truth is historically, politically, and culturally conditioned.")]), _vm._v(" "), _c('li', [_vm._v("The Holy Spirit caused its inclusion in the canon of Scripture and thus affirmed its relevance. Jews and Christians have universally recognized Proverbs as part of the Bible. And the New Testament includes Proverbs in the statement, “All Scripture is God-breathed and is useful for teaching, rebuking, correcting and training in righteousness, so that the servant of God may be thoroughly equipped for every good work” (2 Tim. 3:16–17).")]), _vm._v(" "), _c('li', [_vm._v("The apostles apply the book to the church. Peter uses Prov. 26:11 and Jude uses Prov. 25:14 with reference to false teachers (2 Pet. 2:22; Jude 12). The apostles generally use proverbs to teach the church godly living (cf. Prov. 3:7 with 2 Cor. 8:12; Prov. 3:34 with Jas. 4:5 and 1 Pet. 5:5; Prov. "), _c('a', {
    attrs: {
      "id": "p58"
    }
  }, [_vm._v("4:26 with Heb. 12:13; Prov. 10:16 with Rom. 6:23; Prov. 24:21 with 1 Pet. 2:17; Prov. 25:21–22 with Rom. 12:20; Prov. 26:11 with 2 Pet. 2:2; Prov. 30:8 with Matt. 6:11).")])]), _c('a', {
    attrs: {
      "id": "p58"
    }
  }, [_c('li', [_vm._v("The author of Hebrews interprets the father’s lecture to his son in Prov. 3:11–12 as addressing the church (Heb. 12:5–6).")])])]), _c('a', {
    attrs: {
      "id": "p58"
    }
  }, [_c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-23"
    }
  }, [_vm._v("2. The Superiority of Jesus Christ to Solomon’s Wisdom")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Jesus Christ claimed superiority to Solomon and his wisdom (Matt. 12:42). This superiority is evident in a number of ways:")])]), _c('ul', [_c('a', {
    attrs: {
      "id": "p58"
    }
  }, [_c('li', [_vm._v("The Queen of Sheba praised Solomon’s wisdom, but she will rise at the judgment to condemn those who do not listen to Christ’s superior wisdom (cf. 1 Kings 10:7 with Matt. 12:42).")]), _vm._v(" "), _c('li', [_vm._v("Solomon taught that "), _c('em', [_vm._v("I AM")]), _vm._v(" would repay the wrongdoer, but Christ says he himself will repay them (cf. Prov. 24:12 with Matt 25:41–46; Rev. 2:23; 22:12; see also Rom. 2:6–8; 2 Thess. 1:8; 2 Tim. 4:14; 1 Pet. 1:17; Rev. 20:12–13).")]), _vm._v(" "), _c('li', [_vm._v("Solomon depended on God to discipline those he loves, but Christ himself disciplines those he loves (cf. Prov. 3:11–12 with Rev. 3:19).")]), _vm._v(" "), _c('li', [_vm._v("Solomon emphasized health and wealth now while minimizing present sufferings; Christ emphasized present suffering for righteousness while maximizing future glory (cf. Prov. 3:1–10, 34 with Matt. 5:3–12; 25:1–13).")]), _vm._v(" "), _c('li', [_vm._v("Solomon speaks opaquely of eternal life, but Christ, by his resurrection, brought eternity into present history (cf. Prov. 8:35 with Matt. 25:46; 2 Tim. 1:10; see also John 11:25–26; Rom. 6:1–4; Col. 3:1–3).")]), _vm._v(" "), _c('li', [_vm._v("Solomon promotes pleasing parents, but Christ, while upholding the honor of parents, gives higher priority to loving and serving the triune God (cf. Prov. 10:1; 19:13; 23:22–25; 27:11; 29:3 with Matt. 5:45; 7:21; 10:32, 33, 35, 37; 15:4; 23:9; 25:34; Mark 3:31–35; Luke 9:60).")]), _vm._v(" "), _c('li', [_vm._v("Solomon’s wisdom is brought into being by God, but Christ is God.")]), _vm._v(" "), _c('li', [_vm._v("Solomon offers a banquet of food and drink, but Christ himself is the Christian’s food and drink (cf. Prov. 9:1–3 with John 6:53; see also Matt. 26:26–28 parr.; 1 Cor. 11:23–27).")]), _vm._v(" "), _c('li', [_vm._v("No human ascended into heaven to gain comprehensive knowledge, but Christ both descended from heaven and ascended into it (cf. Prov. 30:4 with John 6:33; Eph. 4:9–10).")])]), _c('li', [_c('a', {
    attrs: {
      "id": "p58"
    }
  }), _c('a', {
    attrs: {
      "id": "p59"
    }
  }, [_vm._v("Solomon himself failed to obey his wisdom, but Christ perfectly exemplified his teachings (cf. Prov. 3:2; 25:26 with 1 Kgs. 11:19–10; Luke 2:52; Heb. 4:15).")])]), _c('a', {
    attrs: {
      "id": "p59"
    }
  }, [_c('li', [_vm._v("Solomon taught his disciples to feed their enemies, but Christ died for his enemies (cf. Prov. 25:21 with Rom. 5:8; see also Eph. 2:1–10; 1 Tim. 1:12–17).")])])]), _c('a', {
    attrs: {
      "id": "p59"
    }
  }, [_c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("Nevertheless, we do not discard Solomon’s wisdom on the grounds that Christ’s wisdom is superior any more than we would throw away a ten-dollar bill because we had a hundred-dollar bill. Jesus himself undoubtedly devoted much time to studying and memorizing Proverbs; the disciple is not above the master.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-24"
    }
  }, [_vm._v("3. Woman Wisdom as a Type of Jesus Christ")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-12"
    }
  }, [_vm._v("a. Historical Background")])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "p59"
    }
  }, [_vm._v("From about the time of Justin Martyr (A.D. 125), most Christians"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-115",
      "id": "footnote-1934-115-backlink"
    }
  }, [_vm._v("115")]), _vm._v(" identified Woman Wisdom ("), _c('em', [_vm._v("Sophia")]), _vm._v(", the Greek equivalent of the Hebrew "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("okmâ")]), _vm._v(") in Prov. 8 with Jesus Christ. This fateful interpretation embroiled the church in controversy about the nature of the relationship between God and Christ."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-116",
      "id": "footnote-1934-116-backlink"
    }
  }, [_vm._v("116")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Nicene fathers equated Wisdom and Christ on the basis of their preexistence and their assumed roles as agents in the creation (cf. Prov. 3:19–20; 8:22–31 with John 1:3; 1 Cor. 8:6; Col. 1:15–16; Heb. 1:3). However, as we will show in the commentary, exegesis of Proverbs 8:22–31 does not support identifying Wisdom with Christ. As we argued above (see "), _c('a', {
    attrs: {
      "href": "#/007_Introduction#p29"
    }
  }, [_vm._v("pp. 29–30")]), _vm._v("), Solomon identifies Woman Wisdom with his teachings, not with a hypostasis of God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Furthermore, the apostles do not build their high Christology by identifying Jesus with Wisdom. Jewish wisdom literature provides no sure foundation, if any, for the high Christology of the New Testament as found in John 1:3, Phil. 2:6, and Col. 1:15–16."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-117",
      "id": "footnote-1934-117-backlink"
    }
  }, [_vm._v("117")])]), _vm._v(" By contrast, the Wisdom of Solomon represents Wisdom as a mediator between God and creation, and the Jerusalem Targum renders Gen. 1:1 in conjunction with Prov. 8:22: “"), _c('em', [_vm._v("I AM")]), _vm._v(" created the heavens and the earth by wisdom.” Such writings, while not contributing directly to the high Christology of the New Testament, may have provided the apostles with a paradigm for expressing the doctrine of the Trinity, with Jesus Christ represented as the agent through whom all things were created; but the apostles do not cite or build their high Christology on Prov. 8:22–31."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-118",
      "id": "footnote-1934-118-backlink"
    }
  }, [_vm._v("118")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A lot has been made of John’s use of Wisdom in his Gospel, but nowhere does he equate Jesus Christ with the figure of Wisdom in Prov. 8. In fact, he never uses the word "), _c('em', [_vm._v("sophia")]), _vm._v(" in his Gospel (or epistles), which, as Karen Jobes notes, would be “beyond comprehension” if John were trying to present Jesus in the categories of Wisdom."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-119",
      "id": "footnote-1934-119-backlink"
    }
  }, [_vm._v("119")])]), _vm._v(" According to Jobes, the "), _c('em', [_vm._v("logos")]), _vm._v(" in John’s prologue differs so markedly from Woman Wisdom that “the prologue is, in fact, a polemic against viewing Jesus Christ through the lens of Jewish Wisdom as refracted by Greek philosophy.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-120",
      "id": "footnote-1934-120-backlink"
    }
  }, [_vm._v("120")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Neither does Paul build his high Christology on Prov. 8 or on any other Jewish wisdom literature."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-121",
      "id": "footnote-1934-121-backlink"
    }
  }, [_vm._v("121")])]), _vm._v(" Gordon Fee examines the crucial wisdom texts in "), _c('a', {
    attrs: {
      "id": "p61"
    }
  }, [_vm._v("the Pauline corpus (1 Cor. 8:6; Col. 1:15–17) along with the crucial wisdom texts in the Jewish tradition where Wisdom is personified and said to be present with God when he created (Prov. 8:22–31; Sir. 24:3–22; Wis. 6:1–10:21). Fee’s conclusion is that “Wisdom is of virtually no—or very little—help in understanding Paul’s view of the preexistent Christ.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#footnote-1934-122",
      "id": "footnote-1934-122-backlink"
    }
  }, [_vm._v("122")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-13"
    }
  }, [_vm._v("b. Woman Wisdom a Type of Jesus Christ")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Nevertheless, the striking similarities between Solomon’s literary personification of his wisdom and John’s representation of Jesus Christ argue that Woman Wisdom is a type—that is to say, a divinely intended exemplar—of Jesus Christ:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Both existed with God before all things.")]), _vm._v(" "), _c('li', [_vm._v("Both played some role in creation.")]), _vm._v(" "), _c('li', [_vm._v("Both descended from heaven to dwell with humanity and were rejected by the masses.")]), _vm._v(" "), _c('li', [_vm._v("Both teach heavenly wisdom.")]), _vm._v(" "), _c('li', [_vm._v("Both call those who listen “children.”")]), _vm._v(" "), _c('li', [_vm._v("Both lead those who listen to life and immortality and threaten death to those who do not.")]), _vm._v(" "), _c('li', {
    staticClass: "bottom"
  }, [_vm._v("Both offer blessings in the symbols of food and drink."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-123",
      "id": "footnote-1934-123-backlink"
    }
  }, [_vm._v("123")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Typology, however, is not identity. Rather, the antitype will be similar and yet superior to the type.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-14"
    }
  }, [_vm._v("c. Conclusion")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("“In Christ,” says Paul, “are hidden all the treasures of wisdom and knowledge” (Col. 2:3–4). Therefore, while Christians prize Solomon’s wisdom, they do not substitute it for the person and work of Jesus Christ. Instead, they come to Proverbs recognizing that they now live in the heavenly Jerusalem with a greater-than-Solomon—with Jesus the mediator of a superior covenant—and with the sprinkled blood that speaks a better word than the blood of Abel (Matt. 12:42; Heb. 12:22–24). In love and faith, Christians hold fast what is good from the past and grasp the presence of Christ’s kingdom now, and with a certain hope they anticipate the consummation of all things.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-1-backlink",
      "id": "footnote-1934-1"
    }
  }, [_vm._v("1")]), _vm._v(". We refer to the book of Proverbs as “Proverbs” (capitalized) and individual proverbs as “proverbs.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-2-backlink",
      "id": "footnote-1934-2"
    }
  }, [_vm._v("2")]), _vm._v(". H. C. Washington, “Wealth and Poverty in the Instruction of Amenemope and the Hebrew Proverbs: A Comparative Case Study in the Social Location and Function of Ancient Near Eastern Wisdom Literature” (PhD diss., Princeton Theological Seminary, 1992), 194–97.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-3-backlink",
      "id": "footnote-1934-3"
    }
  }, [_vm._v("3")]), _vm._v(". J. Barr, “Prov. XI.31, 1 Pet IV.18,” "), _c('em', [_vm._v("JSS")]), _vm._v(" 20 (1975): 158–59.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-4-backlink",
      "id": "footnote-1934-4"
    }
  }, [_vm._v("4")]), _vm._v(". Proverbs is poorly attested in a few fragments of the Dead Sea Scrolls.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-5-backlink",
      "id": "footnote-1934-5"
    }
  }, [_vm._v("5")]), _vm._v(". We commonly use “proverbs” for Solomon’s aphorisms and “sayings” for the aphorisms of other sages.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-6-backlink",
      "id": "footnote-1934-6"
    }
  }, [_vm._v("6")]), _vm._v(". B. S. Childs, "), _c('em', [_vm._v("Introduction to the Old Testament as Scripture")]), _vm._v(" (Philadelphia: Fortress, 1979), 553, citing W. Zimmerli.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-7-backlink",
      "id": "footnote-1934-7"
    }
  }, [_vm._v("7")]), _vm._v(". They are sometimes referred to as “sentence proverbs.” See E. C. Lucas, "), _c('em', [_vm._v("Proverbs")]), _vm._v(","), _c('em'), _vm._v(" The Two Horizons Old Testament Commentary (Grand Rapids: Eerdmans, 2015), 3.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-8-backlink",
      "id": "footnote-1934-8"
    }
  }, [_vm._v("8")]), _vm._v(". To summarize the history of scholarship on this topic, which according to Michael V. Fox goes back to the twelfth century, is beyond the scope of this commentary. Fox ("), _c('em', [_vm._v("Proverbs 10–31: A New Translation with Introduction and Commentary")]), _vm._v(", AB 18B [New Haven: Yale University Press, 2009]) recognizes proverb clusters according to associative thinking but not as meaningful larger groupings. But Fox’s dismissal depends on several assumptions that I (Bruce) critique in my review of Fox, "), _c('em', [_vm._v("Proverbs 10–31")]), _vm._v(" in "), _c('em', [_vm._v("Review of Biblical Literature")]), _vm._v(" (February, 2010).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-9-backlink",
      "id": "footnote-1934-9"
    }
  }, [_vm._v("9")]), _vm._v(". R. C. Van Leeuwen, “Context and Meaning in Proverbs 25–27” (PhD diss., University of St. Michael’s College, 1984), 57–85.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-10-backlink",
      "id": "footnote-1934-10"
    }
  }, [_vm._v("10")]), _vm._v(". Bruce V. Malchow, “A Manual for Future Monarchs,” "), _c('em', [_vm._v("CBQ")]), _vm._v(" 47 (1985): 238–45.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-11-backlink",
      "id": "footnote-1934-11"
    }
  }, [_vm._v("11")]), _vm._v(". T. S. Eliot dedicated "), _c('em', [_vm._v("The Waste Land")]), _vm._v(" to Ezra Pound as “ll miglior fabbro” (“the better craftsman”). Pound’s revisions were so significant that some critics believe he deserves co-author credit. Mabel Loomis Todd infamously edited Emily Dickinson’s poems to make them suitable for nineteenth-century publication. (Thanks to Prof. Jeremiah Webster of Northwest University in Kirkland, Washington, for pointing me to these two cases.)")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-12-backlink",
      "id": "footnote-1934-12"
    }
  }, [_vm._v("12")]), _vm._v(". K. Kitchen, “Proverbs 2: Ancient Near Eastern Background,” in "), _c('em', [_vm._v("DOTWPW")]), _vm._v(", 552–53.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-13-backlink",
      "id": "footnote-1934-13"
    }
  }, [_vm._v("13")]), _vm._v(". E. A. W. Budge, "), _c('em', [_vm._v("Second Series of Facsimiles of Egyptian Hieratic Papyri in the British Museum")]), _vm._v(" (London: British Museum, 1923), plates 1–14.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-14-backlink",
      "id": "footnote-1934-14"
    }
  }, [_vm._v("14")]), _vm._v(". C. B. Kayatz, "), _c('em', [_vm._v("Studien zu Proverbien 1–9: Eine form- und motivgeschichtliche Untersuchung unter Einbeziehung ägyptischen Vergleichsmaterials")]), _vm._v(", WMANT 11 (Neukirchen-Vluyn: Neukirchener, 1966).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-15-backlink",
      "id": "footnote-1934-15"
    }
  }, [_vm._v("15")]), _vm._v(". W. F. Albright, “Some Canaanite-Phoenician Sources of Hebrew Wisdom,” in "), _c('em', [_vm._v("WIANE")]), _vm._v(", 9.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-16-backlink",
      "id": "footnote-1934-16"
    }
  }, [_vm._v("16")]), _vm._v(". M. J. Dahood, "), _c('em', [_vm._v("Proverbs and Northwest Semitic Philology")]), _vm._v(" (Rome: Biblical Institute, 1963); W. A. van der Weiden, "), _c('em', [_vm._v("Le Livre des Proverbs: Notes philolgiques")]), _vm._v(","), _c('em'), _vm._v(" BibOr 23 (Rome: Biblical Institute, 1970).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-17-backlink",
      "id": "footnote-1934-17"
    }
  }, [_vm._v("17")]), _vm._v(". D. M. Carr, "), _c('em', [_vm._v("An Introduction to the Old Testament: Sacred Texts and Imperial Contexts of the Hebrew Bible")]), _vm._v(" (Malden, MA: Wiley-Blackwell, 2010), 76.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-18-backlink",
      "id": "footnote-1934-18"
    }
  }, [_vm._v("18")]), _vm._v(". D. M. Carr, "), _c('em', [_vm._v("Formation of the Hebrew Bible")]), _vm._v(" (New York: Oxford University Press, 2011), 408.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-19-backlink",
      "id": "footnote-1934-19"
    }
  }, [_vm._v("19")]), _vm._v(". Solomonic authorship is contested primarily on the existence of pseudepigraphal writings in the ancient Near East and the Bible (especially Ecclesiastes) and on linguistic data. For a refutation arguing that Ecclesiastes is not a pseudepigraph, see B. K. Waltke, "), _c('em', [_vm._v("Proverbs: Chapters 1–15")]), _vm._v(", NICOT (Grand Rapids: Eerdmans, 2004)"), _c('em', [_vm._v(",")]), _vm._v(" 34–36; and Waltke, "), _c('em', [_vm._v("An Old Testament Theology")]), _vm._v(" (Grand Rapids: Zondervan, 2007), 948.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-20-backlink",
      "id": "footnote-1934-20"
    }
  }, [_vm._v("20")]), _vm._v(". According to N. Shupak (“The Instruction of Amenemope and Proverbs 22:17–24:22 from the Perspective of Contemporary Research,” in "), _c('em', [_vm._v("Seeking Out the Wisdom of the Ancients: Essays Offered to Honor Michael V. Fox on the Occasion of His 65th Birthday")]), _vm._v(", ed. Ronald L. Troxel, Kelvin G. Friebel, and Dennis R. Magary [Winona Lake, IN: Eisenbrauns, 2005], 216), the borrowing of Egyptian imagery “was done in a careful and considered manner: the Hebrew author or editor made changes and adapted the instructions of the Egyptian sage to the world of monotheistic belief.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-21-backlink",
      "id": "footnote-1934-21"
    }
  }, [_vm._v("21")]), _vm._v(". Adele Berlin (“Introduction to Hebrew Poetry"), _c('em', [_vm._v(",”")]), _vm._v(" in "), _c('em', [_vm._v("The New Interpreter’s Bible: Old Testament Survey")]), _vm._v(", ed. Leander E. Keck [Nashville: Abingdon, 2005], 169) offers a good example of terseness by comparing the prose version of Judges 4:19 with its poetic equivalent in 5:19:")]), _vm._v(" "), _c('p', {
    staticClass: "fnext"
  }, [_vm._v("Then he said to her; “Please give me a little water to drink; for I am thirsty.” So she opened a skin of milk, gave him a drink, and covered him. (Judg. 4:19)")]), _vm._v(" "), _c('p', {
    staticClass: "fn-ind"
  }, [_vm._v("“Water,” he asked; milk she gave;")]), _vm._v(" "), _c('p', {
    staticClass: "fn-ind"
  }, [_vm._v("in a princely bowl she brought him curds. (Judg. 5:25)")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes-para"
  }, [_vm._v("The prose version carries the reader step by step along the narrative sequence of Jael’s providing for Sisera’s need, but the terse poetic version highlights her largess to put him at ease for the kill. Prose is like a film; poetry is like a slide show, in which each verse closes with a click.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-22-backlink",
      "id": "footnote-1934-22"
    }
  }, [_vm._v("22")]), _vm._v(". This may be why the sages call on their disciples to memorize all of the proverbs (22:18).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-23-backlink",
      "id": "footnote-1934-23"
    }
  }, [_vm._v("23")]), _vm._v(". L. Wilson ("), _c('em', [_vm._v("Proverbs")]), _vm._v(", TOTC [Downers Grove, IL: InterVarsity, 2017], 7) refers to parallelism as “a kind of ‘thought rhyme.’”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-24-backlink",
      "id": "footnote-1934-24"
    }
  }, [_vm._v("24")]), _vm._v(". James Kugel ("), _c('em', [_vm._v("The Idea of Biblical Poetry: Parallelism and Its History")]), _vm._v(" [Baltimore: The Johns Hopkins University Press, 1981]) contends that in parallelism, the second line expands upon the first in a multitude of ways. He articulates the way in which the second line develops the first with the phrase: “A is so, and "), _c('em', [_vm._v("what’s more")]), _vm._v(", B is so” (his emphasis).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-25-backlink",
      "id": "footnote-1934-25"
    }
  }, [_vm._v("25")]), _vm._v(". A. Berlin, "), _c('em', [_vm._v("Poetics and Interpretation of Biblical Narrative")]), _vm._v(", JSOTSup 9 (Sheffield: Almond Press, 1983), 15.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-26-backlink",
      "id": "footnote-1934-26"
    }
  }, [_vm._v("26")]), _vm._v(". Waltke, "), _c('em', [_vm._v("Old Testament Theology")]), _vm._v(", 119.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-27-backlink",
      "id": "footnote-1934-27"
    }
  }, [_vm._v("27")]), _vm._v(". Waltke, "), _c('em', [_vm._v("Old Testament Theology")]), _vm._v(", 120.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-28-backlink",
      "id": "footnote-1934-28"
    }
  }, [_vm._v("28")]), _vm._v(". D. Garrett, "), _c('em', [_vm._v("Proverbs, Ecclesiastes, Song of Solomon")]), _vm._v(", NAC 14 (Nashville: Broadman, 1983), 212.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-29-backlink",
      "id": "footnote-1934-29"
    }
  }, [_vm._v("29")]), _vm._v(". For example, in Proverbs, the word "), _c('em', [_vm._v("petî")]), _vm._v(", from a root meaning “open,” means open to other worldviews (i.e., “uncommitted” to truth) and so is related to the fool. In the Psalms, however, "), _c('em', [_vm._v("petî")]), _vm._v(" has the sense of open to God (i.e. “pious”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-30-backlink",
      "id": "footnote-1934-30"
    }
  }, [_vm._v("30")]), _vm._v(". The author of Hebrews recognized that “in the past God spoke to our ancestors through the prophets at many times and "), _c('em', [_vm._v("in various ways")]), _vm._v("” (1:1, our emphasis).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-31-backlink",
      "id": "footnote-1934-31"
    }
  }, [_vm._v("31")]), _vm._v(". Similarly, Qoheleth (“teacher” or “gatherer”) begins his treatise in Ecclesiastes by observing the cycles of creation that appear to him a “chasing after wind”/“vexation of spirit.” He tells of his quest for wisdom by reflecting on his experiences under the sun. Job also bases his reflections on his experience of misery, for which he found no relief until "), _c('em', [_vm._v("I AM")]), _vm._v(" opened his eyes to observe that chaos and death in creation are not absolute but are divinely bounded by order and life (Job 38–41).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-32-backlink",
      "id": "footnote-1934-32"
    }
  }, [_vm._v("32")]), _vm._v(". G. M. Landers, “Johan: A māšāl?,”"), _c('em'), _vm._v(" in "), _c('em', [_vm._v("Israelite Wisdom")]), _vm._v(", ed. J. G. Gammie et al. (Missoula, MT: Scholars, 1978), 140, following W. McKane, "), _c('em', [_vm._v("Proverbs: A New Approach")]), _vm._v(","), _c('em'), _vm._v(" OTL (Philadelphia: Westminster, 1970), 23–33.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-33-backlink",
      "id": "footnote-1934-33"
    }
  }, [_vm._v("33")]), _vm._v(". A. S. Herbert, “The ‘Parable’ (MĀŠĀL) in the Old Testament,” "), _c('em', [_vm._v("SJT")]), _vm._v(" 7 (1954): 180–96.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-34-backlink",
      "id": "footnote-1934-34"
    }
  }, [_vm._v("34")]), _vm._v(". R. C. Van Leeuwen, “The Book of Proverbs,” in "), _c('em', [_vm._v("The New Interpreter’s Bible: Old Testament Survey")]), _vm._v(", ed. Leander E. Keck (Nashville: Abingdon, 2005), 241.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-35-backlink",
      "id": "footnote-1934-35"
    }
  }, [_vm._v("35")]), _vm._v(". R. N. Whybray, "), _c('em', [_vm._v("Wealth and Poverty in the Book of Proverbs")]), _vm._v(", JSOTSup 99 (Sheffield: Sheffield Academic, 1990), 47.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-36-backlink",
      "id": "footnote-1934-36"
    }
  }, [_vm._v("36")]), _vm._v(". M. V. Fox, “The Social Location of the Book of Proverbs,” in "), _c('em', [_vm._v("Texts, Temples, and Traditions:")]), _vm._v(" "), _c('em', [_vm._v("A Tribute to Menahem Haran,")]), _vm._v(" ed. M. V. Fox et al. (Winona Lake, IN: Eisenbrauns, 1996), 233. Fox also notes that in Proverbs, when an agricultural setting is the context, the saying usually addresses wealthy landowners and not peasants.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-37-backlink",
      "id": "footnote-1934-37"
    }
  }, [_vm._v("37")]), _vm._v(". E. C. Lucas, "), _c('em', [_vm._v("Exploring the Old Testament: A Guide to the Psalms and Wisdom Literature")]), _vm._v(" (Downers Grove, IL: InterVarsity, 2003), 82. Similarly, Fox, “Social Location,” 231: “Apart from the supposed Egyptian analogy, there is nothing in Proverbs to point to a school origin.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-38-backlink",
      "id": "footnote-1934-38"
    }
  }, [_vm._v("38")]), _vm._v(". D. M. Carr, "), _c('em', [_vm._v("Writing on the Tablet of the Heart: Origins of Scripture and Literature")]), _vm._v(" (New York: Oxford University Press, 2005), 12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-39-backlink",
      "id": "footnote-1934-39"
    }
  }, [_vm._v("39")]), _vm._v(". According to H. Freedman (“Kiddushin,” in "), _c('em', [_vm._v("The Babylonian Talmud")]), _vm._v(", ed. I. Epstein, vol. 4 [London: Soncino, 1948], 140 n. 8), the introduction of schools in Judaism is variously ascribed to the reforms of R. Simeon b. Shetah and the high priest Joshua b. Gamala.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-40-backlink",
      "id": "footnote-1934-40"
    }
  }, [_vm._v("40")]), _vm._v(". Carr, "), _c('em', [_vm._v("Writing")]), _vm._v(", 129–30.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-41-backlink",
      "id": "footnote-1934-41"
    }
  }, [_vm._v("41")]), _vm._v(". Fox, “Social Location,” 232: “Ethical testaments are instructions written by men in their maturity for the religious-ethical guidance of their sons and, sometimes, daughters. These texts are, in fact, descendants of ancient Wisdom Literature, since they use Proverbs as a model…. The father addresses his son (or sons) and through him speaks to a larger audience.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-42-backlink",
      "id": "footnote-1934-42"
    }
  }, [_vm._v("42")]), _vm._v(". See B. K. Waltke, “The Book of Proverbs and Old Testament Theology,” "), _c('em', [_vm._v("BSac")]), _vm._v(" 136 (1979): 302–17.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-43-backlink",
      "id": "footnote-1934-43"
    }
  }, [_vm._v("43")]), _vm._v(". Childs ("), _c('em', [_vm._v("Introduction")]), _vm._v(", 558) states, “It is striking that the patterns of human behavior which the Proverbs inculcate overlap to a large extent with that set of ethical standards prescribed in the Pentateuch for the covenant people…. Both the Proverbs and the Law call for a commitment to God and his divine order.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-44-backlink",
      "id": "footnote-1934-44"
    }
  }, [_vm._v("44")]), _vm._v(". D. Kidner, "), _c('em', [_vm._v("The Proverbs")]), _vm._v(","), _c('em'), _vm._v(" TOTC (Downers Grove, IL: InterVarsity, 1964), 13. Cf. John Goldingay, “The ‘Salvation History’ Perspective and the ‘Wisdom’ Perspective within the Context of Biblical Theology,” "), _c('em', [_vm._v("EvQ")]), _vm._v(" 51 (1979): 194ff.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-45-backlink",
      "id": "footnote-1934-45"
    }
  }, [_vm._v("45")]), _vm._v(". See B. K. Waltke, “Righteousness in Proverbs,” "), _c('em', [_vm._v("WTJ")]), _vm._v(" 70 (2008): 225–37.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-46-backlink",
      "id": "footnote-1934-46"
    }
  }, [_vm._v("46")]), _vm._v(". See Waltke, “Proverbs and Old Testament Theology,” 305.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-47-backlink",
      "id": "footnote-1934-47"
    }
  }, [_vm._v("47")]), _vm._v(". Waltke, "), _c('em', [_vm._v("Old Testament Theology")]), _vm._v(", 903.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-48-backlink",
      "id": "footnote-1934-48"
    }
  }, [_vm._v("48")]), _vm._v(". Childs ("), _c('em', [_vm._v("Introduction")]), _vm._v(", 548) concurs: “Of course the uniquely Hebrew stamp which Israel gave its borrowed material has not been denied.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-49-backlink",
      "id": "footnote-1934-49"
    }
  }, [_vm._v("49")]), _vm._v(". R. N. Whybray, "), _c('em', [_vm._v("Wisdom in Proverbs: The Concept of Wisdom in Proverbs 1–9")]), _vm._v(" (London: SCM, 1965), 96.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-50-backlink",
      "id": "footnote-1934-50"
    }
  }, [_vm._v("50")]), _vm._v(". See Whybray, "), _c('em', [_vm._v("Wisdom in Proverbs")]), _vm._v(", 96.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-51-backlink",
      "id": "footnote-1934-51"
    }
  }, [_vm._v("51")]), _vm._v(". Gareth Cook, “The Moral Life of Babies,” "), _c('em', [_vm._v("Scientific American,")]), _vm._v(" November 12, 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-52-backlink",
      "id": "footnote-1934-52"
    }
  }, [_vm._v("52")]), _vm._v(". B. K. Waltke and J. M. Houston, "), _c('em', [_vm._v("The Psalms as Christian Praise")]), _vm._v(" (Grand Rapids: Eerdmans, 2019), 131–42.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-53-backlink",
      "id": "footnote-1934-53"
    }
  }, [_vm._v("53")]), _vm._v(". Kidner, "), _c('em', [_vm._v("Proverbs")]), _vm._v(", 141.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-54-backlink",
      "id": "footnote-1934-54"
    }
  }, [_vm._v("54")]), _vm._v(". Lennart Boström, "), _c('em', [_vm._v("The God of the Sages: The Portrayal of God in the Book of Proverbs")]), _vm._v(", ConBOT 29 (Stockholm: Almqvist Wiksell, 1990), 145.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-55-backlink",
      "id": "footnote-1934-55"
    }
  }, [_vm._v("55")]), _vm._v(". Van Leeuwen (“Proverbs,” in "), _c('em', [_vm._v("NIB: Old Testament Survey")]), _vm._v(", 244) comments, “One saying calls for another to qualify it, or for a biblical story to flesh it out…. Brief as proverbs are, no one saying contains the whole truth. Reality is too rich and complex for that.” McKane ("), _c('em', [_vm._v("Proverbs")]), _vm._v(") built his commentary on separating humanistic sayings from theological sayings. His new approach floundered because rhetorical criticism demonstrates the two types are intentionally unified.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-56-backlink",
      "id": "footnote-1934-56"
    }
  }, [_vm._v("56")]), _vm._v(". Cf. J. Goldingay, “The Arrangement of Sayings in Proverbs 1–15,” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 61 (1994): 75–83.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-57-backlink",
      "id": "footnote-1934-57"
    }
  }, [_vm._v("57")]), _vm._v(". R. C. Van Leeuwen, “Wisdom Literature,” in "), _c('em', [_vm._v("Dictionary for Theological Interpretation of the Bible")]), _vm._v(", ed. K. J. Vanhoozer et al. (Grand Rapids: Baker Academic, 2005), 847. Cf. C. G. Bartholomew and R. O’Dowd, "), _c('em', [_vm._v("Old Testament Wisdom Literature: A Theological Introduction")]), _vm._v(" (Downers Grove, IL: IVP Academic, 2011), 23–31.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-58-backlink",
      "id": "footnote-1934-58"
    }
  }, [_vm._v("58")]), _vm._v(". E. W. Heaton, "), _c('em', [_vm._v("The Hebrew Kingdoms")]), _vm._v(" (Oxford: Oxford University Press, 1986), 165.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-59-backlink",
      "id": "footnote-1934-59"
    }
  }, [_vm._v("59")]), _vm._v(". For a summary of the various scholarly proposals, see Lucas, "), _c('em', [_vm._v("Proverbs")]), _vm._v(", 251–73.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-60-backlink",
      "id": "footnote-1934-60"
    }
  }, [_vm._v("60")]), _vm._v(". T. Longman III (“Woman Wisdom and Woman Folly,” in "), _c('em', [_vm._v("DOTWPW")]), _vm._v(", 913) bases this identification on the location of Woman Wisdom’s house at the highest point in the city—a location only occupied by the palace in the ancient Near East.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-61-backlink",
      "id": "footnote-1934-61"
    }
  }, [_vm._v("61")]), _vm._v(". See Fox, "), _c('em', [_vm._v("Proverbs 1–9: A New Translation with Introduction and Commentary")]), _vm._v(", AB 18A (New York: Doubleday, 2000); Wilson, "), _c('em', [_vm._v("Proverbs")]), _vm._v(", 11, 319.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-62-backlink",
      "id": "footnote-1934-62"
    }
  }, [_vm._v("62")]), _vm._v(". BAGD, 893, s.v. "), _c('em', [_vm._v("psychē")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-63-backlink",
      "id": "footnote-1934-63"
    }
  }, [_vm._v("63")]), _vm._v(". Kayatz, "), _c('em', [_vm._v("Proverbien 1–9")]), _vm._v(", 45.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-64-backlink",
      "id": "footnote-1934-64"
    }
  }, [_vm._v("64")]), _vm._v(". See R. G. Bratcher, “Biblical Words Describing Man: Breath, Life, Spirit,” "), _c('em', [_vm._v("BT")]), _vm._v(" 34 (1983): 204.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-65-backlink",
      "id": "footnote-1934-65"
    }
  }, [_vm._v("65")]), _vm._v(". K. M. Heim, “Structure and Context in Proverbs 10:1–22:16” (PhD diss., University of Liverpool, 1996), 54–86.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-66-backlink",
      "id": "footnote-1934-66"
    }
  }, [_vm._v("66")]), _vm._v(". See Waltke, “Righteousness,” 233.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-67-backlink",
      "id": "footnote-1934-67"
    }
  }, [_vm._v("67")]), _vm._v(". Lucas ("), _c('em', [_vm._v("Proverbs")]), _vm._v(", 219) notes that “teachableness” is the most frequently mentioned attribute of the wise in Proverbs: “About 40 percent of the sayings which explicitly mention the wise refer to this in one way or another.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-68-backlink",
      "id": "footnote-1934-68"
    }
  }, [_vm._v("68")]), _vm._v(". So W. McKane, "), _c('em', [_vm._v("Prophets and Wise Men")]), _vm._v(" (London: SCM, 1965), 67.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-69-backlink",
      "id": "footnote-1934-69"
    }
  }, [_vm._v("69")]), _vm._v(". M. V. Fox, “Words for Wisdom,” "), _c('em', [_vm._v("ZAH")]), _vm._v(" 6 (1993): 158–59.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-70-backlink",
      "id": "footnote-1934-70"
    }
  }, [_vm._v("70")]), _vm._v(". Fox, “Words for Wisdom,” 160–61, who says further, “This power will protect you from the temptations of the wicked man and woman (2:11; 5:2f), because when they try to seduce you to their ways, you will be able to look inward, maintain independence of thought, and stand up to their inveiglements.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-71-backlink",
      "id": "footnote-1934-71"
    }
  }, [_vm._v("71")]), _vm._v(". In the Prologue (1:4; 2:11; 3:21; 5:2: 8:12) and Collection VII (31:16), "), _c('em', [_vm._v("m")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("zimmâ")]), _vm._v(" has a positive connotation. In the rest of the collections, it has a negative connotation (10:23; 21:27; 24:8, 9; 30:32).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-72-backlink",
      "id": "footnote-1934-72"
    }
  }, [_vm._v("72")]), _vm._v(". Chou-Wee Pan, “A Study of the Vocabulary of Education in Proverbs” (PhD diss., University of Newcastle upon Tyne, 1987), 106.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-73-backlink",
      "id": "footnote-1934-73"
    }
  }, [_vm._v("73")]), _vm._v(". Fox, “Words for Wisdom,” 154. In the parlance of modern neuroscience, "), _c('em', [_vm._v("t")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("bûnâ")]), _vm._v(" could be correlated with the task-oriented, problem-solving, pragmatic network of the brain—what neuroscientists call the task-positive network. "), _c('em', [_vm._v("Bînâ")]), _vm._v(" roughly correlates with the creative, emotionally self-aware, ethical decision-making network labelled the default mode network. Ancients may have been aware of these two aspects of human thinking that modern brain physiology is now discovering and labelling. See R. Boyatzis, K. Rochford and A. I. Jack, “Review Article: Antagonistic Neural Networks Underlying Differentiated Leadership Roles"), _c('em', [_vm._v(",” Frontiers in Human Neuroscience")]), _vm._v(", March 4, 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-74-backlink",
      "id": "footnote-1934-74"
    }
  }, [_vm._v("74")]), _vm._v(". Lucas, "), _c('em', [_vm._v("Proverbs")]), _vm._v(", 222.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-75-backlink",
      "id": "footnote-1934-75"
    }
  }, [_vm._v("75")]), _vm._v(". Waltke, “Righteousness,” 236.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-76-backlink",
      "id": "footnote-1934-76"
    }
  }, [_vm._v("76")]), _vm._v(". There is one nonethical, metaphorical use in 23:31, where it refers to wine that goes down “smoothly.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-77-backlink",
      "id": "footnote-1934-77"
    }
  }, [_vm._v("77")]), _vm._v(". Cf. K. Koch, "), _c('em', [_vm._v("TLOT")]), _vm._v(", 3:1427, s.v. "), _c('em', [_vm._v("tmm")]), _vm._v("; B. K. Waltke with C. J. Fredricks, "), _c('em', [_vm._v("Genesis: A Commentary")]), _vm._v(" (Grand Rapids: Zondervan, 2001), 362.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-78-backlink",
      "id": "footnote-1934-78"
    }
  }, [_vm._v("78")]), _vm._v(". Cf. A. Jepsen, "), _c('em', [_vm._v("TDOT")]), _vm._v(", 1:317, s.v. "), _c('em', [_vm._v("’āman")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-79-backlink",
      "id": "footnote-1934-79"
    }
  }, [_vm._v("79")]), _vm._v(". Bartholomew and O’Dowd ("), _c('em', [_vm._v("Old Testament Wisdom")]), _vm._v(", 80–81) questionably use “fear of "), _c('em', [_vm._v("I AM")]), _vm._v("” (1:7; 9:10; 10:27; 31:30) as a literary marker to divide the book into three major collections (1–9; 10–29; 30–31).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-80-backlink",
      "id": "footnote-1934-80"
    }
  }, [_vm._v("80")]), _vm._v(". See B. K. Waltke, “The Fear of the Lord,” in "), _c('em', [_vm._v("Alive to God: Essays in Honour of James D. Houston")]), _vm._v(", edited by J. I. Packer and L. Wilkinson (Downers Grove, IL: InterVarsity Press, 1992).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-81-backlink",
      "id": "footnote-1934-81"
    }
  }, [_vm._v("81")]), _vm._v(". C. Bridges, "), _c('em', [_vm._v("An Exposition of Proverbs")]), _vm._v(" (Evansville: Sovereign Grace Book Club, 1959), 3–4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-82-backlink",
      "id": "footnote-1934-82"
    }
  }, [_vm._v("82")]), _vm._v(". H.-G. Gadamer, "), _c('em', [_vm._v("Truth and Method")]), _vm._v(", trans. J. Weinsheimer and D. Marshall, 2nd rev. ed. (New York: Continuum, 1989), 17.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-83-backlink",
      "id": "footnote-1934-83"
    }
  }, [_vm._v("83")]), _vm._v(". D. A. Hubbard, "), _c('em', [_vm._v("Proverbs")]), _vm._v(" (Dallas: Word, 1989), 214. The British anthropologist and evolutionary psychologist Robin Dunbar, in his book "), _c('em', [_vm._v("Grooming, Gossip, and the Evolution of Language")]), _vm._v(" (Cambridge, MA: Harvard University Press, 1996), argues that human language evolved from gossip to maintain the harmony and balance of social networks—which otherwise would devolve into violence. While Dunbar’s evolutionary presuppositions are debatable, his main point that language "), _c('em', [_vm._v("primarily")]), _vm._v(" serves to bond and cohere humans is one that Proverbs affirms.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-84-backlink",
      "id": "footnote-1934-84"
    }
  }, [_vm._v("84")]), _vm._v(". Kidner, "), _c('em', [_vm._v("Proverbs")]), _vm._v(", 46.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-85-backlink",
      "id": "footnote-1934-85"
    }
  }, [_vm._v("85")]), _vm._v(". W. Cosser, “The Meaning of ‘Life’ ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("Ḥ")]), _c('em', [_vm._v("ayyîm")]), _vm._v(") in Proverbs, Job, and Ecclesiastes,” "), _c('em', [_vm._v("GUOST")]), _vm._v(" 15 (1955): 48–53.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-86-backlink",
      "id": "footnote-1934-86"
    }
  }, [_vm._v("86")]), _vm._v(". K. T. Aitken ("), _c('em', [_vm._v("Proverbs")]), _vm._v(" [Philadelphia: Westminster John Knox Press, 1986], 43) suggested that the sages were too optimistic: “There is a strong suspicion here that Israel’s sages have confused their belief about what ought to be the case with what actually is the case.” G. Von Rad ("), _c('em', [_vm._v("Wisdom in Israel")]), _vm._v(" [London: SCM, 1972], 233) goes further. Pitting Qoheleth against the sages, he accuses the latter of becoming “entangled in a single false doctrine.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-87-backlink",
      "id": "footnote-1934-87"
    }
  }, [_vm._v("87")]), _vm._v(". K. Farmer, "), _c('em', [_vm._v("Who Knows What Is Good? A Commentary on the Books of Proverbs and Ecclesiastes")]), _vm._v(" (Grand Rapids: Eerdmans, 1991), 206.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-88-backlink",
      "id": "footnote-1934-88"
    }
  }, [_vm._v("88")]), _vm._v(". J. A. Gladson, “Retributive Paradoxes in Proverbs 10–29” (PhD diss., Vanderbilt University, 1978).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-89-backlink",
      "id": "footnote-1934-89"
    }
  }, [_vm._v("89")]), _vm._v(". K. H. Richards, “A Form and Traditio-Historical Study of "), _c('em', [_vm._v("Rš‘")]), _vm._v("” (PhD diss., Claremont, 1970).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-90-backlink",
      "id": "footnote-1934-90"
    }
  }, [_vm._v("90")]), _vm._v(". R. C. Van Leeuwen, "), _c('em', [_vm._v("TLOT")]), _vm._v(", 3:1262, s.v. "), _c('em', [_vm._v("rš‘")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-91-backlink",
      "id": "footnote-1934-91"
    }
  }, [_vm._v("91")]), _vm._v(". W. Brueggemann (“A Neglected Sapiential Word Pair,” "), _c('em', [_vm._v("ZAW")]), _vm._v(" 89 [1977]: 244) notes that the perverse act is apart from and against the community in favor of self (see 10:9).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-92-backlink",
      "id": "footnote-1934-92"
    }
  }, [_vm._v("92")]), _vm._v(". Fools may have a high IQ, but they don’t know how to live. D. Goleman ("), _c('em', [_vm._v("Emotional Intelligence")]), _vm._v(" [New York: Bantam Books, 1995]) speaks of “emotional intelligence” (EQ). EQ refers to social skills and so is similar to “wisdom” in Proverbs. Goleman discovered that “the men with the highest test scores in college were not particularly successful compared to their lower-scoring peers in terms of salary, productivity, or status in their field. Nor did they have great life satisfaction, nor the most happiness with friendship, family, and romantic relationships” (35).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-93-backlink",
      "id": "footnote-1934-93"
    }
  }, [_vm._v("93")]), _vm._v(". T. Donald, “The Semantic Field of ‘Folly’ in Proverbs, Job, Psalms, and Ecclesiastes,” "), _c('em', [_vm._v("VT")]), _vm._v(" 13 (1963): 287.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-94-backlink",
      "id": "footnote-1934-94"
    }
  }, [_vm._v("94")]), _vm._v(". "), _c('em', [_vm._v("AEL")]), _vm._v(", 1:74–75.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-95-backlink",
      "id": "footnote-1934-95"
    }
  }, [_vm._v("95")]), _vm._v(". Fox, "), _c('em', [_vm._v("Proverbs 1–9")]), _vm._v(", 40.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-96-backlink",
      "id": "footnote-1934-96"
    }
  }, [_vm._v("96")]), _vm._v(". McKane, "), _c('em', [_vm._v("Proverbs")]), _vm._v(", 399.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-97-backlink",
      "id": "footnote-1934-97"
    }
  }, [_vm._v("97")]), _vm._v(". Here, we lean heavily on a paper by Bruce’s student, D. Phillip Roberts, “The Sluggard in Proverbs” (unpublished term paper, OT 813, Westminster Theological Seminary, 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-98-backlink",
      "id": "footnote-1934-98"
    }
  }, [_vm._v("98")]), _vm._v(". E.g., Sheol has a “mouth” (Ps. 141:7), which it “enlarges” (Isa. 5:14). It is “never satisfied” (Prov. 27:20; 30:16) and lets no one out of its “grip” (Ps. 89:48; Song 8:6), although some are redeemed from it (Ps. 49:15; Prov. 23:14; Hos. 13:14). It is like a prison with “cords” (2 Sam. 22:6) and a land that has “gates” (Isa. 38:10) with “bars” (Job 17:16). In Sheol, corruption is “the father” and the worm “the mother and sister” (Job 17:13ff.). It is a “land” from which none return to this life (Job 7:9). It equalizes all: rich and poor (Job 3:18–19), righteous and wicked (3:17), regardless of their moral choices, lie together. It is a land of silence (Ps. 94:17), darkness (13:13), weakness, and oblivion (Ps. 88:11–19). Sheol’s destructive nature is highlighted by the addition of “Abaddon” (Prov. 15:11; 27:20).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-99-backlink",
      "id": "footnote-1934-99"
    }
  }, [_vm._v("99")]), _vm._v(". The NIV (2011) translates "), _c('em', [_vm._v("š")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("’ôl")]), _vm._v(" with “realm of the dead.” It is problematic to speculate about an intermediate state from the figurative descriptions of Sheol.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-100-backlink",
      "id": "footnote-1934-100"
    }
  }, [_vm._v("100")]), _vm._v(". Here, we reflect the normative biblical assumption that biological sex and gender identity do not vary independently (cf. Gen. 1:27). While some contest this assumption today, this commentary is not the place to debate it.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-101-backlink",
      "id": "footnote-1934-101"
    }
  }, [_vm._v("101")]), _vm._v(". Of course, the whole book is addressed to the son with the implication that wisdom will make him an ideal husband, but that point is not made explicitly.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-102-backlink",
      "id": "footnote-1934-102"
    }
  }, [_vm._v("102")]), _vm._v(". So A. Moss, “Wisdom as Parental Teaching in Proverbs 1–9,” "), _c('em', [_vm._v("HeyJ")]), _vm._v(" 38 (1997): 426–39. The mention of the mother at the book’s seams—at the beginning of the Prologue (1:8) and of the proverbs (10:1)—validates this interpretation.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-103-backlink",
      "id": "footnote-1934-103"
    }
  }, [_vm._v("103")]), _vm._v(". E. Follis, "), _c('em', [_vm._v("Directions in Biblical Hebrew Poetry")]), _vm._v(", JSOTSup 40 (Sheffield: Sheffield Academic, 1987), 178. The gender differences noted by Follis appear to be supported by numerous social-scientific studies, which show that these differences are not primarily due to socialization but are biologically based. See Y. Weisberg, C. DeYoung, and J. Hirsh, “Gender Differences in Personality across the Ten Aspects of the Big Five,” "), _c('em', [_vm._v("Frontiers in Psychology")]), _vm._v(", August 1, 2011; D. Schmitt et al., “Personality and gender differences in global perspective,” "), _c('em', [_vm._v("International Journal of Psychology")]), _vm._v(" 52 (2016): 45–56; M. Del Giudice, T. Booth, and P. Irwing, “The Distance Between Mars and Venus: Measuring Global Sex Differences in Personality,” "), _c('em', [_vm._v("PLOS One")]), _vm._v(", January 4, 2012.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-104-backlink",
      "id": "footnote-1934-104"
    }
  }, [_vm._v("104")]), _vm._v(". Fox ("), _c('em', [_vm._v("Proverbs 1–9,")]), _vm._v(" 134–41) lists six ways of understanding this figure and concludes that she is “strange” ("), _c('em', [_vm._v("zārâ")]), _vm._v(") because she is another man’s wife and therefore “strange” to all men but her husband.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-105-backlink",
      "id": "footnote-1934-105"
    }
  }, [_vm._v("105")]), _vm._v(". According to R. E. Murphy and O. Carm (“Wisdom and Eros in Proverbs 1–9,” "), _c('em', [_vm._v("CBQ")]), _vm._v(" 50 [1998]: 600), this woman is the subject of some sixty-five verses, more than “any other figure, even … Lady Wisdom.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-106-backlink",
      "id": "footnote-1934-106"
    }
  }, [_vm._v("106")]), _vm._v(". G. Yee (“‘I Have Perfumed My Bed with Myrrh’: The Foreign Woman ["), _c('em', [_vm._v("’Iššâ Zārâ")]), _vm._v("] in Proverbs 1–9,” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 43 [1989]: 54) argues that the adulteress in the Prologue is one woman described variously.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-107-backlink",
      "id": "footnote-1934-107"
    }
  }, [_vm._v("107")]), _vm._v(". Here a “prostitute” signifies one who engages in sex with no intention of an enduring relationship, not one who engages in sex for payment. The Akkadian Counsel of Wisdom warns youths not to marry a (temple) prostitute, and the Proverbs of Ahikar warns them not to lust after her (see H. W. F. Saggs, "), _c('em', [_vm._v("The Greatness That Was Babylon")]), _vm._v(" [New York: New American Library; Times Mirror, 1962], 332; F. C. Conybeare, J. R. Harris, A. S. Smith, “The Story of Ahikar,” in "), _c('em', [_vm._v("The Apocrypha and Pseudepigrapha of the Old Testament")]), _vm._v(", ed. R. H. Charles, vol. 2 [Oxford: Clarendon, 1976], 728–29). Prostitution was accepted and regulated in the ancient Near East (see J. Gasper, "), _c('em', [_vm._v("Social Ideas in the Wisdom Literature of the Old Testament")]), _vm._v(" [Washington, DC: The Catholic University of America, 1947], 11 n. 49). The Mosaic law, however, strictly prohibited Israelite women from roles as prostitutes (Lev. 19:29), prohibited and condemned cultic prostitution (Deut. 23:18), and presented monogamy as the ideal (Gen. 2:18–25). No law, however, explicitly prohibited harlotry with a foreigner, as do these texts in Proverbs. The New Testament threatens God’s judgment for all sorts of sexual immorality outside of marriage (1 Cor. 6:9–20) and prescribes marriage as an anodyne against sexual uncleanness (1 Cor. 7:2).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-108-backlink",
      "id": "footnote-1934-108"
    }
  }, [_vm._v("108")]), _vm._v(". L. A. Snijders, "), _c('em', [_vm._v("TDOT")]), _vm._v(", 4:53, s.v. "), _c('em', [_vm._v("zûr")]), _vm._v("/"), _c('em', [_vm._v("zār")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-109-backlink",
      "id": "footnote-1934-109"
    }
  }, [_vm._v("109")]), _vm._v(". R. Martin-Achard ("), _c('em', [_vm._v("TLOT")]), _vm._v(", 1:391–92, s.v. "), _c('em', [_vm._v("zār")]), _vm._v(") writes, “The other is the outsider whose behavior endangers the existence of the group because he/she stands outside the laws of the community….Thus "), _c('em', [_vm._v("zār")]), _vm._v(" ‘other’ can acquire a rather negative meaning (‘dangerous, hostile’).”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-110-backlink",
      "id": "footnote-1934-110"
    }
  }, [_vm._v("110")]), _vm._v(". Snijders (“The Meaning of "), _c('em', [_vm._v("Zār")]), _vm._v(" in the Old Testament,” "), _c('em', [_vm._v("OtSt")]), _vm._v(" [1954]: 1–54) says no, while J. K. Wiles (“The ‘Enemy’ in Israelite Wisdom Literature” [PhD diss., Southern Baptist Theological Seminary, 1982], 50) says yes: “She is an unfaithful foreigner married to an Israelite.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-111-backlink",
      "id": "footnote-1934-111"
    }
  }, [_vm._v("111")]), _vm._v(". G. Boström, "), _c('em', [_vm._v("Proverbiastudien: Die Weisheit und das fremde Weib in Spr. 1–9")]), _vm._v(", LUÅ (Lund: Gleerup, 1935).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-112-backlink",
      "id": "footnote-1934-112"
    }
  }, [_vm._v("112")]), _vm._v(". Kühlewein, "), _c('em', [_vm._v("TLOT")]), _vm._v(", 3:1243–44, s.v. "), _c('em', [_vm._v("rēa‘.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-113-backlink",
      "id": "footnote-1934-113"
    }
  }, [_vm._v("113")]), _vm._v(". M. Weinfeld, "), _c('em', [_vm._v("TDOT")]), _vm._v(", 2:255, 256, 261, s.v. "), _c('em', [_vm._v("b")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("rît.")]), _vm._v(" Ezek. 16:8 uses "), _c('em', [_vm._v("b")]), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ǝ")]), _c('em', [_vm._v("rît")]), _vm._v(" in reference to marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-114-backlink",
      "id": "footnote-1934-114"
    }
  }, [_vm._v("114")]), _vm._v(". Pace Fox, "), _c('em', [_vm._v("Proverbs 1–9")]), _vm._v(", 139–40.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-115-backlink",
      "id": "footnote-1934-115"
    }
  }, [_vm._v("115")]), _vm._v(". Irenaeus equated Wisdom with the Holy Spirit. See "), _c('em', [_vm._v("Against Heresies")]), _vm._v(" 4.20.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-116-backlink",
      "id": "footnote-1934-116"
    }
  }, [_vm._v("116")]), _vm._v(". A. L. Clayton, “The Orthodox Recovery of a Heretical Proof-Text: Athanasius of Alexandria’s Interpretation of Proverbs 8:22–30 in Conflict with the Arians” (PhD diss., Southern Methodist University, 1988), 32–51.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-117-backlink",
      "id": "footnote-1934-117"
    }
  }, [_vm._v("117")]), _vm._v(". There is no direct evidence in Hellenistic Jewish wisdom literature that links Wisdom in Prov. 8 to Wisdom as an agent in creation. If there were, it might have led the apostles to link Jesus the Creator with Wisdom.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-118-backlink",
      "id": "footnote-1934-118"
    }
  }, [_vm._v("118")]), _vm._v(".R. Bauckham ("), _c('em', [_vm._v("Jesus and the God of Israel: God Crucified and Other Studies on the New Testament’s Christology of Divine Identity")]), _vm._v(" [Grand Rapids: Eerdmans, 2008]) argues an original thesis that in Second Temple Judaism, Wisdom was seen as an intermediary who was intrinsic to God’s divine identity, thus revealing distinctions within God’s identity which then enabled the apostles to construct their high Christology of Jesus as sharing in the divine identity of God.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-119-backlink",
      "id": "footnote-1934-119"
    }
  }, [_vm._v("119")]), _vm._v(". K. Jobes, “Sophia Christology: The Way of Wisdom?,” in "), _c('em', [_vm._v("WWis")]), _vm._v(", 239. However, Bartholomew and O’Dowd ("), _c('em', [_vm._v("Old Testament Wisdom Literature")]), _vm._v(", 245) write, “John’s prologue (Jn. 1:1–18; cf. Heb. 1:1–3) presents the strongest blend of Greek and Hebrew wisdom in the New Testament…. Not only is Genesis 1 evident in John’s prologue, so too is the passage in Proverbs 8:22–31, where we read Woman Wisdom was created by God in the beginning and became an agent in his original creation of the world.” But a careful exegesis of Prov. 8:22–31, as we shall see, does not say Wisdom was “created”—she was given birth—nor that she was an agent in the creation.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-120-backlink",
      "id": "footnote-1934-120"
    }
  }, [_vm._v("120")]), _vm._v(". Jobes, “Sophia Christology,” 242. Jobes notes the following main differences between Wisdom and "), _c('em', [_vm._v("logos")]), _vm._v(": (1) Wisdom was brought into being by God, but the "), _c('em', [_vm._v("logos")]), _vm._v(" was God; (2) Wisdom witnessed the creation, but the "), _c('em', [_vm._v("logos")]), _vm._v(" was the Creator; (3) Wisdom-Sophia in Wisdom of Solomon 7:26 is a reflection of eternal light, but the "), _c('em', [_vm._v("logos")]), _vm._v(" is the light. To these, we add that Wisdom laughs at the time of judgment (1:26), but the "), _c('em', [_vm._v("logos")]), _vm._v(" is the judge (John 5:23–24, 27).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-121-backlink",
      "id": "footnote-1934-121"
    }
  }, [_vm._v("121")]), _vm._v(". Bartholomew and O’Dowd ("), _c('em', [_vm._v("Old Testament Wisdom Literature")]), _vm._v(", 247) provide a contrary voice: “While the Gospels only make implicit use of wisdom to understand Jesus, the Pauline epistles make explicit use of wisdom theology.” Unfortunately, Bartholomew and O’Dowd fail to interact with G. Fee’s previously published essay, “Wisdom Christology in Paul,” in "), _c('em', [_vm._v("WWis")]), _vm._v(", 251–79, where Fee argues against Paul’s reliance on Jewish wisdom traditions for his Christology.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-122-backlink",
      "id": "footnote-1934-122"
    }
  }, [_vm._v("122")]), _vm._v(". Fee, “Wisdom Christology in Paul,” 265. Fee draws the conclusion that “what is most lacking in all of this material [wisdom literature] is a verbal or conceptual linkage between Wisdom and creation of the kind explicitly found in Paul with reference to Christ.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1934-123-backlink",
      "id": "footnote-1934-123"
    }
  }, [_vm._v("123")]), _vm._v(". See R. E. Brown, "), _c('em', [_vm._v("The Gospel According to John: A New Translation with Commentary")]), _vm._v(", AB 29 (Garden City, NY: Doubleday, 1966), cxxii–cxxvii.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d85d198","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Introduction.vue
// module id = 78
// module chunks = 0